"use strict";
/********************************************************************************
  THIS FILE IS GENERATED BY A TOOL -- OBJECTGEN, DO NOT EDIT BY HAND

  HxObjectEnums.ts

  Enum Definitions for all HxCore Enums.
  Generating File: ObjectEnumsJs.tt

  Copyright (c) Microsoft Corporation. All rights reserved.
********************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHxTileActionTypeAsString = exports.HxTileActionType = exports.getHxAccountTypeFromString = exports.getHxAccountTypeAsString = exports.HxAccountType = exports.getHxPatternRangeTypeFromString = exports.getHxPatternRangeTypeAsString = exports.HxPatternRangeType = exports.getHxPatternTypeFromString = exports.getHxPatternTypeAsString = exports.HxPatternType = exports.getHxRelativeOrderTypeFromString = exports.getHxRelativeOrderTypeAsString = exports.HxRelativeOrderType = exports.getHxCalendarTypeFromString = exports.getHxCalendarTypeAsString = exports.HxCalendarType = exports.getHxFirstWeekOfYearTypeFromString = exports.getHxFirstWeekOfYearTypeAsString = exports.HxFirstWeekOfYearType = exports.getHxDayOfWeekTypeFromString = exports.getHxDayOfWeekTypeAsString = exports.HxDayOfWeekType = exports.getHxAddInExtensionLicenseStatusTypeFromString = exports.getHxAddInExtensionLicenseStatusTypeAsString = exports.HxAddInExtensionLicenseStatusType = exports.getHxAddInRequestedCapabilitiesTypeFromString = exports.getHxAddInRequestedCapabilitiesTypeAsString = exports.HxAddInRequestedCapabilitiesType = exports.getHxAddInConsentStateTypeFromString = exports.getHxAddInConsentStateTypeAsString = exports.HxAddInConsentStateType = exports.getHxAddInExtensionTypeFromString = exports.getHxAddInExtensionTypeAsString = exports.HxAddInExtensionType = exports.getHxAddInUserInstallableAppTypeFromString = exports.getHxAddInUserInstallableAppTypeAsString = exports.HxAddInUserInstallableAppType = exports.getHxStorageStateFromString = exports.getHxStorageStateAsString = exports.HxStorageState = exports.getHxActorCompletionNotificationTypeFromString = exports.getHxActorCompletionNotificationTypeAsString = exports.HxActorCompletionNotificationType = exports.getHxActorCompletionStateFromString = exports.getHxActorCompletionStateAsString = exports.HxActorCompletionState = exports.getHxManualSyncModeBehaviorFromString = exports.getHxManualSyncModeBehaviorAsString = exports.HxManualSyncModeBehavior = void 0;
exports.HxNavPaneResizeMode = exports.getHxHxSCapableTypeFromString = exports.getHxHxSCapableTypeAsString = exports.HxHxSCapableType = exports.getHxPushNotificationClassificationTypeFromString = exports.getHxPushNotificationClassificationTypeAsString = exports.HxPushNotificationClassificationType = exports.getHxWatermarkPushNotificationTypeFromString = exports.getHxWatermarkPushNotificationTypeAsString = exports.HxWatermarkPushNotificationType = exports.getHxClassificationTypeFromString = exports.getHxClassificationTypeAsString = exports.HxClassificationType = exports.getHxAccountAuthTypeFromString = exports.getHxAccountAuthTypeAsString = exports.HxAccountAuthType = exports.getHxActionInputTypeFromString = exports.getHxActionInputTypeAsString = exports.HxActionInputType = exports.getHxNewAccountCreateStateFromString = exports.getHxNewAccountCreateStateAsString = exports.HxNewAccountCreateState = exports.getHxSyncDeviceAccountTypeFromString = exports.getHxSyncDeviceAccountTypeAsString = exports.HxSyncDeviceAccountType = exports.getHxUpdateAccountCredentialsErrorTypeFromString = exports.getHxUpdateAccountCredentialsErrorTypeAsString = exports.HxUpdateAccountCredentialsErrorType = exports.getHxProvisionErrorTypeFromString = exports.getHxProvisionErrorTypeAsString = exports.HxProvisionErrorType = exports.getHxAccountProviderTypeFromString = exports.getHxAccountProviderTypeAsString = exports.HxAccountProviderType = exports.getHxTileAssetTypeFromString = exports.getHxTileAssetTypeAsString = exports.HxTileAssetType = exports.getHxMailListFilterTypeFromString = exports.getHxMailListFilterTypeAsString = exports.HxMailListFilterType = exports.getHxHostAppTypeFromString = exports.getHxHostAppTypeAsString = exports.HxHostAppType = exports.getHxAttachmentTypeFromString = exports.getHxAttachmentTypeAsString = exports.HxAttachmentType = exports.getHxDataReplicationObjectStateFromString = exports.getHxDataReplicationObjectStateAsString = exports.HxDataReplicationObjectState = exports.getHxTileActionTypeFromString = void 0;
exports.getHxDownloadStatusTypeFromString = exports.getHxDownloadStatusTypeAsString = exports.HxDownloadStatusType = exports.getHxImportanceTypeFromString = exports.getHxImportanceTypeAsString = exports.HxImportanceType = exports.getHxSslCertificateValidationFromString = exports.getHxSslCertificateValidationAsString = exports.HxSslCertificateValidation = exports.getHxErrorTypeFromString = exports.getHxErrorTypeAsString = exports.HxErrorType = exports.getHxActivityFeedTypeFromString = exports.getHxActivityFeedTypeAsString = exports.HxActivityFeedType = exports.getHxSyncStatusTypeFromString = exports.getHxSyncStatusTypeAsString = exports.HxSyncStatusType = exports.getHxMeetingResponseTypeFromString = exports.getHxMeetingResponseTypeAsString = exports.HxMeetingResponseType = exports.getHxDraftTypeFromString = exports.getHxDraftTypeAsString = exports.HxDraftType = exports.getHxMeetingTypeFromString = exports.getHxMeetingTypeAsString = exports.HxMeetingType = exports.getHxMessageMoveTypeFromString = exports.getHxMessageMoveTypeAsString = exports.HxMessageMoveType = exports.getHxDownloadedStateTypeFromString = exports.getHxDownloadedStateTypeAsString = exports.HxDownloadedStateType = exports.getHxViewTypeFromString = exports.getHxViewTypeAsString = exports.HxViewType = exports.getHxSortPropertyFromString = exports.getHxSortPropertyAsString = exports.HxSortProperty = exports.getHxViewModeFromString = exports.getHxViewModeAsString = exports.HxViewMode = exports.getHxExchangeForestTypeFromString = exports.getHxExchangeForestTypeAsString = exports.HxExchangeForestType = exports.getHxLocalUdaStatusCodeFromString = exports.getHxLocalUdaStatusCodeAsString = exports.HxLocalUdaStatusCode = exports.getHxNavPaneResizeModeFromString = exports.getHxNavPaneResizeModeAsString = void 0;
exports.getHxHandshakeFailureTypeAsString = exports.HxHandshakeFailureType = exports.getHxHandshakePhaseTypeFromString = exports.getHxHandshakePhaseTypeAsString = exports.HxHandshakePhaseType = exports.getHxRefreshViewStatusTypeFromString = exports.getHxRefreshViewStatusTypeAsString = exports.HxRefreshViewStatusType = exports.getHxAccountDataTypeFromString = exports.getHxAccountDataTypeAsString = exports.HxAccountDataType = exports.getHxMailListActionIdFromString = exports.getHxMailListActionIdAsString = exports.HxMailListActionId = exports.getHxStorageAutomationCommandFromString = exports.getHxStorageAutomationCommandAsString = exports.HxStorageAutomationCommand = exports.getHxAccountStateFromString = exports.getHxAccountStateAsString = exports.HxAccountState = exports.getHxConnectionTypeFromString = exports.getHxConnectionTypeAsString = exports.HxConnectionType = exports.getHxSyncFrequencyTypeFromString = exports.getHxSyncFrequencyTypeAsString = exports.HxSyncFrequencyType = exports.getHxOnlineSearchInfoFromString = exports.getHxOnlineSearchInfoAsString = exports.HxOnlineSearchInfo = exports.getHxOnlineSearchStateFromString = exports.getHxOnlineSearchStateAsString = exports.HxOnlineSearchState = exports.getHxMeetingContentTypeFromString = exports.getHxMeetingContentTypeAsString = exports.HxMeetingContentType = exports.getHxRecipientTypeFromString = exports.getHxRecipientTypeAsString = exports.HxRecipientType = exports.getHxSaveDraftStateTypeFromString = exports.getHxSaveDraftStateTypeAsString = exports.HxSaveDraftStateType = exports.getHxSendStateTypeFromString = exports.getHxSendStateTypeAsString = exports.HxSendStateType = exports.getHxSyncQueuePriorityTypeFromString = exports.getHxSyncQueuePriorityTypeAsString = exports.HxSyncQueuePriorityType = exports.getHxDownloadResultTypeFromString = exports.getHxDownloadResultTypeAsString = exports.HxDownloadResultType = void 0;
exports.HxBackgroundImageSetting = exports.getHxBackgroundModeSettingFromString = exports.getHxBackgroundModeSettingAsString = exports.HxBackgroundModeSetting = exports.getHxThemeSettingFromString = exports.getHxThemeSettingAsString = exports.HxThemeSetting = exports.getHxAccentColorSettingFromString = exports.getHxAccentColorSettingAsString = exports.HxAccentColorSetting = exports.getHxInlineStatusTypeFromString = exports.getHxInlineStatusTypeAsString = exports.HxInlineStatusType = exports.getHxSigningAlgorithmTypeFromString = exports.getHxSigningAlgorithmTypeAsString = exports.HxSigningAlgorithmType = exports.getHxEncryptingAlgorithmTypeFromString = exports.getHxEncryptingAlgorithmTypeAsString = exports.HxEncryptingAlgorithmType = exports.getHxAlgorithmNegotiationTypeFromString = exports.getHxAlgorithmNegotiationTypeAsString = exports.HxAlgorithmNegotiationType = exports.getHxSmartReplyStateFromString = exports.getHxSmartReplyStateAsString = exports.HxSmartReplyState = exports.getHxUnpackStatusTypeFromString = exports.getHxUnpackStatusTypeAsString = exports.HxUnpackStatusType = exports.getHxSmimeComposeTypeFromString = exports.getHxSmimeComposeTypeAsString = exports.HxSmimeComposeType = exports.getHxSmimeReplyDraftStateTypeFromString = exports.getHxSmimeReplyDraftStateTypeAsString = exports.HxSmimeReplyDraftStateType = exports.getHxEncryptionCertificateFetchStatusTypeFromString = exports.getHxEncryptionCertificateFetchStatusTypeAsString = exports.HxEncryptionCertificateFetchStatusType = exports.getHxCertificateValidationPurposeTypeFromString = exports.getHxCertificateValidationPurposeTypeAsString = exports.HxCertificateValidationPurposeType = exports.getHxCertificateValidationStatusTypeFromString = exports.getHxCertificateValidationStatusTypeAsString = exports.HxCertificateValidationStatusType = exports.getHxSignatureValidationStatusTypeFromString = exports.getHxSignatureValidationStatusTypeAsString = exports.HxSignatureValidationStatusType = exports.getHxHandshakeTriggerTypeFromString = exports.getHxHandshakeTriggerTypeAsString = exports.HxHandshakeTriggerType = exports.getHxHandshakeFailureTypeFromString = void 0;
exports.getHxDeliverMeetingRequestsTypeFromString = exports.getHxDeliverMeetingRequestsTypeAsString = exports.HxDeliverMeetingRequestsType = exports.getHxCalendarSharingDetailLevelTypeFromString = exports.getHxCalendarSharingDetailLevelTypeAsString = exports.HxCalendarSharingDetailLevelType = exports.getHxNotificationSettingsDefaultVersionFromString = exports.getHxNotificationSettingsDefaultVersionAsString = exports.HxNotificationSettingsDefaultVersion = exports.getHxSharingActionImportanceFromString = exports.getHxSharingActionImportanceAsString = exports.HxSharingActionImportance = exports.getHxSharingActionTypeFromString = exports.getHxSharingActionTypeAsString = exports.HxSharingActionType = exports.getHxSharingActionFromString = exports.getHxSharingActionAsString = exports.HxSharingAction = exports.getHxDraftDirtyStateFlagsFromString = exports.getHxDraftDirtyStateFlagsAsString = exports.HxDraftDirtyStateFlags = exports.getHxOneRMSurfaceAreaFromString = exports.getHxOneRMSurfaceAreaAsString = exports.HxOneRMSurfaceArea = exports.getHxMarkAsReadSettingFromString = exports.getHxMarkAsReadSettingAsString = exports.HxMarkAsReadSetting = exports.getHxConversationClassificationTypeFromString = exports.getHxConversationClassificationTypeAsString = exports.HxConversationClassificationType = exports.getHxMailWindowDeleteActionTypeFromString = exports.getHxMailWindowDeleteActionTypeAsString = exports.HxMailWindowDeleteActionType = exports.getHxNotificationGroupingStateFromString = exports.getHxNotificationGroupingStateAsString = exports.HxNotificationGroupingState = exports.getHxNullableBoolTypeFromString = exports.getHxNullableBoolTypeAsString = exports.HxNullableBoolType = exports.getHxApplyAllAccountsLocalSettingsMapFromString = exports.getHxApplyAllAccountsLocalSettingsMapAsString = exports.HxApplyAllAccountsLocalSettingsMap = exports.getHxResizeImageToSizeSettingFromString = exports.getHxResizeImageToSizeSettingAsString = exports.HxResizeImageToSizeSetting = exports.getHxBackgroundImageDarknessValueFromString = exports.getHxBackgroundImageDarknessValueAsString = exports.HxBackgroundImageDarknessValue = exports.getHxBackgroundImageSettingFromString = exports.getHxBackgroundImageSettingAsString = void 0;
exports.getHxHandshakeCancelStateAsString = exports.HxHandshakeCancelState = exports.getHxDensitySettingFromString = exports.getHxDensitySettingAsString = exports.HxDensitySetting = exports.getHxFavoriteTypeFromString = exports.getHxFavoriteTypeAsString = exports.HxFavoriteType = exports.getHxO365SubscriptionStatusTypeFromString = exports.getHxO365SubscriptionStatusTypeAsString = exports.HxO365SubscriptionStatusType = exports.getHxStorageMaintenanceStateFromString = exports.getHxStorageMaintenanceStateAsString = exports.HxStorageMaintenanceState = exports.getHxSmimeComposeErrorTypeFromString = exports.getHxSmimeComposeErrorTypeAsString = exports.HxSmimeComposeErrorType = exports.getHxDeleteOrEmptyFolderActionErrorTypeFromString = exports.getHxDeleteOrEmptyFolderActionErrorTypeAsString = exports.HxDeleteOrEmptyFolderActionErrorType = exports.getHxCreateFolderActionErrorTypeFromString = exports.getHxCreateFolderActionErrorTypeAsString = exports.HxCreateFolderActionErrorType = exports.getHxMimeTypeFromString = exports.getHxMimeTypeAsString = exports.HxMimeType = exports.getHxMimeEncodingFromString = exports.getHxMimeEncodingAsString = exports.HxMimeEncoding = exports.getHxClientExtensionNotificationMessageTypeFromString = exports.getHxClientExtensionNotificationMessageTypeAsString = exports.HxClientExtensionNotificationMessageType = exports.getHxMeetingRequestTypeFromString = exports.getHxMeetingRequestTypeAsString = exports.HxMeetingRequestType = exports.getHxScheduleStatusTypeFromString = exports.getHxScheduleStatusTypeAsString = exports.HxScheduleStatusType = exports.getHxMoveToPreselectedOptionFromString = exports.getHxMoveToPreselectedOptionAsString = exports.HxMoveToPreselectedOption = exports.getHxUnistoreNotificationSourceFromString = exports.getHxUnistoreNotificationSourceAsString = exports.HxUnistoreNotificationSource = exports.getHxTruncatedStateTypeFromString = exports.getHxTruncatedStateTypeAsString = exports.HxTruncatedStateType = exports.getHxMailboxDeprovisionStatusTypeFromString = exports.getHxMailboxDeprovisionStatusTypeAsString = exports.HxMailboxDeprovisionStatusType = void 0;
exports.HxCdnFileDownloadReactionType = exports.getHxCdnFileDownloadBehaviorTypeFromString = exports.getHxCdnFileDownloadBehaviorTypeAsString = exports.HxCdnFileDownloadBehaviorType = exports.getHxFetchCdnFilesErrorTypeFromString = exports.getHxFetchCdnFilesErrorTypeAsString = exports.HxFetchCdnFilesErrorType = exports.getHxMobilePresenceStatusFromString = exports.getHxMobilePresenceStatusAsString = exports.HxMobilePresenceStatus = exports.getHxAccountCreationFailureTypeFromString = exports.getHxAccountCreationFailureTypeAsString = exports.HxAccountCreationFailureType = exports.getHxSyncRequestOptionsTypeFromString = exports.getHxSyncRequestOptionsTypeAsString = exports.HxSyncRequestOptionsType = exports.getHxRemoteMailboxSyncActionableErrorTypeFromString = exports.getHxRemoteMailboxSyncActionableErrorTypeAsString = exports.HxRemoteMailboxSyncActionableErrorType = exports.getHxRemoteMailboxSyncStatusTypeFromString = exports.getHxRemoteMailboxSyncStatusTypeAsString = exports.HxRemoteMailboxSyncStatusType = exports.getHxSharedAccountTypeFromString = exports.getHxSharedAccountTypeAsString = exports.HxSharedAccountType = exports.getHxSuggestedReplyTypeFromString = exports.getHxSuggestedReplyTypeAsString = exports.HxSuggestedReplyType = exports.getHxDelegateFolderPermissionLevelTypeFromString = exports.getHxDelegateFolderPermissionLevelTypeAsString = exports.HxDelegateFolderPermissionLevelType = exports.getHxLocationIdTypeFromString = exports.getHxLocationIdTypeAsString = exports.HxLocationIdType = exports.getHxPresenceAvailabilityFromString = exports.getHxPresenceAvailabilityAsString = exports.HxPresenceAvailability = exports.getHxCloudCachePromptInteractionTypeFromString = exports.getHxCloudCachePromptInteractionTypeAsString = exports.HxCloudCachePromptInteractionType = exports.getHxToastsTypeFromString = exports.getHxToastsTypeAsString = exports.HxToastsType = exports.getHxLocationEntityTypeFromString = exports.getHxLocationEntityTypeAsString = exports.HxLocationEntityType = exports.getHxCreateOrMarkAsScheduledFolderActionErrorTypeFromString = exports.getHxCreateOrMarkAsScheduledFolderActionErrorTypeAsString = exports.HxCreateOrMarkAsScheduledFolderActionErrorType = exports.getHxHandshakeCancelStateFromString = void 0;
exports.getHxSearchInstrumentationTypeFromString = exports.getHxSearchInstrumentationTypeAsString = exports.HxSearchInstrumentationType = exports.getHxSearchInstrumentationEventTypeFromString = exports.getHxSearchInstrumentationEventTypeAsString = exports.HxSearchInstrumentationEventType = exports.getHxSearchInstrumentationFailureReasonFromString = exports.getHxSearchInstrumentationFailureReasonAsString = exports.HxSearchInstrumentationFailureReason = exports.getHxSearchStateFromString = exports.getHxSearchStateAsString = exports.HxSearchState = exports.getHxMailSearchInteractionTypeFromString = exports.getHxMailSearchInteractionTypeAsString = exports.HxMailSearchInteractionType = exports.getHxAadLogoThemeFromString = exports.getHxAadLogoThemeAsString = exports.HxAadLogoTheme = exports.getHxPolicyEvaluationResultFromString = exports.getHxPolicyEvaluationResultAsString = exports.HxPolicyEvaluationResult = exports.getHxDataProtectionTypeFromString = exports.getHxDataProtectionTypeAsString = exports.HxDataProtectionType = exports.getHxProtectionStatusFromString = exports.getHxProtectionStatusAsString = exports.HxProtectionStatus = exports.getHxImapFolderAttributesFromString = exports.getHxImapFolderAttributesAsString = exports.HxImapFolderAttributes = exports.getHxModuleIdentifierFromString = exports.getHxModuleIdentifierAsString = exports.HxModuleIdentifier = exports.getHxPermissionReadAccessTypeFromString = exports.getHxPermissionReadAccessTypeAsString = exports.HxPermissionReadAccessType = exports.getHxPermissionActionTypeFromString = exports.getHxPermissionActionTypeAsString = exports.HxPermissionActionType = exports.getHxAddInFailureTypeFromString = exports.getHxAddInFailureTypeAsString = exports.HxAddInFailureType = exports.getHxToDoTaskImportanceFromString = exports.getHxToDoTaskImportanceAsString = exports.HxToDoTaskImportance = exports.getHxToDoTaskStatusFromString = exports.getHxToDoTaskStatusAsString = exports.HxToDoTaskStatus = exports.getHxCdnFileDownloadReactionTypeFromString = exports.getHxCdnFileDownloadReactionTypeAsString = void 0;
exports.getHxAppointmentPropertyIdAsString = exports.HxAppointmentPropertyId = exports.getHxAppointmentFreeBusyStateFromString = exports.getHxAppointmentFreeBusyStateAsString = exports.HxAppointmentFreeBusyState = exports.getHxAppointmentSensitivityFromString = exports.getHxAppointmentSensitivityAsString = exports.HxAppointmentSensitivity = exports.getHxAppointmentRepeatItemTypeFromString = exports.getHxAppointmentRepeatItemTypeAsString = exports.HxAppointmentRepeatItemType = exports.getHxTeachingTriggerTypeFromString = exports.getHxTeachingTriggerTypeAsString = exports.HxTeachingTriggerType = exports.getHxTeachingCalloutTypeFromString = exports.getHxTeachingCalloutTypeAsString = exports.HxTeachingCalloutType = exports.getHxComposeContextTypeFromString = exports.getHxComposeContextTypeAsString = exports.HxComposeContextType = exports.getHxSearchResultTypeFromString = exports.getHxSearchResultTypeAsString = exports.HxSearchResultType = exports.getHxCalendarSearchSortDirectionFromString = exports.getHxCalendarSearchSortDirectionAsString = exports.HxCalendarSearchSortDirection = exports.getHxSearchScenarioFromString = exports.getHxSearchScenarioAsString = exports.HxSearchScenario = exports.getHxPeopleSearchResultsTypeFromString = exports.getHxPeopleSearchResultsTypeAsString = exports.HxPeopleSearchResultsType = exports.getHxSearchInstrumentationScenarioFromString = exports.getHxSearchInstrumentationScenarioAsString = exports.HxSearchInstrumentationScenario = exports.getHxSearchSuggestionTypeFromString = exports.getHxSearchSuggestionTypeAsString = exports.HxSearchSuggestionType = exports.getHxSearchScopeFromString = exports.getHxSearchScopeAsString = exports.HxSearchScope = exports.getHxSearchResultClearingBehaviorFromString = exports.getHxSearchResultClearingBehaviorAsString = exports.HxSearchResultClearingBehavior = exports.getHxSearchFeedbackTypeFromString = exports.getHxSearchFeedbackTypeAsString = exports.HxSearchFeedbackType = exports.getHxSearchProviderTypeFromString = exports.getHxSearchProviderTypeAsString = exports.HxSearchProviderType = void 0;
exports.HxSubscriptionStatus = exports.getHxCalendarCatalogItemTypeFromString = exports.getHxCalendarCatalogItemTypeAsString = exports.HxCalendarCatalogItemType = exports.getHxTailoredTypeFromString = exports.getHxTailoredTypeAsString = exports.HxTailoredType = exports.getHxWeatherDegreeTypeFromString = exports.getHxWeatherDegreeTypeAsString = exports.HxWeatherDegreeType = exports.getHxAppointmentBodyFormattingFromString = exports.getHxAppointmentBodyFormattingAsString = exports.HxAppointmentBodyFormatting = exports.getHxCalendarPropertyIdFromString = exports.getHxCalendarPropertyIdAsString = exports.HxCalendarPropertyId = exports.getHxCalendarViewStateTypeFromString = exports.getHxCalendarViewStateTypeAsString = exports.HxCalendarViewStateType = exports.getHxCalendarReadAccessTypeFromString = exports.getHxCalendarReadAccessTypeAsString = exports.HxCalendarReadAccessType = exports.getHxRepeatExpansionTypeFromString = exports.getHxRepeatExpansionTypeAsString = exports.HxRepeatExpansionType = exports.getHxNetworkStatusCodeTypeFromString = exports.getHxNetworkStatusCodeTypeAsString = exports.HxNetworkStatusCodeType = exports.getHxFreeBusyViewTypeFromString = exports.getHxFreeBusyViewTypeAsString = exports.HxFreeBusyViewType = exports.getHxCategoryColorTypeFromString = exports.getHxCategoryColorTypeAsString = exports.HxCategoryColorType = exports.getHxCalendarColorOptionsFromString = exports.getHxCalendarColorOptionsAsString = exports.HxCalendarColorOptions = exports.getHxLegacyCalendarColorTypeFromString = exports.getHxLegacyCalendarColorTypeAsString = exports.HxLegacyCalendarColorType = exports.getHxAvailabilityDataResponseCodeTypeFromString = exports.getHxAvailabilityDataResponseCodeTypeAsString = exports.HxAvailabilityDataResponseCodeType = exports.getHxAttendeeTypeFromString = exports.getHxAttendeeTypeAsString = exports.HxAttendeeType = exports.getHxAppointmentSummaryCardViewFromString = exports.getHxAppointmentSummaryCardViewAsString = exports.HxAppointmentSummaryCardView = exports.getHxAppointmentPropertyIdFromString = void 0;
exports.getHxFetchCalendarStatusTypeFromString = exports.getHxFetchCalendarStatusTypeAsString = exports.HxFetchCalendarStatusType = exports.getHxCalendarSourceTypeFromString = exports.getHxCalendarSourceTypeAsString = exports.HxCalendarSourceType = exports.getHxCreateCalendarItemStateTypeFromString = exports.getHxCreateCalendarItemStateTypeAsString = exports.HxCreateCalendarItemStateType = exports.getHxSortDirectionFromString = exports.getHxSortDirectionAsString = exports.HxSortDirection = exports.getHxOnlineMeetingProviderTypeFromString = exports.getHxOnlineMeetingProviderTypeAsString = exports.HxOnlineMeetingProviderType = exports.getHxCalendarReminderTypeFromString = exports.getHxCalendarReminderTypeAsString = exports.HxCalendarReminderType = exports.getHxAppointmentAttendeeStatusFromString = exports.getHxAppointmentAttendeeStatusAsString = exports.HxAppointmentAttendeeStatus = exports.getHxAppointmentAttendeeRoleFromString = exports.getHxAppointmentAttendeeRoleAsString = exports.HxAppointmentAttendeeRole = exports.getHxMeetingStateTypeFromString = exports.getHxMeetingStateTypeAsString = exports.HxMeetingStateType = exports.getHxServiceRequestStatusTypeFromString = exports.getHxServiceRequestStatusTypeAsString = exports.HxServiceRequestStatusType = exports.getHxRefreshCalendarStatusTypeFromString = exports.getHxRefreshCalendarStatusTypeAsString = exports.HxRefreshCalendarStatusType = exports.getHxLocationSourceTypeFromString = exports.getHxLocationSourceTypeAsString = exports.HxLocationSourceType = exports.getHxLocationSuggestionsSourceFromString = exports.getHxLocationSuggestionsSourceAsString = exports.HxLocationSuggestionsSource = exports.getHxMeetingTimeSuggestionsRangeFromString = exports.getHxMeetingTimeSuggestionsRangeAsString = exports.HxMeetingTimeSuggestionsRange = exports.getHxEmptySuggestionsReasonTypeFromString = exports.getHxEmptySuggestionsReasonTypeAsString = exports.HxEmptySuggestionsReasonType = exports.getHxCalendarFolderTypeFromString = exports.getHxCalendarFolderTypeAsString = exports.HxCalendarFolderType = exports.getHxSubscriptionStatusFromString = exports.getHxSubscriptionStatusAsString = void 0;
exports.getHxNetworkStatusAsString = exports.HxNetworkStatus = exports.getHxActivatedByTypeFromString = exports.getHxActivatedByTypeAsString = exports.HxActivatedByType = exports.getHxRuleActionTypeFromString = exports.getHxRuleActionTypeAsString = exports.HxRuleActionType = exports.getHxRuleConditionTypeFromString = exports.getHxRuleConditionTypeAsString = exports.HxRuleConditionType = exports.getHxContactSortPropertyFromString = exports.getHxContactSortPropertyAsString = exports.HxContactSortProperty = exports.getHxEmailAddressTypeFromString = exports.getHxEmailAddressTypeAsString = exports.HxEmailAddressType = exports.getHxContactPhotoKindFromString = exports.getHxContactPhotoKindAsString = exports.HxContactPhotoKind = exports.getHxContactImAddressKindFromString = exports.getHxContactImAddressKindAsString = exports.HxContactImAddressKind = exports.getHxContactUnistoreNotificationTypeFromString = exports.getHxContactUnistoreNotificationTypeAsString = exports.HxContactUnistoreNotificationType = exports.getHxContactUrlTypeFromString = exports.getHxContactUrlTypeAsString = exports.HxContactUrlType = exports.getHxContactListSyncStatusFromString = exports.getHxContactListSyncStatusAsString = exports.HxContactListSyncStatus = exports.getHxContactSignificantOtherKindFromString = exports.getHxContactSignificantOtherKindAsString = exports.HxContactSignificantOtherKind = exports.getHxContactPhoneKindFromString = exports.getHxContactPhoneKindAsString = exports.HxContactPhoneKind = exports.getHxContactDateKindFromString = exports.getHxContactDateKindAsString = exports.HxContactDateKind = exports.getHxContactEmailKindFromString = exports.getHxContactEmailKindAsString = exports.HxContactEmailKind = exports.getHxContactAddressKindFromString = exports.getHxContactAddressKindAsString = exports.HxContactAddressKind = exports.getHxSpeedyMeetingClippingTypeFromString = exports.getHxSpeedyMeetingClippingTypeAsString = exports.HxSpeedyMeetingClippingType = void 0;
exports.HxAllowBluetoothType = exports.getHxMipLabelEventTypeFromString = exports.getHxMipLabelEventTypeAsString = exports.HxMipLabelEventType = exports.getHxMipLabelChangeActionSourceTypeFromString = exports.getHxMipLabelChangeActionSourceTypeAsString = exports.HxMipLabelChangeActionSourceType = exports.getHxMipLabelAuditOperationTypeFromString = exports.getHxMipLabelAuditOperationTypeAsString = exports.HxMipLabelAuditOperationType = exports.getHxAddInAccessTokenTypeFromString = exports.getHxAddInAccessTokenTypeAsString = exports.HxAddInAccessTokenType = exports.getHxAllowGuestActionFromString = exports.getHxAllowGuestActionAsString = exports.HxAllowGuestAction = exports.getHxCertificateUsageFromString = exports.getHxCertificateUsageAsString = exports.HxCertificateUsage = exports.getHxEndTimeModeFromString = exports.getHxEndTimeModeAsString = exports.HxEndTimeMode = exports.getHxMockActorFailureTypeFromString = exports.getHxMockActorFailureTypeAsString = exports.HxMockActorFailureType = exports.getHxMigrationStateTypeFromString = exports.getHxMigrationStateTypeAsString = exports.HxMigrationStateType = exports.getHxStatusCodeTypeFromString = exports.getHxStatusCodeTypeAsString = exports.HxStatusCodeType = exports.getHxPolicyComplianceStateFromString = exports.getHxPolicyComplianceStateAsString = exports.HxPolicyComplianceState = exports.getHxGroupMemberTypeFromString = exports.getHxGroupMemberTypeAsString = exports.HxGroupMemberType = exports.getHxGroupProductTypeFromString = exports.getHxGroupProductTypeAsString = exports.HxGroupProductType = exports.getHxGroupSubscriptionTypeFromString = exports.getHxGroupSubscriptionTypeAsString = exports.HxGroupSubscriptionType = exports.getHxGroupAccessTypeFromString = exports.getHxGroupAccessTypeAsString = exports.HxGroupAccessType = exports.getHxBatteryStatusFromString = exports.getHxBatteryStatusAsString = exports.HxBatteryStatus = exports.getHxNetworkStatusFromString = void 0;
exports.getHxTimeIncrementTypeFromString = exports.getHxTimeIncrementTypeAsString = exports.HxTimeIncrementType = exports.getHxLocalEventsEnabledTypeFromString = exports.getHxLocalEventsEnabledTypeAsString = exports.HxLocalEventsEnabledType = exports.getHxDaysOfWeekTypeFromString = exports.getHxDaysOfWeekTypeAsString = exports.HxDaysOfWeekType = exports.getHxAfterMoveOrDeleteBehaviorTypeFromString = exports.getHxAfterMoveOrDeleteBehaviorTypeAsString = exports.HxAfterMoveOrDeleteBehaviorType = exports.getHxConversationSortOrderTypeFromString = exports.getHxConversationSortOrderTypeAsString = exports.HxConversationSortOrderType = exports.getHxFontFlagsTypeFromString = exports.getHxFontFlagsTypeAsString = exports.HxFontFlagsType = exports.getHxNewItemNotificationTypeFromString = exports.getHxNewItemNotificationTypeAsString = exports.HxNewItemNotificationType = exports.getHxSslSchemeFromString = exports.getHxSslSchemeAsString = exports.HxSslScheme = exports.getHxOutlookCloudSettingValueSourceTypeFromString = exports.getHxOutlookCloudSettingValueSourceTypeAsString = exports.HxOutlookCloudSettingValueSourceType = exports.getHxCalendarIconAssetFileTypeFromString = exports.getHxCalendarIconAssetFileTypeAsString = exports.HxCalendarIconAssetFileType = exports.getHxCredentialsValidationStatusFromString = exports.getHxCredentialsValidationStatusAsString = exports.HxCredentialsValidationStatus = exports.getHxCertificateSourceTypeFromString = exports.getHxCertificateSourceTypeAsString = exports.HxCertificateSourceType = exports.getHxCertificateDefaultFlagsTypeFromString = exports.getHxCertificateDefaultFlagsTypeAsString = exports.HxCertificateDefaultFlagsType = exports.getHxCloudEnvironmentTypeFromString = exports.getHxCloudEnvironmentTypeAsString = exports.HxCloudEnvironmentType = exports.getHxRestEndpointTypeFromString = exports.getHxRestEndpointTypeAsString = exports.HxRestEndpointType = exports.getHxSmimeCertValidationTypeFromString = exports.getHxSmimeCertValidationTypeAsString = exports.HxSmimeCertValidationType = exports.getHxAllowBluetoothTypeFromString = exports.getHxAllowBluetoothTypeAsString = void 0;
exports.getHxExternalAudienceTypeFromString = exports.getHxExternalAudienceTypeAsString = exports.HxExternalAudienceType = exports.getHxAutoReplyStateTypeFromString = exports.getHxAutoReplyStateTypeAsString = exports.HxAutoReplyStateType = exports.getHxEmailComposeModeTypeFromString = exports.getHxEmailComposeModeTypeAsString = exports.HxEmailComposeModeType = exports.getHxMailFormatTypeFromString = exports.getHxMailFormatTypeAsString = exports.HxMailFormatType = exports.getHxReadReceiptResponseTypeFromString = exports.getHxReadReceiptResponseTypeAsString = exports.HxReadReceiptResponseType = exports.getHxPreviewMarkAsReadBehaviorTypeFromString = exports.getHxPreviewMarkAsReadBehaviorTypeAsString = exports.HxPreviewMarkAsReadBehaviorType = void 0;
/*-------------------------------------------------------------------------------
  HxManualSyncModeBehavior
-------------------------------------------------------------------------------*/
var HxManualSyncModeBehavior;
(function (HxManualSyncModeBehavior) {
    HxManualSyncModeBehavior[HxManualSyncModeBehavior["Fail"] = 0] = "Fail";
    HxManualSyncModeBehavior[HxManualSyncModeBehavior["ForceConnection"] = 1] = "ForceConnection";
})(HxManualSyncModeBehavior = exports.HxManualSyncModeBehavior || (exports.HxManualSyncModeBehavior = {}));
function getHxManualSyncModeBehaviorAsString(value) {
    return HxManualSyncModeBehavior[value];
}
exports.getHxManualSyncModeBehaviorAsString = getHxManualSyncModeBehaviorAsString;
function getHxManualSyncModeBehaviorFromString(value) {
    return HxManualSyncModeBehavior[value];
}
exports.getHxManualSyncModeBehaviorFromString = getHxManualSyncModeBehaviorFromString;
/*-------------------------------------------------------------------------------
  HxActorCompletionState
-------------------------------------------------------------------------------*/
var HxActorCompletionState;
(function (HxActorCompletionState) {
    HxActorCompletionState[HxActorCompletionState["Pending"] = 0] = "Pending";
    HxActorCompletionState[HxActorCompletionState["Succeeded"] = 1] = "Succeeded";
    HxActorCompletionState[HxActorCompletionState["Canceled"] = 2] = "Canceled";
    HxActorCompletionState[HxActorCompletionState["Failed"] = 3] = "Failed";
    HxActorCompletionState[HxActorCompletionState["Aborted"] = 4] = "Aborted";
    HxActorCompletionState[HxActorCompletionState["UserError"] = 5] = "UserError";
    HxActorCompletionState[HxActorCompletionState["PreconditionsViolated"] = 6] = "PreconditionsViolated";
})(HxActorCompletionState = exports.HxActorCompletionState || (exports.HxActorCompletionState = {}));
function getHxActorCompletionStateAsString(value) {
    return HxActorCompletionState[value];
}
exports.getHxActorCompletionStateAsString = getHxActorCompletionStateAsString;
function getHxActorCompletionStateFromString(value) {
    return HxActorCompletionState[value];
}
exports.getHxActorCompletionStateFromString = getHxActorCompletionStateFromString;
/*-------------------------------------------------------------------------------
  HxActorCompletionNotificationType
-------------------------------------------------------------------------------*/
var HxActorCompletionNotificationType;
(function (HxActorCompletionNotificationType) {
    HxActorCompletionNotificationType[HxActorCompletionNotificationType["Completed"] = 0] = "Completed";
    HxActorCompletionNotificationType[HxActorCompletionNotificationType["CompletedOnStorage"] = 1] = "CompletedOnStorage";
})(HxActorCompletionNotificationType = exports.HxActorCompletionNotificationType || (exports.HxActorCompletionNotificationType = {}));
function getHxActorCompletionNotificationTypeAsString(value) {
    return HxActorCompletionNotificationType[value];
}
exports.getHxActorCompletionNotificationTypeAsString = getHxActorCompletionNotificationTypeAsString;
function getHxActorCompletionNotificationTypeFromString(value) {
    return HxActorCompletionNotificationType[value];
}
exports.getHxActorCompletionNotificationTypeFromString = getHxActorCompletionNotificationTypeFromString;
/*-------------------------------------------------------------------------------
  HxStorageState
-------------------------------------------------------------------------------*/
var HxStorageState;
(function (HxStorageState) {
    HxStorageState[HxStorageState["Initializing"] = 0] = "Initializing";
    HxStorageState[HxStorageState["Migrating"] = 1] = "Migrating";
    HxStorageState[HxStorageState["Migration_Complete"] = 2] = "Migration_Complete";
    HxStorageState[HxStorageState["New_Store"] = 3] = "New_Store";
    HxStorageState[HxStorageState["Store_Boot_Complete"] = 4] = "Store_Boot_Complete";
})(HxStorageState = exports.HxStorageState || (exports.HxStorageState = {}));
function getHxStorageStateAsString(value) {
    return HxStorageState[value];
}
exports.getHxStorageStateAsString = getHxStorageStateAsString;
function getHxStorageStateFromString(value) {
    return HxStorageState[value];
}
exports.getHxStorageStateFromString = getHxStorageStateFromString;
/*-------------------------------------------------------------------------------
  HxAddInUserInstallableAppType
-------------------------------------------------------------------------------*/
var HxAddInUserInstallableAppType;
(function (HxAddInUserInstallableAppType) {
    HxAddInUserInstallableAppType[HxAddInUserInstallableAppType["None"] = 0] = "None";
    HxAddInUserInstallableAppType[HxAddInUserInstallableAppType["MyMarketplaceApps"] = 1] = "MyMarketplaceApps";
    HxAddInUserInstallableAppType[HxAddInUserInstallableAppType["MyCustomApps"] = 2] = "MyCustomApps";
    HxAddInUserInstallableAppType[HxAddInUserInstallableAppType["MyReadWriteMailboxApps"] = 3] = "MyReadWriteMailboxApps";
})(HxAddInUserInstallableAppType = exports.HxAddInUserInstallableAppType || (exports.HxAddInUserInstallableAppType = {}));
function getHxAddInUserInstallableAppTypeAsString(value) {
    return HxAddInUserInstallableAppType[value];
}
exports.getHxAddInUserInstallableAppTypeAsString = getHxAddInUserInstallableAppTypeAsString;
function getHxAddInUserInstallableAppTypeFromString(value) {
    return HxAddInUserInstallableAppType[value];
}
exports.getHxAddInUserInstallableAppTypeFromString = getHxAddInUserInstallableAppTypeFromString;
/*-------------------------------------------------------------------------------
  HxAddInExtensionType
-------------------------------------------------------------------------------*/
var HxAddInExtensionType;
(function (HxAddInExtensionType) {
    HxAddInExtensionType[HxAddInExtensionType["Unknown"] = 6] = "Unknown";
    HxAddInExtensionType[HxAddInExtensionType["Default"] = 0] = "Default";
    HxAddInExtensionType[HxAddInExtensionType["Private"] = 1] = "Private";
    HxAddInExtensionType[HxAddInExtensionType["MarketPlace"] = 2] = "MarketPlace";
    HxAddInExtensionType[HxAddInExtensionType["PreInstalled"] = 3] = "PreInstalled";
    HxAddInExtensionType[HxAddInExtensionType["PrivateCatalog"] = 4] = "PrivateCatalog";
    HxAddInExtensionType[HxAddInExtensionType["MarketplacePrivateCatalog"] = 5] = "MarketplacePrivateCatalog";
})(HxAddInExtensionType = exports.HxAddInExtensionType || (exports.HxAddInExtensionType = {}));
function getHxAddInExtensionTypeAsString(value) {
    return HxAddInExtensionType[value];
}
exports.getHxAddInExtensionTypeAsString = getHxAddInExtensionTypeAsString;
function getHxAddInExtensionTypeFromString(value) {
    return HxAddInExtensionType[value];
}
exports.getHxAddInExtensionTypeFromString = getHxAddInExtensionTypeFromString;
/*-------------------------------------------------------------------------------
  HxAddInConsentStateType
-------------------------------------------------------------------------------*/
var HxAddInConsentStateType;
(function (HxAddInConsentStateType) {
    HxAddInConsentStateType[HxAddInConsentStateType["Unknown"] = 3] = "Unknown";
    HxAddInConsentStateType[HxAddInConsentStateType["NotResponded"] = 0] = "NotResponded";
    HxAddInConsentStateType[HxAddInConsentStateType["NotConsented"] = 1] = "NotConsented";
    HxAddInConsentStateType[HxAddInConsentStateType["Consented"] = 2] = "Consented";
})(HxAddInConsentStateType = exports.HxAddInConsentStateType || (exports.HxAddInConsentStateType = {}));
function getHxAddInConsentStateTypeAsString(value) {
    return HxAddInConsentStateType[value];
}
exports.getHxAddInConsentStateTypeAsString = getHxAddInConsentStateTypeAsString;
function getHxAddInConsentStateTypeFromString(value) {
    return HxAddInConsentStateType[value];
}
exports.getHxAddInConsentStateTypeFromString = getHxAddInConsentStateTypeFromString;
/*-------------------------------------------------------------------------------
  HxAddInRequestedCapabilitiesType
-------------------------------------------------------------------------------*/
var HxAddInRequestedCapabilitiesType;
(function (HxAddInRequestedCapabilitiesType) {
    HxAddInRequestedCapabilitiesType[HxAddInRequestedCapabilitiesType["Unknown"] = 4] = "Unknown";
    HxAddInRequestedCapabilitiesType[HxAddInRequestedCapabilitiesType["Restricted"] = 0] = "Restricted";
    HxAddInRequestedCapabilitiesType[HxAddInRequestedCapabilitiesType["ReadItem"] = 1] = "ReadItem";
    HxAddInRequestedCapabilitiesType[HxAddInRequestedCapabilitiesType["ReadWriteMailbox"] = 2] = "ReadWriteMailbox";
    HxAddInRequestedCapabilitiesType[HxAddInRequestedCapabilitiesType["ReadWriteItem"] = 3] = "ReadWriteItem";
})(HxAddInRequestedCapabilitiesType = exports.HxAddInRequestedCapabilitiesType || (exports.HxAddInRequestedCapabilitiesType = {}));
function getHxAddInRequestedCapabilitiesTypeAsString(value) {
    return HxAddInRequestedCapabilitiesType[value];
}
exports.getHxAddInRequestedCapabilitiesTypeAsString = getHxAddInRequestedCapabilitiesTypeAsString;
function getHxAddInRequestedCapabilitiesTypeFromString(value) {
    return HxAddInRequestedCapabilitiesType[value];
}
exports.getHxAddInRequestedCapabilitiesTypeFromString = getHxAddInRequestedCapabilitiesTypeFromString;
/*-------------------------------------------------------------------------------
  HxAddInExtensionLicenseStatusType
-------------------------------------------------------------------------------*/
var HxAddInExtensionLicenseStatusType;
(function (HxAddInExtensionLicenseStatusType) {
    HxAddInExtensionLicenseStatusType[HxAddInExtensionLicenseStatusType["Unknown"] = 4] = "Unknown";
    HxAddInExtensionLicenseStatusType[HxAddInExtensionLicenseStatusType["Free"] = 0] = "Free";
    HxAddInExtensionLicenseStatusType[HxAddInExtensionLicenseStatusType["Owned"] = 1] = "Owned";
    HxAddInExtensionLicenseStatusType[HxAddInExtensionLicenseStatusType["InTrial"] = 2] = "InTrial";
    HxAddInExtensionLicenseStatusType[HxAddInExtensionLicenseStatusType["TrialExpired"] = 3] = "TrialExpired";
})(HxAddInExtensionLicenseStatusType = exports.HxAddInExtensionLicenseStatusType || (exports.HxAddInExtensionLicenseStatusType = {}));
function getHxAddInExtensionLicenseStatusTypeAsString(value) {
    return HxAddInExtensionLicenseStatusType[value];
}
exports.getHxAddInExtensionLicenseStatusTypeAsString = getHxAddInExtensionLicenseStatusTypeAsString;
function getHxAddInExtensionLicenseStatusTypeFromString(value) {
    return HxAddInExtensionLicenseStatusType[value];
}
exports.getHxAddInExtensionLicenseStatusTypeFromString = getHxAddInExtensionLicenseStatusTypeFromString;
/*-------------------------------------------------------------------------------
  HxDayOfWeekType
-------------------------------------------------------------------------------*/
var HxDayOfWeekType;
(function (HxDayOfWeekType) {
    HxDayOfWeekType[HxDayOfWeekType["Sunday"] = 0] = "Sunday";
    HxDayOfWeekType[HxDayOfWeekType["Monday"] = 1] = "Monday";
    HxDayOfWeekType[HxDayOfWeekType["Tuesday"] = 2] = "Tuesday";
    HxDayOfWeekType[HxDayOfWeekType["Wednesday"] = 3] = "Wednesday";
    HxDayOfWeekType[HxDayOfWeekType["Thursday"] = 4] = "Thursday";
    HxDayOfWeekType[HxDayOfWeekType["Friday"] = 5] = "Friday";
    HxDayOfWeekType[HxDayOfWeekType["Saturday"] = 6] = "Saturday";
})(HxDayOfWeekType = exports.HxDayOfWeekType || (exports.HxDayOfWeekType = {}));
function getHxDayOfWeekTypeAsString(value) {
    return HxDayOfWeekType[value];
}
exports.getHxDayOfWeekTypeAsString = getHxDayOfWeekTypeAsString;
function getHxDayOfWeekTypeFromString(value) {
    return HxDayOfWeekType[value];
}
exports.getHxDayOfWeekTypeFromString = getHxDayOfWeekTypeFromString;
/*-------------------------------------------------------------------------------
  HxFirstWeekOfYearType
-------------------------------------------------------------------------------*/
var HxFirstWeekOfYearType;
(function (HxFirstWeekOfYearType) {
    HxFirstWeekOfYearType[HxFirstWeekOfYearType["LegacyNotSet"] = 0] = "LegacyNotSet";
    HxFirstWeekOfYearType[HxFirstWeekOfYearType["FirstDayOfYear"] = 1] = "FirstDayOfYear";
    HxFirstWeekOfYearType[HxFirstWeekOfYearType["FirstFourDayWeek"] = 2] = "FirstFourDayWeek";
    HxFirstWeekOfYearType[HxFirstWeekOfYearType["FirstFullWeek"] = 3] = "FirstFullWeek";
})(HxFirstWeekOfYearType = exports.HxFirstWeekOfYearType || (exports.HxFirstWeekOfYearType = {}));
function getHxFirstWeekOfYearTypeAsString(value) {
    return HxFirstWeekOfYearType[value];
}
exports.getHxFirstWeekOfYearTypeAsString = getHxFirstWeekOfYearTypeAsString;
function getHxFirstWeekOfYearTypeFromString(value) {
    return HxFirstWeekOfYearType[value];
}
exports.getHxFirstWeekOfYearTypeFromString = getHxFirstWeekOfYearTypeFromString;
/*-------------------------------------------------------------------------------
  HxCalendarType
-------------------------------------------------------------------------------*/
var HxCalendarType;
(function (HxCalendarType) {
    HxCalendarType[HxCalendarType["Unknown"] = 0] = "Unknown";
    HxCalendarType[HxCalendarType["Gregorian"] = 1] = "Gregorian";
    HxCalendarType[HxCalendarType["GregorianUS"] = 2] = "GregorianUS";
    HxCalendarType[HxCalendarType["Japan"] = 3] = "Japan";
    HxCalendarType[HxCalendarType["Taiwan"] = 4] = "Taiwan";
    HxCalendarType[HxCalendarType["Korea"] = 5] = "Korea";
    HxCalendarType[HxCalendarType["Hijri"] = 6] = "Hijri";
    HxCalendarType[HxCalendarType["Thai"] = 7] = "Thai";
    HxCalendarType[HxCalendarType["Hebrew"] = 8] = "Hebrew";
    HxCalendarType[HxCalendarType["GregorianMeFrench"] = 9] = "GregorianMeFrench";
    HxCalendarType[HxCalendarType["GregorianArabic"] = 10] = "GregorianArabic";
    HxCalendarType[HxCalendarType["GregorianXlitEnglish"] = 11] = "GregorianXlitEnglish";
    HxCalendarType[HxCalendarType["GregorianXlitFrench"] = 12] = "GregorianXlitFrench";
    HxCalendarType[HxCalendarType["Julian"] = 13] = "Julian";
    HxCalendarType[HxCalendarType["JapaneseLuniSolar"] = 14] = "JapaneseLuniSolar";
    HxCalendarType[HxCalendarType["ChineseLuniSolar"] = 15] = "ChineseLuniSolar";
    HxCalendarType[HxCalendarType["Saka"] = 16] = "Saka";
    HxCalendarType[HxCalendarType["LunarEtoChn"] = 17] = "LunarEtoChn";
    HxCalendarType[HxCalendarType["LunarEtoKor"] = 18] = "LunarEtoKor";
    HxCalendarType[HxCalendarType["LunarEtoRokuyou"] = 19] = "LunarEtoRokuyou";
    HxCalendarType[HxCalendarType["KoreanLuniSolar"] = 20] = "KoreanLuniSolar";
    HxCalendarType[HxCalendarType["TaiwanLuniSolar"] = 21] = "TaiwanLuniSolar";
    HxCalendarType[HxCalendarType["Persian"] = 22] = "Persian";
    HxCalendarType[HxCalendarType["UmAlQura"] = 23] = "UmAlQura";
})(HxCalendarType = exports.HxCalendarType || (exports.HxCalendarType = {}));
function getHxCalendarTypeAsString(value) {
    return HxCalendarType[value];
}
exports.getHxCalendarTypeAsString = getHxCalendarTypeAsString;
function getHxCalendarTypeFromString(value) {
    return HxCalendarType[value];
}
exports.getHxCalendarTypeFromString = getHxCalendarTypeFromString;
/*-------------------------------------------------------------------------------
  HxRelativeOrderType
-------------------------------------------------------------------------------*/
var HxRelativeOrderType;
(function (HxRelativeOrderType) {
    HxRelativeOrderType[HxRelativeOrderType["First"] = 0] = "First";
    HxRelativeOrderType[HxRelativeOrderType["Second"] = 1] = "Second";
    HxRelativeOrderType[HxRelativeOrderType["Third"] = 2] = "Third";
    HxRelativeOrderType[HxRelativeOrderType["Fourth"] = 3] = "Fourth";
    HxRelativeOrderType[HxRelativeOrderType["Last"] = 4] = "Last";
})(HxRelativeOrderType = exports.HxRelativeOrderType || (exports.HxRelativeOrderType = {}));
function getHxRelativeOrderTypeAsString(value) {
    return HxRelativeOrderType[value];
}
exports.getHxRelativeOrderTypeAsString = getHxRelativeOrderTypeAsString;
function getHxRelativeOrderTypeFromString(value) {
    return HxRelativeOrderType[value];
}
exports.getHxRelativeOrderTypeFromString = getHxRelativeOrderTypeFromString;
/*-------------------------------------------------------------------------------
  HxPatternType
-------------------------------------------------------------------------------*/
var HxPatternType;
(function (HxPatternType) {
    HxPatternType[HxPatternType["Irregular"] = 0] = "Irregular";
    HxPatternType[HxPatternType["Daily"] = 1] = "Daily";
    HxPatternType[HxPatternType["Weekly"] = 2] = "Weekly";
    HxPatternType[HxPatternType["MonthlyAbsolute"] = 3] = "MonthlyAbsolute";
    HxPatternType[HxPatternType["MonthlyRelative"] = 4] = "MonthlyRelative";
    HxPatternType[HxPatternType["YearlyAbsolute"] = 5] = "YearlyAbsolute";
    HxPatternType[HxPatternType["YearlyRelative"] = 6] = "YearlyRelative";
    HxPatternType[HxPatternType["CustomPattern"] = 7] = "CustomPattern";
    HxPatternType[HxPatternType["None"] = 8] = "None";
})(HxPatternType = exports.HxPatternType || (exports.HxPatternType = {}));
function getHxPatternTypeAsString(value) {
    return HxPatternType[value];
}
exports.getHxPatternTypeAsString = getHxPatternTypeAsString;
function getHxPatternTypeFromString(value) {
    return HxPatternType[value];
}
exports.getHxPatternTypeFromString = getHxPatternTypeFromString;
/*-------------------------------------------------------------------------------
  HxPatternRangeType
-------------------------------------------------------------------------------*/
var HxPatternRangeType;
(function (HxPatternRangeType) {
    HxPatternRangeType[HxPatternRangeType["NoEndPatternRange"] = 0] = "NoEndPatternRange";
    HxPatternRangeType[HxPatternRangeType["EndDatePatternRange"] = 1] = "EndDatePatternRange";
    HxPatternRangeType[HxPatternRangeType["NumberedPatternRange"] = 2] = "NumberedPatternRange";
    HxPatternRangeType[HxPatternRangeType["None"] = 3] = "None";
})(HxPatternRangeType = exports.HxPatternRangeType || (exports.HxPatternRangeType = {}));
function getHxPatternRangeTypeAsString(value) {
    return HxPatternRangeType[value];
}
exports.getHxPatternRangeTypeAsString = getHxPatternRangeTypeAsString;
function getHxPatternRangeTypeFromString(value) {
    return HxPatternRangeType[value];
}
exports.getHxPatternRangeTypeFromString = getHxPatternRangeTypeFromString;
/*-------------------------------------------------------------------------------
  HxAccountType
-------------------------------------------------------------------------------*/
var HxAccountType;
(function (HxAccountType) {
    HxAccountType[HxAccountType["Invalid"] = 2] = "Invalid";
    HxAccountType[HxAccountType["HxS"] = 0] = "HxS";
    HxAccountType[HxAccountType["Device"] = 1] = "Device";
    HxAccountType[HxAccountType["Direct"] = 3] = "Direct";
})(HxAccountType = exports.HxAccountType || (exports.HxAccountType = {}));
function getHxAccountTypeAsString(value) {
    return HxAccountType[value];
}
exports.getHxAccountTypeAsString = getHxAccountTypeAsString;
function getHxAccountTypeFromString(value) {
    return HxAccountType[value];
}
exports.getHxAccountTypeFromString = getHxAccountTypeFromString;
/*-------------------------------------------------------------------------------
  HxTileActionType
-------------------------------------------------------------------------------*/
var HxTileActionType;
(function (HxTileActionType) {
    HxTileActionType[HxTileActionType["NoAction"] = 0] = "NoAction";
    HxTileActionType[HxTileActionType["Create"] = 1] = "Create";
    HxTileActionType[HxTileActionType["Update"] = 2] = "Update";
    HxTileActionType[HxTileActionType["Delete"] = 3] = "Delete";
})(HxTileActionType = exports.HxTileActionType || (exports.HxTileActionType = {}));
function getHxTileActionTypeAsString(value) {
    return HxTileActionType[value];
}
exports.getHxTileActionTypeAsString = getHxTileActionTypeAsString;
function getHxTileActionTypeFromString(value) {
    return HxTileActionType[value];
}
exports.getHxTileActionTypeFromString = getHxTileActionTypeFromString;
/*-------------------------------------------------------------------------------
  HxDataReplicationObjectState
-------------------------------------------------------------------------------*/
var HxDataReplicationObjectState;
(function (HxDataReplicationObjectState) {
    HxDataReplicationObjectState[HxDataReplicationObjectState["Unknown"] = 0] = "Unknown";
    HxDataReplicationObjectState[HxDataReplicationObjectState["Create"] = 1] = "Create";
    HxDataReplicationObjectState[HxDataReplicationObjectState["Update"] = 2] = "Update";
    HxDataReplicationObjectState[HxDataReplicationObjectState["Delete"] = 3] = "Delete";
})(HxDataReplicationObjectState = exports.HxDataReplicationObjectState || (exports.HxDataReplicationObjectState = {}));
function getHxDataReplicationObjectStateAsString(value) {
    return HxDataReplicationObjectState[value];
}
exports.getHxDataReplicationObjectStateAsString = getHxDataReplicationObjectStateAsString;
function getHxDataReplicationObjectStateFromString(value) {
    return HxDataReplicationObjectState[value];
}
exports.getHxDataReplicationObjectStateFromString = getHxDataReplicationObjectStateFromString;
/*-------------------------------------------------------------------------------
  HxAttachmentType
-------------------------------------------------------------------------------*/
var HxAttachmentType;
(function (HxAttachmentType) {
    HxAttachmentType[HxAttachmentType["Word"] = 0] = "Word";
    HxAttachmentType[HxAttachmentType["XL"] = 1] = "XL";
    HxAttachmentType[HxAttachmentType["PPT"] = 2] = "PPT";
    HxAttachmentType[HxAttachmentType["Image"] = 3] = "Image";
    HxAttachmentType[HxAttachmentType["PDF"] = 4] = "PDF";
    HxAttachmentType[HxAttachmentType["Message"] = 5] = "Message";
    HxAttachmentType[HxAttachmentType["SmimePlainTextSigned"] = 6] = "SmimePlainTextSigned";
    HxAttachmentType[HxAttachmentType["SmimeOpaqueSignedOrEncrypted"] = 7] = "SmimeOpaqueSignedOrEncrypted";
    HxAttachmentType[HxAttachmentType["Calendar"] = 9] = "Calendar";
    HxAttachmentType[HxAttachmentType["Unknown"] = 8] = "Unknown";
})(HxAttachmentType = exports.HxAttachmentType || (exports.HxAttachmentType = {}));
function getHxAttachmentTypeAsString(value) {
    return HxAttachmentType[value];
}
exports.getHxAttachmentTypeAsString = getHxAttachmentTypeAsString;
function getHxAttachmentTypeFromString(value) {
    return HxAttachmentType[value];
}
exports.getHxAttachmentTypeFromString = getHxAttachmentTypeFromString;
/*-------------------------------------------------------------------------------
  HxHostAppType
-------------------------------------------------------------------------------*/
var HxHostAppType;
(function (HxHostAppType) {
    HxHostAppType[HxHostAppType["Mail"] = 1] = "Mail";
    HxHostAppType[HxHostAppType["Calendar"] = 2] = "Calendar";
})(HxHostAppType = exports.HxHostAppType || (exports.HxHostAppType = {}));
function getHxHostAppTypeAsString(value) {
    return HxHostAppType[value];
}
exports.getHxHostAppTypeAsString = getHxHostAppTypeAsString;
function getHxHostAppTypeFromString(value) {
    return HxHostAppType[value];
}
exports.getHxHostAppTypeFromString = getHxHostAppTypeFromString;
/*-------------------------------------------------------------------------------
  HxMailListFilterType
-------------------------------------------------------------------------------*/
var HxMailListFilterType;
(function (HxMailListFilterType) {
    HxMailListFilterType[HxMailListFilterType["Unfiltered"] = 3] = "Unfiltered";
    HxMailListFilterType[HxMailListFilterType["Unread"] = 1] = "Unread";
    HxMailListFilterType[HxMailListFilterType["Flagged"] = 2] = "Flagged";
    HxMailListFilterType[HxMailListFilterType["Mentioned"] = 4] = "Mentioned";
})(HxMailListFilterType = exports.HxMailListFilterType || (exports.HxMailListFilterType = {}));
function getHxMailListFilterTypeAsString(value) {
    return HxMailListFilterType[value];
}
exports.getHxMailListFilterTypeAsString = getHxMailListFilterTypeAsString;
function getHxMailListFilterTypeFromString(value) {
    return HxMailListFilterType[value];
}
exports.getHxMailListFilterTypeFromString = getHxMailListFilterTypeFromString;
/*-------------------------------------------------------------------------------
  HxTileAssetType
-------------------------------------------------------------------------------*/
var HxTileAssetType;
(function (HxTileAssetType) {
    HxTileAssetType[HxTileAssetType["Generic"] = 0] = "Generic";
    HxTileAssetType[HxTileAssetType["Exchange"] = 1] = "Exchange";
    HxTileAssetType[HxTileAssetType["Gmail"] = 2] = "Gmail";
    HxTileAssetType[HxTileAssetType["OutlookDotCom"] = 3] = "OutlookDotCom";
    HxTileAssetType[HxTileAssetType["LinkedInbox"] = 4] = "LinkedInbox";
})(HxTileAssetType = exports.HxTileAssetType || (exports.HxTileAssetType = {}));
function getHxTileAssetTypeAsString(value) {
    return HxTileAssetType[value];
}
exports.getHxTileAssetTypeAsString = getHxTileAssetTypeAsString;
function getHxTileAssetTypeFromString(value) {
    return HxTileAssetType[value];
}
exports.getHxTileAssetTypeFromString = getHxTileAssetTypeFromString;
/*-------------------------------------------------------------------------------
  HxAccountProviderType
-------------------------------------------------------------------------------*/
var HxAccountProviderType;
(function (HxAccountProviderType) {
    HxAccountProviderType[HxAccountProviderType["Unknown"] = 0] = "Unknown";
    HxAccountProviderType[HxAccountProviderType["Mixed"] = 1] = "Mixed";
    HxAccountProviderType[HxAccountProviderType["Generic"] = 2] = "Generic";
    HxAccountProviderType[HxAccountProviderType["Microsoft"] = 3] = "Microsoft";
    HxAccountProviderType[HxAccountProviderType["Exchange"] = 4] = "Exchange";
    HxAccountProviderType[HxAccountProviderType["Google"] = 5] = "Google";
    HxAccountProviderType[HxAccountProviderType["ICloud"] = 6] = "ICloud";
    HxAccountProviderType[HxAccountProviderType["Yahoo"] = 7] = "Yahoo";
})(HxAccountProviderType = exports.HxAccountProviderType || (exports.HxAccountProviderType = {}));
function getHxAccountProviderTypeAsString(value) {
    return HxAccountProviderType[value];
}
exports.getHxAccountProviderTypeAsString = getHxAccountProviderTypeAsString;
function getHxAccountProviderTypeFromString(value) {
    return HxAccountProviderType[value];
}
exports.getHxAccountProviderTypeFromString = getHxAccountProviderTypeFromString;
/*-------------------------------------------------------------------------------
  HxProvisionErrorType
-------------------------------------------------------------------------------*/
var HxProvisionErrorType;
(function (HxProvisionErrorType) {
    HxProvisionErrorType[HxProvisionErrorType["None"] = 0] = "None";
    HxProvisionErrorType[HxProvisionErrorType["Unknown"] = 1] = "Unknown";
    HxProvisionErrorType[HxProvisionErrorType["InvalidExchangeServer"] = 2] = "InvalidExchangeServer";
    HxProvisionErrorType[HxProvisionErrorType["InvalidAuth"] = 3] = "InvalidAuth";
    HxProvisionErrorType[HxProvisionErrorType["SslCheckFailed"] = 4] = "SslCheckFailed";
    HxProvisionErrorType[HxProvisionErrorType["NeedsOtherAuth"] = 5] = "NeedsOtherAuth";
    HxProvisionErrorType[HxProvisionErrorType["InvalidRemoteServer"] = 6] = "InvalidRemoteServer";
})(HxProvisionErrorType = exports.HxProvisionErrorType || (exports.HxProvisionErrorType = {}));
function getHxProvisionErrorTypeAsString(value) {
    return HxProvisionErrorType[value];
}
exports.getHxProvisionErrorTypeAsString = getHxProvisionErrorTypeAsString;
function getHxProvisionErrorTypeFromString(value) {
    return HxProvisionErrorType[value];
}
exports.getHxProvisionErrorTypeFromString = getHxProvisionErrorTypeFromString;
/*-------------------------------------------------------------------------------
  HxUpdateAccountCredentialsErrorType
-------------------------------------------------------------------------------*/
var HxUpdateAccountCredentialsErrorType;
(function (HxUpdateAccountCredentialsErrorType) {
    HxUpdateAccountCredentialsErrorType[HxUpdateAccountCredentialsErrorType["None"] = 0] = "None";
    HxUpdateAccountCredentialsErrorType[HxUpdateAccountCredentialsErrorType["Unknown"] = 1] = "Unknown";
    HxUpdateAccountCredentialsErrorType[HxUpdateAccountCredentialsErrorType["InvalidAuth"] = 2] = "InvalidAuth";
    HxUpdateAccountCredentialsErrorType[HxUpdateAccountCredentialsErrorType["SslCheckFailed"] = 3] = "SslCheckFailed";
    HxUpdateAccountCredentialsErrorType[HxUpdateAccountCredentialsErrorType["InvalidRemoteServer"] = 4] = "InvalidRemoteServer";
    HxUpdateAccountCredentialsErrorType[HxUpdateAccountCredentialsErrorType["OutgoingCredentialsInvalid"] = 5] = "OutgoingCredentialsInvalid";
    HxUpdateAccountCredentialsErrorType[HxUpdateAccountCredentialsErrorType["OutgoingSslCheckFailed"] = 6] = "OutgoingSslCheckFailed";
    HxUpdateAccountCredentialsErrorType[HxUpdateAccountCredentialsErrorType["InvalidDirectSyncServerConfig"] = 7] = "InvalidDirectSyncServerConfig";
    HxUpdateAccountCredentialsErrorType[HxUpdateAccountCredentialsErrorType["InvalidDirectSyncOutgoingServerConfig"] = 8] = "InvalidDirectSyncOutgoingServerConfig";
})(HxUpdateAccountCredentialsErrorType = exports.HxUpdateAccountCredentialsErrorType || (exports.HxUpdateAccountCredentialsErrorType = {}));
function getHxUpdateAccountCredentialsErrorTypeAsString(value) {
    return HxUpdateAccountCredentialsErrorType[value];
}
exports.getHxUpdateAccountCredentialsErrorTypeAsString = getHxUpdateAccountCredentialsErrorTypeAsString;
function getHxUpdateAccountCredentialsErrorTypeFromString(value) {
    return HxUpdateAccountCredentialsErrorType[value];
}
exports.getHxUpdateAccountCredentialsErrorTypeFromString = getHxUpdateAccountCredentialsErrorTypeFromString;
/*-------------------------------------------------------------------------------
  HxSyncDeviceAccountType
-------------------------------------------------------------------------------*/
var HxSyncDeviceAccountType;
(function (HxSyncDeviceAccountType) {
    HxSyncDeviceAccountType[HxSyncDeviceAccountType["Unknown"] = 0] = "Unknown";
    HxSyncDeviceAccountType[HxSyncDeviceAccountType["ActiveSyncExchange"] = 1] = "ActiveSyncExchange";
    HxSyncDeviceAccountType[HxSyncDeviceAccountType["ActiveSyncGoogle"] = 2] = "ActiveSyncGoogle";
    HxSyncDeviceAccountType[HxSyncDeviceAccountType["ActiveSyncMicrosoft"] = 3] = "ActiveSyncMicrosoft";
    HxSyncDeviceAccountType[HxSyncDeviceAccountType["InternetGoogle"] = 4] = "InternetGoogle";
    HxSyncDeviceAccountType[HxSyncDeviceAccountType["InternetICloud"] = 5] = "InternetICloud";
    HxSyncDeviceAccountType[HxSyncDeviceAccountType["InternetMailPopImap"] = 6] = "InternetMailPopImap";
    HxSyncDeviceAccountType[HxSyncDeviceAccountType["InternetMailPOP"] = 8] = "InternetMailPOP";
    HxSyncDeviceAccountType[HxSyncDeviceAccountType["InternetMailIMAP"] = 9] = "InternetMailIMAP";
    HxSyncDeviceAccountType[HxSyncDeviceAccountType["InternetYahoo"] = 10] = "InternetYahoo";
    HxSyncDeviceAccountType[HxSyncDeviceAccountType["SunriseFacebook"] = 11] = "SunriseFacebook";
    HxSyncDeviceAccountType[HxSyncDeviceAccountType["SunriseEvernote"] = 12] = "SunriseEvernote";
    HxSyncDeviceAccountType[HxSyncDeviceAccountType["SunriseMeetup"] = 13] = "SunriseMeetup";
    HxSyncDeviceAccountType[HxSyncDeviceAccountType["Ews"] = 14] = "Ews";
})(HxSyncDeviceAccountType = exports.HxSyncDeviceAccountType || (exports.HxSyncDeviceAccountType = {}));
function getHxSyncDeviceAccountTypeAsString(value) {
    return HxSyncDeviceAccountType[value];
}
exports.getHxSyncDeviceAccountTypeAsString = getHxSyncDeviceAccountTypeAsString;
function getHxSyncDeviceAccountTypeFromString(value) {
    return HxSyncDeviceAccountType[value];
}
exports.getHxSyncDeviceAccountTypeFromString = getHxSyncDeviceAccountTypeFromString;
/*-------------------------------------------------------------------------------
  HxNewAccountCreateState
-------------------------------------------------------------------------------*/
var HxNewAccountCreateState;
(function (HxNewAccountCreateState) {
    HxNewAccountCreateState[HxNewAccountCreateState["Success"] = 0] = "Success";
    HxNewAccountCreateState[HxNewAccountCreateState["Err_Duplicate"] = 1] = "Err_Duplicate";
    HxNewAccountCreateState[HxNewAccountCreateState["Err_AutoD"] = 3] = "Err_AutoD";
    HxNewAccountCreateState[HxNewAccountCreateState["Err_AuthNeeded"] = 4] = "Err_AuthNeeded";
    HxNewAccountCreateState[HxNewAccountCreateState["Err_Unknown"] = 5] = "Err_Unknown";
    HxNewAccountCreateState[HxNewAccountCreateState["Err_TurnMailSyncOn"] = 6] = "Err_TurnMailSyncOn";
    HxNewAccountCreateState[HxNewAccountCreateState["Unknown"] = 2] = "Unknown";
    HxNewAccountCreateState[HxNewAccountCreateState["Success_AutoD"] = 7] = "Success_AutoD";
    HxNewAccountCreateState[HxNewAccountCreateState["ForceCreate"] = 8] = "ForceCreate";
    HxNewAccountCreateState[HxNewAccountCreateState["Err_PolicyBlocksAccountCreation"] = 9] = "Err_PolicyBlocksAccountCreation";
    HxNewAccountCreateState[HxNewAccountCreateState["Err_RedirectToBasicAuth"] = 10] = "Err_RedirectToBasicAuth";
    HxNewAccountCreateState[HxNewAccountCreateState["Err_DeviceAccountBlackforestNotSupported"] = 11] = "Err_DeviceAccountBlackforestNotSupported";
    HxNewAccountCreateState[HxNewAccountCreateState["AddDefaultAccount"] = 12] = "AddDefaultAccount";
    HxNewAccountCreateState[HxNewAccountCreateState["Err_DefaultAccountWasAddedPreviously"] = 13] = "Err_DefaultAccountWasAddedPreviously";
    HxNewAccountCreateState[HxNewAccountCreateState["Err_AccountIsNotSharedAccount"] = 16] = "Err_AccountIsNotSharedAccount";
    HxNewAccountCreateState[HxNewAccountCreateState["Err_InvalidPrimaryAccountForSharedAccount"] = 17] = "Err_InvalidPrimaryAccountForSharedAccount";
    HxNewAccountCreateState[HxNewAccountCreateState["Err_PreconditionCheckFailed"] = 18] = "Err_PreconditionCheckFailed";
    HxNewAccountCreateState[HxNewAccountCreateState["Err_ProvisioningError"] = 19] = "Err_ProvisioningError";
    HxNewAccountCreateState[HxNewAccountCreateState["Err_SslError"] = 20] = "Err_SslError";
})(HxNewAccountCreateState = exports.HxNewAccountCreateState || (exports.HxNewAccountCreateState = {}));
function getHxNewAccountCreateStateAsString(value) {
    return HxNewAccountCreateState[value];
}
exports.getHxNewAccountCreateStateAsString = getHxNewAccountCreateStateAsString;
function getHxNewAccountCreateStateFromString(value) {
    return HxNewAccountCreateState[value];
}
exports.getHxNewAccountCreateStateFromString = getHxNewAccountCreateStateFromString;
/*-------------------------------------------------------------------------------
  HxActionInputType
-------------------------------------------------------------------------------*/
var HxActionInputType;
(function (HxActionInputType) {
    HxActionInputType[HxActionInputType["None"] = 0] = "None";
    HxActionInputType[HxActionInputType["HoverButton"] = 1] = "HoverButton";
    HxActionInputType[HxActionInputType["RibbonOrKeyboard"] = 2] = "RibbonOrKeyboard";
    HxActionInputType[HxActionInputType["Swipe"] = 3] = "Swipe";
    HxActionInputType[HxActionInputType["ContextMenu"] = 4] = "ContextMenu";
    HxActionInputType[HxActionInputType["DragDrop"] = 5] = "DragDrop";
})(HxActionInputType = exports.HxActionInputType || (exports.HxActionInputType = {}));
function getHxActionInputTypeAsString(value) {
    return HxActionInputType[value];
}
exports.getHxActionInputTypeAsString = getHxActionInputTypeAsString;
function getHxActionInputTypeFromString(value) {
    return HxActionInputType[value];
}
exports.getHxActionInputTypeFromString = getHxActionInputTypeFromString;
/*-------------------------------------------------------------------------------
  HxAccountAuthType
-------------------------------------------------------------------------------*/
var HxAccountAuthType;
(function (HxAccountAuthType) {
    HxAccountAuthType[HxAccountAuthType["Unknown"] = 0] = "Unknown";
    HxAccountAuthType[HxAccountAuthType["Basic"] = 1] = "Basic";
    HxAccountAuthType[HxAccountAuthType["Bearer"] = 2] = "Bearer";
})(HxAccountAuthType = exports.HxAccountAuthType || (exports.HxAccountAuthType = {}));
function getHxAccountAuthTypeAsString(value) {
    return HxAccountAuthType[value];
}
exports.getHxAccountAuthTypeAsString = getHxAccountAuthTypeAsString;
function getHxAccountAuthTypeFromString(value) {
    return HxAccountAuthType[value];
}
exports.getHxAccountAuthTypeFromString = getHxAccountAuthTypeFromString;
/*-------------------------------------------------------------------------------
  HxClassificationType
-------------------------------------------------------------------------------*/
var HxClassificationType;
(function (HxClassificationType) {
    HxClassificationType[HxClassificationType["Focused"] = 0] = "Focused";
    HxClassificationType[HxClassificationType["Other"] = 1] = "Other";
    HxClassificationType[HxClassificationType["Any"] = 3] = "Any";
})(HxClassificationType = exports.HxClassificationType || (exports.HxClassificationType = {}));
function getHxClassificationTypeAsString(value) {
    return HxClassificationType[value];
}
exports.getHxClassificationTypeAsString = getHxClassificationTypeAsString;
function getHxClassificationTypeFromString(value) {
    return HxClassificationType[value];
}
exports.getHxClassificationTypeFromString = getHxClassificationTypeFromString;
/*-------------------------------------------------------------------------------
  HxWatermarkPushNotificationType
-------------------------------------------------------------------------------*/
var HxWatermarkPushNotificationType;
(function (HxWatermarkPushNotificationType) {
    HxWatermarkPushNotificationType[HxWatermarkPushNotificationType["None"] = 2] = "None";
    HxWatermarkPushNotificationType[HxWatermarkPushNotificationType["Conservative"] = 0] = "Conservative";
    HxWatermarkPushNotificationType[HxWatermarkPushNotificationType["Aggressive"] = 1] = "Aggressive";
})(HxWatermarkPushNotificationType = exports.HxWatermarkPushNotificationType || (exports.HxWatermarkPushNotificationType = {}));
function getHxWatermarkPushNotificationTypeAsString(value) {
    return HxWatermarkPushNotificationType[value];
}
exports.getHxWatermarkPushNotificationTypeAsString = getHxWatermarkPushNotificationTypeAsString;
function getHxWatermarkPushNotificationTypeFromString(value) {
    return HxWatermarkPushNotificationType[value];
}
exports.getHxWatermarkPushNotificationTypeFromString = getHxWatermarkPushNotificationTypeFromString;
/*-------------------------------------------------------------------------------
  HxPushNotificationClassificationType
-------------------------------------------------------------------------------*/
var HxPushNotificationClassificationType;
(function (HxPushNotificationClassificationType) {
    HxPushNotificationClassificationType[HxPushNotificationClassificationType["None"] = 0] = "None";
    HxPushNotificationClassificationType[HxPushNotificationClassificationType["Focused"] = 1] = "Focused";
    HxPushNotificationClassificationType[HxPushNotificationClassificationType["Any"] = 2] = "Any";
    HxPushNotificationClassificationType[HxPushNotificationClassificationType["Favorites"] = 3] = "Favorites";
})(HxPushNotificationClassificationType = exports.HxPushNotificationClassificationType || (exports.HxPushNotificationClassificationType = {}));
function getHxPushNotificationClassificationTypeAsString(value) {
    return HxPushNotificationClassificationType[value];
}
exports.getHxPushNotificationClassificationTypeAsString = getHxPushNotificationClassificationTypeAsString;
function getHxPushNotificationClassificationTypeFromString(value) {
    return HxPushNotificationClassificationType[value];
}
exports.getHxPushNotificationClassificationTypeFromString = getHxPushNotificationClassificationTypeFromString;
/*-------------------------------------------------------------------------------
  HxHxSCapableType
-------------------------------------------------------------------------------*/
var HxHxSCapableType;
(function (HxHxSCapableType) {
    HxHxSCapableType[HxHxSCapableType["Unknown"] = 0] = "Unknown";
    HxHxSCapableType[HxHxSCapableType["Capable"] = 1] = "Capable";
    HxHxSCapableType[HxHxSCapableType["NotCapable"] = 2] = "NotCapable";
})(HxHxSCapableType = exports.HxHxSCapableType || (exports.HxHxSCapableType = {}));
function getHxHxSCapableTypeAsString(value) {
    return HxHxSCapableType[value];
}
exports.getHxHxSCapableTypeAsString = getHxHxSCapableTypeAsString;
function getHxHxSCapableTypeFromString(value) {
    return HxHxSCapableType[value];
}
exports.getHxHxSCapableTypeFromString = getHxHxSCapableTypeFromString;
/*-------------------------------------------------------------------------------
  HxNavPaneResizeMode
-------------------------------------------------------------------------------*/
var HxNavPaneResizeMode;
(function (HxNavPaneResizeMode) {
    HxNavPaneResizeMode[HxNavPaneResizeMode["Automatic"] = 0] = "Automatic";
    HxNavPaneResizeMode[HxNavPaneResizeMode["UserCollapsed"] = 1] = "UserCollapsed";
})(HxNavPaneResizeMode = exports.HxNavPaneResizeMode || (exports.HxNavPaneResizeMode = {}));
function getHxNavPaneResizeModeAsString(value) {
    return HxNavPaneResizeMode[value];
}
exports.getHxNavPaneResizeModeAsString = getHxNavPaneResizeModeAsString;
function getHxNavPaneResizeModeFromString(value) {
    return HxNavPaneResizeMode[value];
}
exports.getHxNavPaneResizeModeFromString = getHxNavPaneResizeModeFromString;
/*-------------------------------------------------------------------------------
  HxLocalUdaStatusCode
-------------------------------------------------------------------------------*/
var HxLocalUdaStatusCode;
(function (HxLocalUdaStatusCode) {
    HxLocalUdaStatusCode[HxLocalUdaStatusCode["None"] = 0] = "None";
    HxLocalUdaStatusCode[HxLocalUdaStatusCode["Candidate"] = 1] = "Candidate";
    HxLocalUdaStatusCode[HxLocalUdaStatusCode["LocalUda"] = 2] = "LocalUda";
})(HxLocalUdaStatusCode = exports.HxLocalUdaStatusCode || (exports.HxLocalUdaStatusCode = {}));
function getHxLocalUdaStatusCodeAsString(value) {
    return HxLocalUdaStatusCode[value];
}
exports.getHxLocalUdaStatusCodeAsString = getHxLocalUdaStatusCodeAsString;
function getHxLocalUdaStatusCodeFromString(value) {
    return HxLocalUdaStatusCode[value];
}
exports.getHxLocalUdaStatusCodeFromString = getHxLocalUdaStatusCodeFromString;
/*-------------------------------------------------------------------------------
  HxExchangeForestType
-------------------------------------------------------------------------------*/
var HxExchangeForestType;
(function (HxExchangeForestType) {
    HxExchangeForestType[HxExchangeForestType["Unknown"] = 0] = "Unknown";
    HxExchangeForestType[HxExchangeForestType["Office365"] = 1] = "Office365";
    HxExchangeForestType[HxExchangeForestType["Blackforest"] = 2] = "Blackforest";
})(HxExchangeForestType = exports.HxExchangeForestType || (exports.HxExchangeForestType = {}));
function getHxExchangeForestTypeAsString(value) {
    return HxExchangeForestType[value];
}
exports.getHxExchangeForestTypeAsString = getHxExchangeForestTypeAsString;
function getHxExchangeForestTypeFromString(value) {
    return HxExchangeForestType[value];
}
exports.getHxExchangeForestTypeFromString = getHxExchangeForestTypeFromString;
/*-------------------------------------------------------------------------------
  HxViewMode
-------------------------------------------------------------------------------*/
var HxViewMode;
(function (HxViewMode) {
    HxViewMode[HxViewMode["ClassicGroupedMessages"] = 1] = "ClassicGroupedMessages";
    HxViewMode[HxViewMode["ClassicMessages"] = 2] = "ClassicMessages";
    HxViewMode[HxViewMode["None"] = 4] = "None";
})(HxViewMode = exports.HxViewMode || (exports.HxViewMode = {}));
function getHxViewModeAsString(value) {
    return HxViewMode[value];
}
exports.getHxViewModeAsString = getHxViewModeAsString;
function getHxViewModeFromString(value) {
    return HxViewMode[value];
}
exports.getHxViewModeFromString = getHxViewModeFromString;
/*-------------------------------------------------------------------------------
  HxSortProperty
-------------------------------------------------------------------------------*/
var HxSortProperty;
(function (HxSortProperty) {
    HxSortProperty[HxSortProperty["Date"] = 0] = "Date";
    HxSortProperty[HxSortProperty["Sender"] = 1] = "Sender";
    HxSortProperty[HxSortProperty["Subject"] = 2] = "Subject";
    HxSortProperty[HxSortProperty["Size"] = 3] = "Size";
    HxSortProperty[HxSortProperty["Importance"] = 4] = "Importance";
})(HxSortProperty = exports.HxSortProperty || (exports.HxSortProperty = {}));
function getHxSortPropertyAsString(value) {
    return HxSortProperty[value];
}
exports.getHxSortPropertyAsString = getHxSortPropertyAsString;
function getHxSortPropertyFromString(value) {
    return HxSortProperty[value];
}
exports.getHxSortPropertyFromString = getHxSortPropertyFromString;
/*-------------------------------------------------------------------------------
  HxViewType
-------------------------------------------------------------------------------*/
var HxViewType;
(function (HxViewType) {
    HxViewType[HxViewType["Unknown"] = 18] = "Unknown";
    HxViewType[HxViewType["Inbox"] = 0] = "Inbox";
    HxViewType[HxViewType["Folder"] = 1] = "Folder";
    HxViewType[HxViewType["Search"] = 2] = "Search";
    HxViewType[HxViewType["TopResultsSearch"] = 12] = "TopResultsSearch";
    HxViewType[HxViewType["Done"] = 3] = "Done";
    HxViewType[HxViewType["Drafts"] = 4] = "Drafts";
    HxViewType[HxViewType["SentItems"] = 5] = "SentItems";
    HxViewType[HxViewType["DeletedItems"] = 6] = "DeletedItems";
    HxViewType[HxViewType["JunkMail"] = 7] = "JunkMail";
    HxViewType[HxViewType["Outbox"] = 8] = "Outbox";
    HxViewType[HxViewType["Inbox_Other"] = 10] = "Inbox_Other";
    HxViewType[HxViewType["PersonView"] = 11] = "PersonView";
    HxViewType[HxViewType["ConversationHistory"] = 13] = "ConversationHistory";
    HxViewType[HxViewType["Scheduled"] = 14] = "Scheduled";
    HxViewType[HxViewType["GroupInbox"] = 15] = "GroupInbox";
    HxViewType[HxViewType["FindConversationsByPerson"] = 17] = "FindConversationsByPerson";
})(HxViewType = exports.HxViewType || (exports.HxViewType = {}));
function getHxViewTypeAsString(value) {
    return HxViewType[value];
}
exports.getHxViewTypeAsString = getHxViewTypeAsString;
function getHxViewTypeFromString(value) {
    return HxViewType[value];
}
exports.getHxViewTypeFromString = getHxViewTypeFromString;
/*-------------------------------------------------------------------------------
  HxDownloadedStateType
-------------------------------------------------------------------------------*/
var HxDownloadedStateType;
(function (HxDownloadedStateType) {
    HxDownloadedStateType[HxDownloadedStateType["NotDownloaded"] = 0] = "NotDownloaded";
    HxDownloadedStateType[HxDownloadedStateType["Downloading"] = 2] = "Downloading";
    HxDownloadedStateType[HxDownloadedStateType["Complete"] = 3] = "Complete";
    HxDownloadedStateType[HxDownloadedStateType["Failed"] = 4] = "Failed";
})(HxDownloadedStateType = exports.HxDownloadedStateType || (exports.HxDownloadedStateType = {}));
function getHxDownloadedStateTypeAsString(value) {
    return HxDownloadedStateType[value];
}
exports.getHxDownloadedStateTypeAsString = getHxDownloadedStateTypeAsString;
function getHxDownloadedStateTypeFromString(value) {
    return HxDownloadedStateType[value];
}
exports.getHxDownloadedStateTypeFromString = getHxDownloadedStateTypeFromString;
/*-------------------------------------------------------------------------------
  HxMessageMoveType
-------------------------------------------------------------------------------*/
var HxMessageMoveType;
(function (HxMessageMoveType) {
    HxMessageMoveType[HxMessageMoveType["NonSearch"] = 0] = "NonSearch";
    HxMessageMoveType[HxMessageMoveType["Search_AllFolders"] = 1] = "Search_AllFolders";
    HxMessageMoveType[HxMessageMoveType["Search_SingleFolder"] = 2] = "Search_SingleFolder";
    HxMessageMoveType[HxMessageMoveType["Search_ThisFolderAndSubfolders"] = 3] = "Search_ThisFolderAndSubfolders";
})(HxMessageMoveType = exports.HxMessageMoveType || (exports.HxMessageMoveType = {}));
function getHxMessageMoveTypeAsString(value) {
    return HxMessageMoveType[value];
}
exports.getHxMessageMoveTypeAsString = getHxMessageMoveTypeAsString;
function getHxMessageMoveTypeFromString(value) {
    return HxMessageMoveType[value];
}
exports.getHxMessageMoveTypeFromString = getHxMessageMoveTypeFromString;
/*-------------------------------------------------------------------------------
  HxMeetingType
-------------------------------------------------------------------------------*/
var HxMeetingType;
(function (HxMeetingType) {
    HxMeetingType[HxMeetingType["Invalid"] = 3] = "Invalid";
    HxMeetingType[HxMeetingType["Request"] = 0] = "Request";
    HxMeetingType[HxMeetingType["Cancellation"] = 1] = "Cancellation";
    HxMeetingType[HxMeetingType["Response"] = 2] = "Response";
})(HxMeetingType = exports.HxMeetingType || (exports.HxMeetingType = {}));
function getHxMeetingTypeAsString(value) {
    return HxMeetingType[value];
}
exports.getHxMeetingTypeAsString = getHxMeetingTypeAsString;
function getHxMeetingTypeFromString(value) {
    return HxMeetingType[value];
}
exports.getHxMeetingTypeFromString = getHxMeetingTypeFromString;
/*-------------------------------------------------------------------------------
  HxDraftType
-------------------------------------------------------------------------------*/
var HxDraftType;
(function (HxDraftType) {
    HxDraftType[HxDraftType["New"] = 0] = "New";
    HxDraftType[HxDraftType["Reply"] = 1] = "Reply";
    HxDraftType[HxDraftType["Forward"] = 2] = "Forward";
    HxDraftType[HxDraftType["ReplyAll"] = 3] = "ReplyAll";
    HxDraftType[HxDraftType["ReplyFromCalendar"] = 4] = "ReplyFromCalendar";
    HxDraftType[HxDraftType["ReplyAllFromCalendar"] = 5] = "ReplyAllFromCalendar";
    HxDraftType[HxDraftType["ForwardMeetingRequest"] = 8] = "ForwardMeetingRequest";
    HxDraftType[HxDraftType["UnknownDraft"] = 6] = "UnknownDraft";
    HxDraftType[HxDraftType["None"] = 7] = "None";
    HxDraftType[HxDraftType["ForwardFromCalendar"] = 9] = "ForwardFromCalendar";
})(HxDraftType = exports.HxDraftType || (exports.HxDraftType = {}));
function getHxDraftTypeAsString(value) {
    return HxDraftType[value];
}
exports.getHxDraftTypeAsString = getHxDraftTypeAsString;
function getHxDraftTypeFromString(value) {
    return HxDraftType[value];
}
exports.getHxDraftTypeFromString = getHxDraftTypeFromString;
/*-------------------------------------------------------------------------------
  HxMeetingResponseType
-------------------------------------------------------------------------------*/
var HxMeetingResponseType;
(function (HxMeetingResponseType) {
    HxMeetingResponseType[HxMeetingResponseType["Accepted"] = 0] = "Accepted";
    HxMeetingResponseType[HxMeetingResponseType["Tentative"] = 1] = "Tentative";
    HxMeetingResponseType[HxMeetingResponseType["Declined"] = 2] = "Declined";
    HxMeetingResponseType[HxMeetingResponseType["Organizer"] = 3] = "Organizer";
    HxMeetingResponseType[HxMeetingResponseType["NoResponse"] = 4] = "NoResponse";
})(HxMeetingResponseType = exports.HxMeetingResponseType || (exports.HxMeetingResponseType = {}));
function getHxMeetingResponseTypeAsString(value) {
    return HxMeetingResponseType[value];
}
exports.getHxMeetingResponseTypeAsString = getHxMeetingResponseTypeAsString;
function getHxMeetingResponseTypeFromString(value) {
    return HxMeetingResponseType[value];
}
exports.getHxMeetingResponseTypeFromString = getHxMeetingResponseTypeFromString;
/*-------------------------------------------------------------------------------
  HxSyncStatusType
-------------------------------------------------------------------------------*/
var HxSyncStatusType;
(function (HxSyncStatusType) {
    HxSyncStatusType[HxSyncStatusType["Unknown"] = 0] = "Unknown";
    HxSyncStatusType[HxSyncStatusType["HeadersUpToDate"] = 2] = "HeadersUpToDate";
    HxSyncStatusType[HxSyncStatusType["BodiesUpToDate"] = 4] = "BodiesUpToDate";
    HxSyncStatusType[HxSyncStatusType["UpToDate"] = 3] = "UpToDate";
})(HxSyncStatusType = exports.HxSyncStatusType || (exports.HxSyncStatusType = {}));
function getHxSyncStatusTypeAsString(value) {
    return HxSyncStatusType[value];
}
exports.getHxSyncStatusTypeAsString = getHxSyncStatusTypeAsString;
function getHxSyncStatusTypeFromString(value) {
    return HxSyncStatusType[value];
}
exports.getHxSyncStatusTypeFromString = getHxSyncStatusTypeFromString;
/*-------------------------------------------------------------------------------
  HxActivityFeedType
-------------------------------------------------------------------------------*/
var HxActivityFeedType;
(function (HxActivityFeedType) {
    HxActivityFeedType[HxActivityFeedType["Reactions"] = 0] = "Reactions";
    HxActivityFeedType[HxActivityFeedType["None"] = 1] = "None";
})(HxActivityFeedType = exports.HxActivityFeedType || (exports.HxActivityFeedType = {}));
function getHxActivityFeedTypeAsString(value) {
    return HxActivityFeedType[value];
}
exports.getHxActivityFeedTypeAsString = getHxActivityFeedTypeAsString;
function getHxActivityFeedTypeFromString(value) {
    return HxActivityFeedType[value];
}
exports.getHxActivityFeedTypeFromString = getHxActivityFeedTypeFromString;
/*-------------------------------------------------------------------------------
  HxErrorType
-------------------------------------------------------------------------------*/
var HxErrorType;
(function (HxErrorType) {
    HxErrorType[HxErrorType["None"] = 111] = "None";
    HxErrorType[HxErrorType["BadCredentials"] = 0] = "BadCredentials";
    HxErrorType[HxErrorType["GenericSendFailure"] = 2] = "GenericSendFailure";
    HxErrorType[HxErrorType["DeleteRootView"] = 4] = "DeleteRootView";
    HxErrorType[HxErrorType["DeleteViewHasChildren"] = 6] = "DeleteViewHasChildren";
    HxErrorType[HxErrorType["ServiceTooOld"] = 8] = "ServiceTooOld";
    HxErrorType[HxErrorType["UpgradeRequired"] = 10] = "UpgradeRequired";
    HxErrorType[HxErrorType["UpgradeSuggested"] = 11] = "UpgradeSuggested";
    HxErrorType[HxErrorType["NetworkDisconnected"] = 12] = "NetworkDisconnected";
    HxErrorType[HxErrorType["InvalidIRMTemplate"] = 13] = "InvalidIRMTemplate";
    HxErrorType[HxErrorType["DraftSaveUIFailed"] = 14] = "DraftSaveUIFailed";
    HxErrorType[HxErrorType["ShouldEnsureOriginFullBodyAndAttachments"] = 15] = "ShouldEnsureOriginFullBodyAndAttachments";
    HxErrorType[HxErrorType["PolicyError"] = 16] = "PolicyError";
    HxErrorType[HxErrorType["PrintWaitOnFullMessageAndImages"] = 17] = "PrintWaitOnFullMessageAndImages";
    HxErrorType[HxErrorType["DraftSmartReplyDeleteAttachment"] = 18] = "DraftSmartReplyDeleteAttachment";
    HxErrorType[HxErrorType["NgcMonthlyYearlyRepeatNotSupported"] = 19] = "NgcMonthlyYearlyRepeatNotSupported";
    HxErrorType[HxErrorType["FailedToAddAttachmentToDraft"] = 20] = "FailedToAddAttachmentToDraft";
    HxErrorType[HxErrorType["FailedToSaveAutoReply"] = 21] = "FailedToSaveAutoReply";
    HxErrorType[HxErrorType["AutoReplyIsOn"] = 22] = "AutoReplyIsOn";
    HxErrorType[HxErrorType["DraftOpenInWindow"] = 23] = "DraftOpenInWindow";
    HxErrorType[HxErrorType["DraftOpenInShareWindow"] = 24] = "DraftOpenInShareWindow";
    HxErrorType[HxErrorType["SmimeNotSupportSmartReply"] = 25] = "SmimeNotSupportSmartReply";
    HxErrorType[HxErrorType["FetchingEncryptionCerts"] = 26] = "FetchingEncryptionCerts";
    HxErrorType[HxErrorType["FailedToFetchEncryptionCerts"] = 27] = "FailedToFetchEncryptionCerts";
    HxErrorType[HxErrorType["EmailRecipientInvalid"] = 28] = "EmailRecipientInvalid";
    HxErrorType[HxErrorType["DiskIsFull"] = 30] = "DiskIsFull";
    HxErrorType[HxErrorType["PopOutCantExtractIRMConversation"] = 32] = "PopOutCantExtractIRMConversation";
    HxErrorType[HxErrorType["InvalidEmailStore"] = 34] = "InvalidEmailStore";
    HxErrorType[HxErrorType["InvalidContactStore"] = 35] = "InvalidContactStore";
    HxErrorType[HxErrorType["InvalidAppointmentStore"] = 36] = "InvalidAppointmentStore";
    HxErrorType[HxErrorType["ShowMailFailure"] = 37] = "ShowMailFailure";
    HxErrorType[HxErrorType["HolidayCalendarFailure"] = 38] = "HolidayCalendarFailure";
    HxErrorType[HxErrorType["FailedToFetchHolidayCatalog"] = 39] = "FailedToFetchHolidayCatalog";
    HxErrorType[HxErrorType["DownloadMessageBodyFailed"] = 41] = "DownloadMessageBodyFailed";
    HxErrorType[HxErrorType["DownloadOriginBodyFailed"] = 42] = "DownloadOriginBodyFailed";
    HxErrorType[HxErrorType["DownloadAttachmentFailed"] = 40] = "DownloadAttachmentFailed";
    HxErrorType[HxErrorType["HxSHandshakeFailed"] = 43] = "HxSHandshakeFailed";
    HxErrorType[HxErrorType["SaveWaitOnFullMessageAndImages"] = 45] = "SaveWaitOnFullMessageAndImages";
    HxErrorType[HxErrorType["IcsEventsFailedToParse"] = 47] = "IcsEventsFailedToParse";
    HxErrorType[HxErrorType["ReadingPaneLoadMessageWhileDisconnected"] = 48] = "ReadingPaneLoadMessageWhileDisconnected";
    HxErrorType[HxErrorType["UserConsentNeededToHandoff"] = 49] = "UserConsentNeededToHandoff";
    HxErrorType[HxErrorType["UserConsentNeededToHandback"] = 50] = "UserConsentNeededToHandback";
    HxErrorType[HxErrorType["FailedToFetchFeedsCatalog"] = 51] = "FailedToFetchFeedsCatalog";
    HxErrorType[HxErrorType["MoveToAccountMismatch"] = 53] = "MoveToAccountMismatch";
    HxErrorType[HxErrorType["SaveAllAttachmentsFailed"] = 54] = "SaveAllAttachmentsFailed";
    HxErrorType[HxErrorType["JoinOnlineLinkNotYetAvailable"] = 55] = "JoinOnlineLinkNotYetAvailable";
    HxErrorType[HxErrorType["CalendarSharingCannotCompleteRequest"] = 56] = "CalendarSharingCannotCompleteRequest";
    HxErrorType[HxErrorType["CredentialsNeededForHandshake"] = 57] = "CredentialsNeededForHandshake";
    HxErrorType[HxErrorType["InvalidAppointmentTimeRange"] = 58] = "InvalidAppointmentTimeRange";
    HxErrorType[HxErrorType["ViewOutsideSyncWindow"] = 60] = "ViewOutsideSyncWindow";
    HxErrorType[HxErrorType["CannotRemoveSelectedCalendar"] = 61] = "CannotRemoveSelectedCalendar";
    HxErrorType[HxErrorType["SkypeMeetingCreated"] = 62] = "SkypeMeetingCreated";
    HxErrorType[HxErrorType["SkypeMeetingRemoved"] = 63] = "SkypeMeetingRemoved";
    HxErrorType[HxErrorType["EnableFocusedInboxFailed"] = 64] = "EnableFocusedInboxFailed";
    HxErrorType[HxErrorType["AccountDeprovisionedOnServer"] = 65] = "AccountDeprovisionedOnServer";
    HxErrorType[HxErrorType["FailedToAddOneOverSizeAttachment"] = 68] = "FailedToAddOneOverSizeAttachment";
    HxErrorType[HxErrorType["FailedToAddMoreOverSizeAttachment"] = 69] = "FailedToAddMoreOverSizeAttachment";
    HxErrorType[HxErrorType["SmimeZeroValidRecipients"] = 72] = "SmimeZeroValidRecipients";
    HxErrorType[HxErrorType["FailedToCreateRule"] = 73] = "FailedToCreateRule";
    HxErrorType[HxErrorType["FailedToUpdateRule"] = 74] = "FailedToUpdateRule";
    HxErrorType[HxErrorType["FailedToDeleteRule"] = 75] = "FailedToDeleteRule";
    HxErrorType[HxErrorType["CalendarSharingFetchCollectionFailed"] = 76] = "CalendarSharingFetchCollectionFailed";
    HxErrorType[HxErrorType["CalendarSharingFetchRecipientFailed"] = 77] = "CalendarSharingFetchRecipientFailed";
    HxErrorType[HxErrorType["CalendarSharingCreatePermissionFailed"] = 78] = "CalendarSharingCreatePermissionFailed";
    HxErrorType[HxErrorType["CalendarSharingUpdatePermissionFailed"] = 79] = "CalendarSharingUpdatePermissionFailed";
    HxErrorType[HxErrorType["CalendarSharingDeletePermissionFailed"] = 80] = "CalendarSharingDeletePermissionFailed";
    HxErrorType[HxErrorType["CalendarFeedAddSubscriptionFailed"] = 81] = "CalendarFeedAddSubscriptionFailed";
    HxErrorType[HxErrorType["CalendarFeedAddSubscriptionSuccessOneCalendar"] = 82] = "CalendarFeedAddSubscriptionSuccessOneCalendar";
    HxErrorType[HxErrorType["RemoteMailboxSyncImapError"] = 83] = "RemoteMailboxSyncImapError";
    HxErrorType[HxErrorType["FailedToFetchLocalEvents"] = 84] = "FailedToFetchLocalEvents";
    HxErrorType[HxErrorType["BadCredentialsOrProviderPOPIMAPRestriction"] = 85] = "BadCredentialsOrProviderPOPIMAPRestriction";
    HxErrorType[HxErrorType["UpgradeSuggestedCal"] = 86] = "UpgradeSuggestedCal";
    HxErrorType[HxErrorType["UpgradeRequiredMessageBar"] = 87] = "UpgradeRequiredMessageBar";
    HxErrorType[HxErrorType["UpgradeRequiredCal"] = 88] = "UpgradeRequiredCal";
    HxErrorType[HxErrorType["UpgradeRequiredMessageBarCal"] = 89] = "UpgradeRequiredMessageBarCal";
    HxErrorType[HxErrorType["CreateFolderActionFailed"] = 90] = "CreateFolderActionFailed";
    HxErrorType[HxErrorType["RenameFolderActionFailed"] = 91] = "RenameFolderActionFailed";
    HxErrorType[HxErrorType["DeleteFolderActionFailed"] = 92] = "DeleteFolderActionFailed";
    HxErrorType[HxErrorType["MoveFolderActionFailed"] = 93] = "MoveFolderActionFailed";
    HxErrorType[HxErrorType["EmptyFolderActionFailed"] = 94] = "EmptyFolderActionFailed";
    HxErrorType[HxErrorType["EmailNoRecipients"] = 95] = "EmailNoRecipients";
    HxErrorType[HxErrorType["SmimeComposeError"] = 96] = "SmimeComposeError";
    HxErrorType[HxErrorType["AttachmentsDeletionFromAppointmentFailed"] = 97] = "AttachmentsDeletionFromAppointmentFailed";
    HxErrorType[HxErrorType["GenericSaveDraftFailure"] = 98] = "GenericSaveDraftFailure";
    HxErrorType[HxErrorType["CreateScheduledFolderActionFailed"] = 99] = "CreateScheduledFolderActionFailed";
    HxErrorType[HxErrorType["MarkAsScheduledFolderActionFailed"] = 100] = "MarkAsScheduledFolderActionFailed";
    HxErrorType[HxErrorType["FailedToAddBlockedAttachment"] = 101] = "FailedToAddBlockedAttachment";
    HxErrorType[HxErrorType["LocationPermissionPrePrompt"] = 102] = "LocationPermissionPrePrompt";
    HxErrorType[HxErrorType["OnPremiseCloudCacheEasMailboxQuotaExceeded"] = 103] = "OnPremiseCloudCacheEasMailboxQuotaExceeded";
    HxErrorType[HxErrorType["OnPremiseCloudCacheEasMaximumDevicesReached"] = 104] = "OnPremiseCloudCacheEasMaximumDevicesReached";
    HxErrorType[HxErrorType["OnPremiseCloudCacheEasAccountDisabled"] = 105] = "OnPremiseCloudCacheEasAccountDisabled";
    HxErrorType[HxErrorType["OnPremiseCloudCacheEasAccountBlocked"] = 106] = "OnPremiseCloudCacheEasAccountBlocked";
    HxErrorType[HxErrorType["InDataProtectionChangeHandshake"] = 107] = "InDataProtectionChangeHandshake";
    HxErrorType[HxErrorType["FailedToAddZeroSizedAttachment"] = 108] = "FailedToAddZeroSizedAttachment";
    HxErrorType[HxErrorType["GenericCreateDraftFailure"] = 109] = "GenericCreateDraftFailure";
    HxErrorType[HxErrorType["PreviousCreateDraftFailed"] = 110] = "PreviousCreateDraftFailed";
    HxErrorType[HxErrorType["DataProtectionChangeHandshakeFailed"] = 112] = "DataProtectionChangeHandshakeFailed";
    HxErrorType[HxErrorType["MessageSizeExceeded"] = 113] = "MessageSizeExceeded";
    HxErrorType[HxErrorType["InvalidRecipient"] = 114] = "InvalidRecipient";
    HxErrorType[HxErrorType["SendQuotaExceeded"] = 115] = "SendQuotaExceeded";
    HxErrorType[HxErrorType["InvalidItemForReplyAll"] = 116] = "InvalidItemForReplyAll";
    HxErrorType[HxErrorType["InvalidItemForReply"] = 117] = "InvalidItemForReply";
    HxErrorType[HxErrorType["InvalidItemForForward"] = 118] = "InvalidItemForForward";
    HxErrorType[HxErrorType["SendAsDenied"] = 119] = "SendAsDenied";
    HxErrorType[HxErrorType["ReferencedAttachmentNotFound"] = 120] = "ReferencedAttachmentNotFound";
    HxErrorType[HxErrorType["MessageSubmissionBlocked"] = 121] = "MessageSubmissionBlocked";
    HxErrorType[HxErrorType["MessageBlocked"] = 122] = "MessageBlocked";
    HxErrorType[HxErrorType["AccountSuspend"] = 123] = "AccountSuspend";
    HxErrorType[HxErrorType["InternalServerError"] = 124] = "InternalServerError";
    HxErrorType[HxErrorType["AccessDenied"] = 125] = "AccessDenied";
    HxErrorType[HxErrorType["InvalidArgument"] = 126] = "InvalidArgument";
    HxErrorType[HxErrorType["InvalidReferenceItem"] = 127] = "InvalidReferenceItem";
    HxErrorType[HxErrorType["InvalidItemForCreateCalendarItem"] = 128] = "InvalidItemForCreateCalendarItem";
    HxErrorType[HxErrorType["CannotCreateCalendarItemInNonCalendarFolder"] = 129] = "CannotCreateCalendarItemInNonCalendarFolder";
    HxErrorType[HxErrorType["GenericCreateCalendarItemError"] = 130] = "GenericCreateCalendarItemError";
    HxErrorType[HxErrorType["PreviousCreateCalendarItemFailed"] = 131] = "PreviousCreateCalendarItemFailed";
    HxErrorType[HxErrorType["MessageSendSizeExceeded"] = 132] = "MessageSendSizeExceeded";
    HxErrorType[HxErrorType["MessageSendSizeExceededMaxKnown"] = 133] = "MessageSendSizeExceededMaxKnown";
    HxErrorType[HxErrorType["CancelSendFailed"] = 134] = "CancelSendFailed";
    HxErrorType[HxErrorType["RespondToMeetingRequestFailed"] = 135] = "RespondToMeetingRequestFailed";
    HxErrorType[HxErrorType["MailboxFull"] = 136] = "MailboxFull";
    HxErrorType[HxErrorType["UserRemovedFromSharedAccount"] = 142] = "UserRemovedFromSharedAccount";
    HxErrorType[HxErrorType["TenantAccessBlocked"] = 138] = "TenantAccessBlocked";
    HxErrorType[HxErrorType["InvalidLicense"] = 139] = "InvalidLicense";
    HxErrorType[HxErrorType["CreateCalendarActionFailed"] = 140] = "CreateCalendarActionFailed";
    HxErrorType[HxErrorType["TooManyPinnedMailMessages"] = 141] = "TooManyPinnedMailMessages";
    HxErrorType[HxErrorType["CreateArchiveFolderActionFailed"] = 143] = "CreateArchiveFolderActionFailed";
    HxErrorType[HxErrorType["RecurrenceHasNoOccurrence"] = 144] = "RecurrenceHasNoOccurrence";
    HxErrorType[HxErrorType["UpdateCalendarItemActionFailed"] = 145] = "UpdateCalendarItemActionFailed";
    HxErrorType[HxErrorType["PathNotFound"] = 146] = "PathNotFound";
    HxErrorType[HxErrorType["AuthenticationError"] = 147] = "AuthenticationError";
    HxErrorType[HxErrorType["MOPCCMailboxNotYetReady"] = 148] = "MOPCCMailboxNotYetReady";
    HxErrorType[HxErrorType["CreateViewWithEmptyNameError"] = 149] = "CreateViewWithEmptyNameError";
    HxErrorType[HxErrorType["SslCertificateError"] = 150] = "SslCertificateError";
    HxErrorType[HxErrorType["ICSFileOpenFailed"] = 151] = "ICSFileOpenFailed";
    HxErrorType[HxErrorType["ICSFileInvalidContent"] = 152] = "ICSFileInvalidContent";
    HxErrorType[HxErrorType["ICSFileUnknownException"] = 153] = "ICSFileUnknownException";
    HxErrorType[HxErrorType["MissingMandatoryMipLabel"] = 154] = "MissingMandatoryMipLabel";
    HxErrorType[HxErrorType["ICSFileCannotImportEventError"] = 155] = "ICSFileCannotImportEventError";
    HxErrorType[HxErrorType["ShouldAppendQuotedTextToBody"] = 156] = "ShouldAppendQuotedTextToBody";
    HxErrorType[HxErrorType["PreviewICSFileFailed"] = 157] = "PreviewICSFileFailed";
    HxErrorType[HxErrorType["SharedCalendarInvalidSmtpAddressError"] = 158] = "SharedCalendarInvalidSmtpAddressError";
    HxErrorType[HxErrorType["RemoteCalendarUnableToSync"] = 159] = "RemoteCalendarUnableToSync";
    HxErrorType[HxErrorType["VCFFileOpenFailed"] = 160] = "VCFFileOpenFailed";
    HxErrorType[HxErrorType["VCFFileInvalidContent"] = 161] = "VCFFileInvalidContent";
    HxErrorType[HxErrorType["VCFFileUnknownException"] = 162] = "VCFFileUnknownException";
    HxErrorType[HxErrorType["InvalidOnPremCloudCacheUri"] = 163] = "InvalidOnPremCloudCacheUri";
    HxErrorType[HxErrorType["PinActionNotSupported"] = 164] = "PinActionNotSupported";
    HxErrorType[HxErrorType["SharedCalendarAlreadyExists"] = 165] = "SharedCalendarAlreadyExists";
    HxErrorType[HxErrorType["ReportAbuseServiceUnknownError"] = 166] = "ReportAbuseServiceUnknownError";
    HxErrorType[HxErrorType["EMLFileUploadFailed"] = 172] = "EMLFileUploadFailed";
    HxErrorType[HxErrorType["OutgoingServerSslError"] = 167] = "OutgoingServerSslError";
    HxErrorType[HxErrorType["OutgoingServerAuthError"] = 168] = "OutgoingServerAuthError";
    HxErrorType[HxErrorType["OutgoingServerConfigError"] = 169] = "OutgoingServerConfigError";
    HxErrorType[HxErrorType["DownloadQuotedTextFailed"] = 170] = "DownloadQuotedTextFailed";
    HxErrorType[HxErrorType["DownloadOriginAttachmentFailed"] = 171] = "DownloadOriginAttachmentFailed";
})(HxErrorType = exports.HxErrorType || (exports.HxErrorType = {}));
function getHxErrorTypeAsString(value) {
    return HxErrorType[value];
}
exports.getHxErrorTypeAsString = getHxErrorTypeAsString;
function getHxErrorTypeFromString(value) {
    return HxErrorType[value];
}
exports.getHxErrorTypeFromString = getHxErrorTypeFromString;
/*-------------------------------------------------------------------------------
  HxSslCertificateValidation
-------------------------------------------------------------------------------*/
var HxSslCertificateValidation;
(function (HxSslCertificateValidation) {
    HxSslCertificateValidation[HxSslCertificateValidation["Default"] = 0] = "Default";
    HxSslCertificateValidation[HxSslCertificateValidation["Disabled"] = 1] = "Disabled";
})(HxSslCertificateValidation = exports.HxSslCertificateValidation || (exports.HxSslCertificateValidation = {}));
function getHxSslCertificateValidationAsString(value) {
    return HxSslCertificateValidation[value];
}
exports.getHxSslCertificateValidationAsString = getHxSslCertificateValidationAsString;
function getHxSslCertificateValidationFromString(value) {
    return HxSslCertificateValidation[value];
}
exports.getHxSslCertificateValidationFromString = getHxSslCertificateValidationFromString;
/*-------------------------------------------------------------------------------
  HxImportanceType
-------------------------------------------------------------------------------*/
var HxImportanceType;
(function (HxImportanceType) {
    HxImportanceType[HxImportanceType["NotSet"] = 3] = "NotSet";
    HxImportanceType[HxImportanceType["Low"] = 0] = "Low";
    HxImportanceType[HxImportanceType["Normal"] = 1] = "Normal";
    HxImportanceType[HxImportanceType["High"] = 2] = "High";
})(HxImportanceType = exports.HxImportanceType || (exports.HxImportanceType = {}));
function getHxImportanceTypeAsString(value) {
    return HxImportanceType[value];
}
exports.getHxImportanceTypeAsString = getHxImportanceTypeAsString;
function getHxImportanceTypeFromString(value) {
    return HxImportanceType[value];
}
exports.getHxImportanceTypeFromString = getHxImportanceTypeFromString;
/*-------------------------------------------------------------------------------
  HxDownloadStatusType
-------------------------------------------------------------------------------*/
var HxDownloadStatusType;
(function (HxDownloadStatusType) {
    HxDownloadStatusType[HxDownloadStatusType["NotDownloaded"] = 0] = "NotDownloaded";
    HxDownloadStatusType[HxDownloadStatusType["InQueue"] = 6] = "InQueue";
    HxDownloadStatusType[HxDownloadStatusType["Downloading"] = 1] = "Downloading";
    HxDownloadStatusType[HxDownloadStatusType["Downloaded"] = 2] = "Downloaded";
    HxDownloadStatusType[HxDownloadStatusType["Blocked"] = 3] = "Blocked";
    HxDownloadStatusType[HxDownloadStatusType["Failed"] = 4] = "Failed";
    HxDownloadStatusType[HxDownloadStatusType["Unknown"] = 5] = "Unknown";
    HxDownloadStatusType[HxDownloadStatusType["PartiallyDownloaded"] = 7] = "PartiallyDownloaded";
})(HxDownloadStatusType = exports.HxDownloadStatusType || (exports.HxDownloadStatusType = {}));
function getHxDownloadStatusTypeAsString(value) {
    return HxDownloadStatusType[value];
}
exports.getHxDownloadStatusTypeAsString = getHxDownloadStatusTypeAsString;
function getHxDownloadStatusTypeFromString(value) {
    return HxDownloadStatusType[value];
}
exports.getHxDownloadStatusTypeFromString = getHxDownloadStatusTypeFromString;
/*-------------------------------------------------------------------------------
  HxDownloadResultType
-------------------------------------------------------------------------------*/
var HxDownloadResultType;
(function (HxDownloadResultType) {
    HxDownloadResultType[HxDownloadResultType["Success"] = 0] = "Success";
    HxDownloadResultType[HxDownloadResultType["PermanentFailure"] = 1] = "PermanentFailure";
    HxDownloadResultType[HxDownloadResultType["RetryableFailure"] = 2] = "RetryableFailure";
    HxDownloadResultType[HxDownloadResultType["IgnoreFailure"] = 3] = "IgnoreFailure";
    HxDownloadResultType[HxDownloadResultType["None"] = 4] = "None";
    HxDownloadResultType[HxDownloadResultType["SuccessfulPartialDownload"] = 6] = "SuccessfulPartialDownload";
})(HxDownloadResultType = exports.HxDownloadResultType || (exports.HxDownloadResultType = {}));
function getHxDownloadResultTypeAsString(value) {
    return HxDownloadResultType[value];
}
exports.getHxDownloadResultTypeAsString = getHxDownloadResultTypeAsString;
function getHxDownloadResultTypeFromString(value) {
    return HxDownloadResultType[value];
}
exports.getHxDownloadResultTypeFromString = getHxDownloadResultTypeFromString;
/*-------------------------------------------------------------------------------
  HxSyncQueuePriorityType
-------------------------------------------------------------------------------*/
var HxSyncQueuePriorityType;
(function (HxSyncQueuePriorityType) {
    HxSyncQueuePriorityType[HxSyncQueuePriorityType["Foreground"] = 0] = "Foreground";
    HxSyncQueuePriorityType[HxSyncQueuePriorityType["Background"] = 1] = "Background";
})(HxSyncQueuePriorityType = exports.HxSyncQueuePriorityType || (exports.HxSyncQueuePriorityType = {}));
function getHxSyncQueuePriorityTypeAsString(value) {
    return HxSyncQueuePriorityType[value];
}
exports.getHxSyncQueuePriorityTypeAsString = getHxSyncQueuePriorityTypeAsString;
function getHxSyncQueuePriorityTypeFromString(value) {
    return HxSyncQueuePriorityType[value];
}
exports.getHxSyncQueuePriorityTypeFromString = getHxSyncQueuePriorityTypeFromString;
/*-------------------------------------------------------------------------------
  HxSendStateType
-------------------------------------------------------------------------------*/
var HxSendStateType;
(function (HxSendStateType) {
    HxSendStateType[HxSendStateType["NotSending"] = 0] = "NotSending";
    HxSendStateType[HxSendStateType["Sending"] = 11] = "Sending";
    HxSendStateType[HxSendStateType["ProviderError"] = 7] = "ProviderError";
    HxSendStateType[HxSendStateType["FatalSendError"] = 8] = "FatalSendError";
    HxSendStateType[HxSendStateType["Sent"] = 9] = "Sent";
    HxSendStateType[HxSendStateType["DeferredSend"] = 10] = "DeferredSend";
})(HxSendStateType = exports.HxSendStateType || (exports.HxSendStateType = {}));
function getHxSendStateTypeAsString(value) {
    return HxSendStateType[value];
}
exports.getHxSendStateTypeAsString = getHxSendStateTypeAsString;
function getHxSendStateTypeFromString(value) {
    return HxSendStateType[value];
}
exports.getHxSendStateTypeFromString = getHxSendStateTypeFromString;
/*-------------------------------------------------------------------------------
  HxSaveDraftStateType
-------------------------------------------------------------------------------*/
var HxSaveDraftStateType;
(function (HxSaveDraftStateType) {
    HxSaveDraftStateType[HxSaveDraftStateType["None"] = 0] = "None";
    HxSaveDraftStateType[HxSaveDraftStateType["UnsavedDraft"] = 1] = "UnsavedDraft";
    HxSaveDraftStateType[HxSaveDraftStateType["SavedDraft"] = 2] = "SavedDraft";
    HxSaveDraftStateType[HxSaveDraftStateType["ProviderError"] = 3] = "ProviderError";
    HxSaveDraftStateType[HxSaveDraftStateType["FatalSaveError"] = 4] = "FatalSaveError";
    HxSaveDraftStateType[HxSaveDraftStateType["CreateDraftError"] = 5] = "CreateDraftError";
})(HxSaveDraftStateType = exports.HxSaveDraftStateType || (exports.HxSaveDraftStateType = {}));
function getHxSaveDraftStateTypeAsString(value) {
    return HxSaveDraftStateType[value];
}
exports.getHxSaveDraftStateTypeAsString = getHxSaveDraftStateTypeAsString;
function getHxSaveDraftStateTypeFromString(value) {
    return HxSaveDraftStateType[value];
}
exports.getHxSaveDraftStateTypeFromString = getHxSaveDraftStateTypeFromString;
/*-------------------------------------------------------------------------------
  HxRecipientType
-------------------------------------------------------------------------------*/
var HxRecipientType;
(function (HxRecipientType) {
    HxRecipientType[HxRecipientType["To"] = 0] = "To";
    HxRecipientType[HxRecipientType["Cc"] = 1] = "Cc";
    HxRecipientType[HxRecipientType["Bcc"] = 2] = "Bcc";
})(HxRecipientType = exports.HxRecipientType || (exports.HxRecipientType = {}));
function getHxRecipientTypeAsString(value) {
    return HxRecipientType[value];
}
exports.getHxRecipientTypeAsString = getHxRecipientTypeAsString;
function getHxRecipientTypeFromString(value) {
    return HxRecipientType[value];
}
exports.getHxRecipientTypeFromString = getHxRecipientTypeFromString;
/*-------------------------------------------------------------------------------
  HxMeetingContentType
-------------------------------------------------------------------------------*/
var HxMeetingContentType;
(function (HxMeetingContentType) {
    HxMeetingContentType[HxMeetingContentType["None"] = 0] = "None";
    HxMeetingContentType[HxMeetingContentType["GenericMeetingContent"] = 1] = "GenericMeetingContent";
    HxMeetingContentType[HxMeetingContentType["MeetingRequest"] = 2] = "MeetingRequest";
    HxMeetingContentType[HxMeetingContentType["MeetingRequestSeries"] = 3] = "MeetingRequestSeries";
    HxMeetingContentType[HxMeetingContentType["MeetingCancellation"] = 4] = "MeetingCancellation";
    HxMeetingContentType[HxMeetingContentType["MeetingCancellationSeries"] = 5] = "MeetingCancellationSeries";
    HxMeetingContentType[HxMeetingContentType["MeetingResponseAccepted"] = 6] = "MeetingResponseAccepted";
    HxMeetingContentType[HxMeetingContentType["MeetingResponseAcceptedSeries"] = 7] = "MeetingResponseAcceptedSeries";
    HxMeetingContentType[HxMeetingContentType["MeetingResponseDeclined"] = 8] = "MeetingResponseDeclined";
    HxMeetingContentType[HxMeetingContentType["MeetingResponseDeclinedSeries"] = 9] = "MeetingResponseDeclinedSeries";
    HxMeetingContentType[HxMeetingContentType["MeetingResponseTentative"] = 10] = "MeetingResponseTentative";
    HxMeetingContentType[HxMeetingContentType["MeetingResponseTentativeSeries"] = 11] = "MeetingResponseTentativeSeries";
    HxMeetingContentType[HxMeetingContentType["MeetingForwardNotification"] = 12] = "MeetingForwardNotification";
    HxMeetingContentType[HxMeetingContentType["MeetingForwardNotificationSeries"] = 13] = "MeetingForwardNotificationSeries";
})(HxMeetingContentType = exports.HxMeetingContentType || (exports.HxMeetingContentType = {}));
function getHxMeetingContentTypeAsString(value) {
    return HxMeetingContentType[value];
}
exports.getHxMeetingContentTypeAsString = getHxMeetingContentTypeAsString;
function getHxMeetingContentTypeFromString(value) {
    return HxMeetingContentType[value];
}
exports.getHxMeetingContentTypeFromString = getHxMeetingContentTypeFromString;
/*-------------------------------------------------------------------------------
  HxOnlineSearchState
-------------------------------------------------------------------------------*/
var HxOnlineSearchState;
(function (HxOnlineSearchState) {
    HxOnlineSearchState[HxOnlineSearchState["NotStarted"] = 0] = "NotStarted";
    HxOnlineSearchState[HxOnlineSearchState["InProgress"] = 1] = "InProgress";
    HxOnlineSearchState[HxOnlineSearchState["Completed"] = 2] = "Completed";
})(HxOnlineSearchState = exports.HxOnlineSearchState || (exports.HxOnlineSearchState = {}));
function getHxOnlineSearchStateAsString(value) {
    return HxOnlineSearchState[value];
}
exports.getHxOnlineSearchStateAsString = getHxOnlineSearchStateAsString;
function getHxOnlineSearchStateFromString(value) {
    return HxOnlineSearchState[value];
}
exports.getHxOnlineSearchStateFromString = getHxOnlineSearchStateFromString;
/*-------------------------------------------------------------------------------
  HxOnlineSearchInfo
-------------------------------------------------------------------------------*/
var HxOnlineSearchInfo;
(function (HxOnlineSearchInfo) {
    HxOnlineSearchInfo[HxOnlineSearchInfo["None"] = 0] = "None";
    HxOnlineSearchInfo[HxOnlineSearchInfo["NoResults"] = 1] = "NoResults";
    HxOnlineSearchInfo[HxOnlineSearchInfo["ResultsTrimmed"] = 2] = "ResultsTrimmed";
    HxOnlineSearchInfo[HxOnlineSearchInfo["LongRunning"] = 3] = "LongRunning";
})(HxOnlineSearchInfo = exports.HxOnlineSearchInfo || (exports.HxOnlineSearchInfo = {}));
function getHxOnlineSearchInfoAsString(value) {
    return HxOnlineSearchInfo[value];
}
exports.getHxOnlineSearchInfoAsString = getHxOnlineSearchInfoAsString;
function getHxOnlineSearchInfoFromString(value) {
    return HxOnlineSearchInfo[value];
}
exports.getHxOnlineSearchInfoFromString = getHxOnlineSearchInfoFromString;
/*-------------------------------------------------------------------------------
  HxSyncFrequencyType
-------------------------------------------------------------------------------*/
var HxSyncFrequencyType;
(function (HxSyncFrequencyType) {
    HxSyncFrequencyType[HxSyncFrequencyType["Push"] = 0] = "Push";
    HxSyncFrequencyType[HxSyncFrequencyType["Poll"] = 1] = "Poll";
    HxSyncFrequencyType[HxSyncFrequencyType["Manual"] = 2] = "Manual";
    HxSyncFrequencyType[HxSyncFrequencyType["BasedOnMyUsage"] = 3] = "BasedOnMyUsage";
})(HxSyncFrequencyType = exports.HxSyncFrequencyType || (exports.HxSyncFrequencyType = {}));
function getHxSyncFrequencyTypeAsString(value) {
    return HxSyncFrequencyType[value];
}
exports.getHxSyncFrequencyTypeAsString = getHxSyncFrequencyTypeAsString;
function getHxSyncFrequencyTypeFromString(value) {
    return HxSyncFrequencyType[value];
}
exports.getHxSyncFrequencyTypeFromString = getHxSyncFrequencyTypeFromString;
/*-------------------------------------------------------------------------------
  HxConnectionType
-------------------------------------------------------------------------------*/
var HxConnectionType;
(function (HxConnectionType) {
    HxConnectionType[HxConnectionType["HttpSockets"] = 0] = "HttpSockets";
    HxConnectionType[HxConnectionType["WebSockets"] = 1] = "WebSockets";
})(HxConnectionType = exports.HxConnectionType || (exports.HxConnectionType = {}));
function getHxConnectionTypeAsString(value) {
    return HxConnectionType[value];
}
exports.getHxConnectionTypeAsString = getHxConnectionTypeAsString;
function getHxConnectionTypeFromString(value) {
    return HxConnectionType[value];
}
exports.getHxConnectionTypeFromString = getHxConnectionTypeFromString;
/*-------------------------------------------------------------------------------
  HxAccountState
-------------------------------------------------------------------------------*/
var HxAccountState;
(function (HxAccountState) {
    HxAccountState[HxAccountState["Online"] = 0] = "Online";
    HxAccountState[HxAccountState["PolicyError"] = 1] = "PolicyError";
    HxAccountState[HxAccountState["UnknownError"] = 5] = "UnknownError";
    HxAccountState[HxAccountState["Offline"] = 2] = "Offline";
    HxAccountState[HxAccountState["OfflineUserAttentionRequired"] = 3] = "OfflineUserAttentionRequired";
    HxAccountState[HxAccountState["Invalid"] = 4] = "Invalid";
    HxAccountState[HxAccountState["ClientTooOld"] = 6] = "ClientTooOld";
    HxAccountState[HxAccountState["Blocked"] = 7] = "Blocked";
    HxAccountState[HxAccountState["Quarantined"] = 8] = "Quarantined";
    HxAccountState[HxAccountState["AccessDeniedByClientAccessRule"] = 9] = "AccessDeniedByClientAccessRule";
    HxAccountState[HxAccountState["OfflineSslCertificateErrorUserConsentRequired"] = 10] = "OfflineSslCertificateErrorUserConsentRequired";
})(HxAccountState = exports.HxAccountState || (exports.HxAccountState = {}));
function getHxAccountStateAsString(value) {
    return HxAccountState[value];
}
exports.getHxAccountStateAsString = getHxAccountStateAsString;
function getHxAccountStateFromString(value) {
    return HxAccountState[value];
}
exports.getHxAccountStateFromString = getHxAccountStateFromString;
/*-------------------------------------------------------------------------------
  HxStorageAutomationCommand
-------------------------------------------------------------------------------*/
var HxStorageAutomationCommand;
(function (HxStorageAutomationCommand) {
    HxStorageAutomationCommand[HxStorageAutomationCommand["BackgroundFlush"] = 0] = "BackgroundFlush";
    HxStorageAutomationCommand[HxStorageAutomationCommand["BackgroundShrink"] = 1] = "BackgroundShrink";
})(HxStorageAutomationCommand = exports.HxStorageAutomationCommand || (exports.HxStorageAutomationCommand = {}));
function getHxStorageAutomationCommandAsString(value) {
    return HxStorageAutomationCommand[value];
}
exports.getHxStorageAutomationCommandAsString = getHxStorageAutomationCommandAsString;
function getHxStorageAutomationCommandFromString(value) {
    return HxStorageAutomationCommand[value];
}
exports.getHxStorageAutomationCommandFromString = getHxStorageAutomationCommandFromString;
/*-------------------------------------------------------------------------------
  HxMailListActionId
-------------------------------------------------------------------------------*/
var HxMailListActionId;
(function (HxMailListActionId) {
    HxMailListActionId[HxMailListActionId["ToggleFlag"] = 1] = "ToggleFlag";
    HxMailListActionId[HxMailListActionId["ToggleRead"] = 2] = "ToggleRead";
    HxMailListActionId[HxMailListActionId["Archive"] = 3] = "Archive";
    HxMailListActionId[HxMailListActionId["Delete"] = 4] = "Delete";
    HxMailListActionId[HxMailListActionId["MoveTo"] = 5] = "MoveTo";
    HxMailListActionId[HxMailListActionId["SetFlag"] = 6] = "SetFlag";
    HxMailListActionId[HxMailListActionId["ClearFlag"] = 7] = "ClearFlag";
    HxMailListActionId[HxMailListActionId["SetIsRead"] = 8] = "SetIsRead";
    HxMailListActionId[HxMailListActionId["SetIsUnread"] = 9] = "SetIsUnread";
    HxMailListActionId[HxMailListActionId["MoveToViewPreselectedPrimary"] = 12] = "MoveToViewPreselectedPrimary";
    HxMailListActionId[HxMailListActionId["MoveToViewPreselectedSecondary"] = 13] = "MoveToViewPreselectedSecondary";
    HxMailListActionId[HxMailListActionId["MoveToJunk"] = 14] = "MoveToJunk";
    HxMailListActionId[HxMailListActionId["MoveToInbox"] = 15] = "MoveToInbox";
    HxMailListActionId[HxMailListActionId["MoveToFocused"] = 16] = "MoveToFocused";
    HxMailListActionId[HxMailListActionId["MoveToOther"] = 17] = "MoveToOther";
    HxMailListActionId[HxMailListActionId["AlwaysMoveToFocused"] = 20] = "AlwaysMoveToFocused";
    HxMailListActionId[HxMailListActionId["AlwaysMoveToOther"] = 21] = "AlwaysMoveToOther";
    HxMailListActionId[HxMailListActionId["IgnoreConversation"] = 22] = "IgnoreConversation";
    HxMailListActionId[HxMailListActionId["Dismiss"] = 23] = "Dismiss";
    HxMailListActionId[HxMailListActionId["NullAction"] = 10] = "NullAction";
})(HxMailListActionId = exports.HxMailListActionId || (exports.HxMailListActionId = {}));
function getHxMailListActionIdAsString(value) {
    return HxMailListActionId[value];
}
exports.getHxMailListActionIdAsString = getHxMailListActionIdAsString;
function getHxMailListActionIdFromString(value) {
    return HxMailListActionId[value];
}
exports.getHxMailListActionIdFromString = getHxMailListActionIdFromString;
/*-------------------------------------------------------------------------------
  HxAccountDataType
-------------------------------------------------------------------------------*/
var HxAccountDataType;
(function (HxAccountDataType) {
    HxAccountDataType[HxAccountDataType["None"] = 0] = "None";
    HxAccountDataType[HxAccountDataType["Mail"] = 1] = "Mail";
    HxAccountDataType[HxAccountDataType["Calendar"] = 2] = "Calendar";
    HxAccountDataType[HxAccountDataType["Contacts"] = 4] = "Contacts";
})(HxAccountDataType = exports.HxAccountDataType || (exports.HxAccountDataType = {}));
function getHxAccountDataTypeAsString(value) {
    return HxAccountDataType[value];
}
exports.getHxAccountDataTypeAsString = getHxAccountDataTypeAsString;
function getHxAccountDataTypeFromString(value) {
    return HxAccountDataType[value];
}
exports.getHxAccountDataTypeFromString = getHxAccountDataTypeFromString;
/*-------------------------------------------------------------------------------
  HxRefreshViewStatusType
-------------------------------------------------------------------------------*/
var HxRefreshViewStatusType;
(function (HxRefreshViewStatusType) {
    HxRefreshViewStatusType[HxRefreshViewStatusType["Syncing"] = 0] = "Syncing";
    HxRefreshViewStatusType[HxRefreshViewStatusType["Failure"] = 1] = "Failure";
    HxRefreshViewStatusType[HxRefreshViewStatusType["Success"] = 2] = "Success";
    HxRefreshViewStatusType[HxRefreshViewStatusType["None"] = 3] = "None";
})(HxRefreshViewStatusType = exports.HxRefreshViewStatusType || (exports.HxRefreshViewStatusType = {}));
function getHxRefreshViewStatusTypeAsString(value) {
    return HxRefreshViewStatusType[value];
}
exports.getHxRefreshViewStatusTypeAsString = getHxRefreshViewStatusTypeAsString;
function getHxRefreshViewStatusTypeFromString(value) {
    return HxRefreshViewStatusType[value];
}
exports.getHxRefreshViewStatusTypeFromString = getHxRefreshViewStatusTypeFromString;
/*-------------------------------------------------------------------------------
  HxHandshakePhaseType
-------------------------------------------------------------------------------*/
var HxHandshakePhaseType;
(function (HxHandshakePhaseType) {
    HxHandshakePhaseType[HxHandshakePhaseType["None"] = 0] = "None";
    HxHandshakePhaseType[HxHandshakePhaseType["Start"] = 6] = "Start";
    HxHandshakePhaseType[HxHandshakePhaseType["Sync"] = 7] = "Sync";
    HxHandshakePhaseType[HxHandshakePhaseType["Switch"] = 8] = "Switch";
    HxHandshakePhaseType[HxHandshakePhaseType["Success"] = 9] = "Success";
    HxHandshakePhaseType[HxHandshakePhaseType["Suspend"] = 10] = "Suspend";
    HxHandshakePhaseType[HxHandshakePhaseType["SuspendForCredentials"] = 11] = "SuspendForCredentials";
    HxHandshakePhaseType[HxHandshakePhaseType["VerifyShadowMailboxReady"] = 12] = "VerifyShadowMailboxReady";
})(HxHandshakePhaseType = exports.HxHandshakePhaseType || (exports.HxHandshakePhaseType = {}));
function getHxHandshakePhaseTypeAsString(value) {
    return HxHandshakePhaseType[value];
}
exports.getHxHandshakePhaseTypeAsString = getHxHandshakePhaseTypeAsString;
function getHxHandshakePhaseTypeFromString(value) {
    return HxHandshakePhaseType[value];
}
exports.getHxHandshakePhaseTypeFromString = getHxHandshakePhaseTypeFromString;
/*-------------------------------------------------------------------------------
  HxHandshakeFailureType
-------------------------------------------------------------------------------*/
var HxHandshakeFailureType;
(function (HxHandshakeFailureType) {
    HxHandshakeFailureType[HxHandshakeFailureType["None"] = 0] = "None";
    HxHandshakeFailureType[HxHandshakeFailureType["Fatal"] = 2] = "Fatal";
    HxHandshakeFailureType[HxHandshakeFailureType["NotFatal"] = 3] = "NotFatal";
    HxHandshakeFailureType[HxHandshakeFailureType["Restart"] = 4] = "Restart";
})(HxHandshakeFailureType = exports.HxHandshakeFailureType || (exports.HxHandshakeFailureType = {}));
function getHxHandshakeFailureTypeAsString(value) {
    return HxHandshakeFailureType[value];
}
exports.getHxHandshakeFailureTypeAsString = getHxHandshakeFailureTypeAsString;
function getHxHandshakeFailureTypeFromString(value) {
    return HxHandshakeFailureType[value];
}
exports.getHxHandshakeFailureTypeFromString = getHxHandshakeFailureTypeFromString;
/*-------------------------------------------------------------------------------
  HxHandshakeTriggerType
-------------------------------------------------------------------------------*/
var HxHandshakeTriggerType;
(function (HxHandshakeTriggerType) {
    HxHandshakeTriggerType[HxHandshakeTriggerType["None"] = 0] = "None";
    HxHandshakeTriggerType[HxHandshakeTriggerType["OneSettings"] = 1] = "OneSettings";
    HxHandshakeTriggerType[HxHandshakeTriggerType["EDP"] = 2] = "EDP";
    HxHandshakeTriggerType[HxHandshakeTriggerType["Manual"] = 3] = "Manual";
    HxHandshakeTriggerType[HxHandshakeTriggerType["ServiceRequest"] = 4] = "ServiceRequest";
    HxHandshakeTriggerType[HxHandshakeTriggerType["HxSAccountBudget"] = 8] = "HxSAccountBudget";
    HxHandshakeTriggerType[HxHandshakeTriggerType["OffboardingToOnPrem"] = 9] = "OffboardingToOnPrem";
    HxHandshakeTriggerType[HxHandshakeTriggerType["DirectSync"] = 12] = "DirectSync";
    HxHandshakeTriggerType[HxHandshakeTriggerType["FromDirectSync"] = 13] = "FromDirectSync";
    HxHandshakeTriggerType[HxHandshakeTriggerType["HxSEDP"] = 14] = "HxSEDP";
    HxHandshakeTriggerType[HxHandshakeTriggerType["GmailCloudCacheForPaidConsumersDirect"] = 16] = "GmailCloudCacheForPaidConsumersDirect";
    HxHandshakeTriggerType[HxHandshakeTriggerType["GmailCloudCacheForPaidConsumersDevice"] = 17] = "GmailCloudCacheForPaidConsumersDevice";
    HxHandshakeTriggerType[HxHandshakeTriggerType["FromMOPCC"] = 18] = "FromMOPCC";
    HxHandshakeTriggerType[HxHandshakeTriggerType["ToMOPCC"] = 19] = "ToMOPCC";
})(HxHandshakeTriggerType = exports.HxHandshakeTriggerType || (exports.HxHandshakeTriggerType = {}));
function getHxHandshakeTriggerTypeAsString(value) {
    return HxHandshakeTriggerType[value];
}
exports.getHxHandshakeTriggerTypeAsString = getHxHandshakeTriggerTypeAsString;
function getHxHandshakeTriggerTypeFromString(value) {
    return HxHandshakeTriggerType[value];
}
exports.getHxHandshakeTriggerTypeFromString = getHxHandshakeTriggerTypeFromString;
/*-------------------------------------------------------------------------------
  HxSignatureValidationStatusType
-------------------------------------------------------------------------------*/
var HxSignatureValidationStatusType;
(function (HxSignatureValidationStatusType) {
    HxSignatureValidationStatusType[HxSignatureValidationStatusType["NoAttemptYet"] = 0] = "NoAttemptYet";
    HxSignatureValidationStatusType[HxSignatureValidationStatusType["Valid"] = 1] = "Valid";
    HxSignatureValidationStatusType[HxSignatureValidationStatusType["Invalid"] = 2] = "Invalid";
    HxSignatureValidationStatusType[HxSignatureValidationStatusType["ValidAndSignerCertificateValid"] = 3] = "ValidAndSignerCertificateValid";
    HxSignatureValidationStatusType[HxSignatureValidationStatusType["ValidButSignerCertificateExpired"] = 4] = "ValidButSignerCertificateExpired";
})(HxSignatureValidationStatusType = exports.HxSignatureValidationStatusType || (exports.HxSignatureValidationStatusType = {}));
function getHxSignatureValidationStatusTypeAsString(value) {
    return HxSignatureValidationStatusType[value];
}
exports.getHxSignatureValidationStatusTypeAsString = getHxSignatureValidationStatusTypeAsString;
function getHxSignatureValidationStatusTypeFromString(value) {
    return HxSignatureValidationStatusType[value];
}
exports.getHxSignatureValidationStatusTypeFromString = getHxSignatureValidationStatusTypeFromString;
/*-------------------------------------------------------------------------------
  HxCertificateValidationStatusType
-------------------------------------------------------------------------------*/
var HxCertificateValidationStatusType;
(function (HxCertificateValidationStatusType) {
    HxCertificateValidationStatusType[HxCertificateValidationStatusType["NoAttemptYet"] = 0] = "NoAttemptYet";
    HxCertificateValidationStatusType[HxCertificateValidationStatusType["Validating"] = 1] = "Validating";
    HxCertificateValidationStatusType[HxCertificateValidationStatusType["Valid"] = 2] = "Valid";
    HxCertificateValidationStatusType[HxCertificateValidationStatusType["UnableToValidate"] = 3] = "UnableToValidate";
    HxCertificateValidationStatusType[HxCertificateValidationStatusType["Invalid"] = 4] = "Invalid";
    HxCertificateValidationStatusType[HxCertificateValidationStatusType["Revoked"] = 5] = "Revoked";
    HxCertificateValidationStatusType[HxCertificateValidationStatusType["Mismatch"] = 6] = "Mismatch";
    HxCertificateValidationStatusType[HxCertificateValidationStatusType["Expired"] = 7] = "Expired";
    HxCertificateValidationStatusType[HxCertificateValidationStatusType["InvalidUsage"] = 8] = "InvalidUsage";
    HxCertificateValidationStatusType[HxCertificateValidationStatusType["UnableToBuildCertificateChain"] = 9] = "UnableToBuildCertificateChain";
    HxCertificateValidationStatusType[HxCertificateValidationStatusType["Untrusted"] = 10] = "Untrusted";
})(HxCertificateValidationStatusType = exports.HxCertificateValidationStatusType || (exports.HxCertificateValidationStatusType = {}));
function getHxCertificateValidationStatusTypeAsString(value) {
    return HxCertificateValidationStatusType[value];
}
exports.getHxCertificateValidationStatusTypeAsString = getHxCertificateValidationStatusTypeAsString;
function getHxCertificateValidationStatusTypeFromString(value) {
    return HxCertificateValidationStatusType[value];
}
exports.getHxCertificateValidationStatusTypeFromString = getHxCertificateValidationStatusTypeFromString;
/*-------------------------------------------------------------------------------
  HxCertificateValidationPurposeType
-------------------------------------------------------------------------------*/
var HxCertificateValidationPurposeType;
(function (HxCertificateValidationPurposeType) {
    HxCertificateValidationPurposeType[HxCertificateValidationPurposeType["Invalid"] = 4] = "Invalid";
    HxCertificateValidationPurposeType[HxCertificateValidationPurposeType["SignerCertificate"] = 0] = "SignerCertificate";
    HxCertificateValidationPurposeType[HxCertificateValidationPurposeType["EncryptionCert"] = 1] = "EncryptionCert";
    HxCertificateValidationPurposeType[HxCertificateValidationPurposeType["SelfCerts"] = 2] = "SelfCerts";
    HxCertificateValidationPurposeType[HxCertificateValidationPurposeType["ClientRequestedCertificates"] = 3] = "ClientRequestedCertificates";
})(HxCertificateValidationPurposeType = exports.HxCertificateValidationPurposeType || (exports.HxCertificateValidationPurposeType = {}));
function getHxCertificateValidationPurposeTypeAsString(value) {
    return HxCertificateValidationPurposeType[value];
}
exports.getHxCertificateValidationPurposeTypeAsString = getHxCertificateValidationPurposeTypeAsString;
function getHxCertificateValidationPurposeTypeFromString(value) {
    return HxCertificateValidationPurposeType[value];
}
exports.getHxCertificateValidationPurposeTypeFromString = getHxCertificateValidationPurposeTypeFromString;
/*-------------------------------------------------------------------------------
  HxEncryptionCertificateFetchStatusType
-------------------------------------------------------------------------------*/
var HxEncryptionCertificateFetchStatusType;
(function (HxEncryptionCertificateFetchStatusType) {
    HxEncryptionCertificateFetchStatusType[HxEncryptionCertificateFetchStatusType["NoAttemptYet"] = 0] = "NoAttemptYet";
    HxEncryptionCertificateFetchStatusType[HxEncryptionCertificateFetchStatusType["Fetching"] = 1] = "Fetching";
    HxEncryptionCertificateFetchStatusType[HxEncryptionCertificateFetchStatusType["FetchCompleted"] = 2] = "FetchCompleted";
})(HxEncryptionCertificateFetchStatusType = exports.HxEncryptionCertificateFetchStatusType || (exports.HxEncryptionCertificateFetchStatusType = {}));
function getHxEncryptionCertificateFetchStatusTypeAsString(value) {
    return HxEncryptionCertificateFetchStatusType[value];
}
exports.getHxEncryptionCertificateFetchStatusTypeAsString = getHxEncryptionCertificateFetchStatusTypeAsString;
function getHxEncryptionCertificateFetchStatusTypeFromString(value) {
    return HxEncryptionCertificateFetchStatusType[value];
}
exports.getHxEncryptionCertificateFetchStatusTypeFromString = getHxEncryptionCertificateFetchStatusTypeFromString;
/*-------------------------------------------------------------------------------
  HxSmimeReplyDraftStateType
-------------------------------------------------------------------------------*/
var HxSmimeReplyDraftStateType;
(function (HxSmimeReplyDraftStateType) {
    HxSmimeReplyDraftStateType[HxSmimeReplyDraftStateType["NotSet"] = 0] = "NotSet";
    HxSmimeReplyDraftStateType[HxSmimeReplyDraftStateType["Created"] = 1] = "Created";
    HxSmimeReplyDraftStateType[HxSmimeReplyDraftStateType["Populated"] = 2] = "Populated";
    HxSmimeReplyDraftStateType[HxSmimeReplyDraftStateType["Saved"] = 3] = "Saved";
})(HxSmimeReplyDraftStateType = exports.HxSmimeReplyDraftStateType || (exports.HxSmimeReplyDraftStateType = {}));
function getHxSmimeReplyDraftStateTypeAsString(value) {
    return HxSmimeReplyDraftStateType[value];
}
exports.getHxSmimeReplyDraftStateTypeAsString = getHxSmimeReplyDraftStateTypeAsString;
function getHxSmimeReplyDraftStateTypeFromString(value) {
    return HxSmimeReplyDraftStateType[value];
}
exports.getHxSmimeReplyDraftStateTypeFromString = getHxSmimeReplyDraftStateTypeFromString;
/*-------------------------------------------------------------------------------
  HxSmimeComposeType
-------------------------------------------------------------------------------*/
var HxSmimeComposeType;
(function (HxSmimeComposeType) {
    HxSmimeComposeType[HxSmimeComposeType["NotSet"] = 0] = "NotSet";
    HxSmimeComposeType[HxSmimeComposeType["ForSave"] = 1] = "ForSave";
    HxSmimeComposeType[HxSmimeComposeType["ForSend"] = 2] = "ForSend";
    HxSmimeComposeType[HxSmimeComposeType["Failed"] = 3] = "Failed";
})(HxSmimeComposeType = exports.HxSmimeComposeType || (exports.HxSmimeComposeType = {}));
function getHxSmimeComposeTypeAsString(value) {
    return HxSmimeComposeType[value];
}
exports.getHxSmimeComposeTypeAsString = getHxSmimeComposeTypeAsString;
function getHxSmimeComposeTypeFromString(value) {
    return HxSmimeComposeType[value];
}
exports.getHxSmimeComposeTypeFromString = getHxSmimeComposeTypeFromString;
/*-------------------------------------------------------------------------------
  HxUnpackStatusType
-------------------------------------------------------------------------------*/
var HxUnpackStatusType;
(function (HxUnpackStatusType) {
    HxUnpackStatusType[HxUnpackStatusType["NotSet"] = 0] = "NotSet";
    HxUnpackStatusType[HxUnpackStatusType["Success"] = 3] = "Success";
    HxUnpackStatusType[HxUnpackStatusType["Failure"] = 2] = "Failure";
})(HxUnpackStatusType = exports.HxUnpackStatusType || (exports.HxUnpackStatusType = {}));
function getHxUnpackStatusTypeAsString(value) {
    return HxUnpackStatusType[value];
}
exports.getHxUnpackStatusTypeAsString = getHxUnpackStatusTypeAsString;
function getHxUnpackStatusTypeFromString(value) {
    return HxUnpackStatusType[value];
}
exports.getHxUnpackStatusTypeFromString = getHxUnpackStatusTypeFromString;
/*-------------------------------------------------------------------------------
  HxSmartReplyState
-------------------------------------------------------------------------------*/
var HxSmartReplyState;
(function (HxSmartReplyState) {
    HxSmartReplyState[HxSmartReplyState["SmartReply"] = 0] = "SmartReply";
    HxSmartReplyState[HxSmartReplyState["WaitingOnDownload"] = 1] = "WaitingOnDownload";
    HxSmartReplyState[HxSmartReplyState["Downloaded"] = 2] = "Downloaded";
    HxSmartReplyState[HxSmartReplyState["FullBody"] = 3] = "FullBody";
})(HxSmartReplyState = exports.HxSmartReplyState || (exports.HxSmartReplyState = {}));
function getHxSmartReplyStateAsString(value) {
    return HxSmartReplyState[value];
}
exports.getHxSmartReplyStateAsString = getHxSmartReplyStateAsString;
function getHxSmartReplyStateFromString(value) {
    return HxSmartReplyState[value];
}
exports.getHxSmartReplyStateFromString = getHxSmartReplyStateFromString;
/*-------------------------------------------------------------------------------
  HxAlgorithmNegotiationType
-------------------------------------------------------------------------------*/
var HxAlgorithmNegotiationType;
(function (HxAlgorithmNegotiationType) {
    HxAlgorithmNegotiationType[HxAlgorithmNegotiationType["DoNotNegotiate"] = 0] = "DoNotNegotiate";
    HxAlgorithmNegotiationType[HxAlgorithmNegotiationType["NegotiateStrong"] = 1] = "NegotiateStrong";
    HxAlgorithmNegotiationType[HxAlgorithmNegotiationType["NegotiateAny"] = 2] = "NegotiateAny";
    HxAlgorithmNegotiationType[HxAlgorithmNegotiationType["NotSet"] = 3] = "NotSet";
    HxAlgorithmNegotiationType[HxAlgorithmNegotiationType["Unknown"] = 4] = "Unknown";
})(HxAlgorithmNegotiationType = exports.HxAlgorithmNegotiationType || (exports.HxAlgorithmNegotiationType = {}));
function getHxAlgorithmNegotiationTypeAsString(value) {
    return HxAlgorithmNegotiationType[value];
}
exports.getHxAlgorithmNegotiationTypeAsString = getHxAlgorithmNegotiationTypeAsString;
function getHxAlgorithmNegotiationTypeFromString(value) {
    return HxAlgorithmNegotiationType[value];
}
exports.getHxAlgorithmNegotiationTypeFromString = getHxAlgorithmNegotiationTypeFromString;
/*-------------------------------------------------------------------------------
  HxEncryptingAlgorithmType
-------------------------------------------------------------------------------*/
var HxEncryptingAlgorithmType;
(function (HxEncryptingAlgorithmType) {
    HxEncryptingAlgorithmType[HxEncryptingAlgorithmType["TripleDES"] = 0] = "TripleDES";
    HxEncryptingAlgorithmType[HxEncryptingAlgorithmType["DES"] = 1] = "DES";
    HxEncryptingAlgorithmType[HxEncryptingAlgorithmType["RC2128Bit"] = 2] = "RC2128Bit";
    HxEncryptingAlgorithmType[HxEncryptingAlgorithmType["RC264Bit"] = 3] = "RC264Bit";
    HxEncryptingAlgorithmType[HxEncryptingAlgorithmType["RC240Bit"] = 4] = "RC240Bit";
    HxEncryptingAlgorithmType[HxEncryptingAlgorithmType["NotSet"] = 5] = "NotSet";
    HxEncryptingAlgorithmType[HxEncryptingAlgorithmType["AES256"] = 6] = "AES256";
    HxEncryptingAlgorithmType[HxEncryptingAlgorithmType["AES192"] = 7] = "AES192";
    HxEncryptingAlgorithmType[HxEncryptingAlgorithmType["AES128"] = 8] = "AES128";
    HxEncryptingAlgorithmType[HxEncryptingAlgorithmType["Unknown"] = 9] = "Unknown";
})(HxEncryptingAlgorithmType = exports.HxEncryptingAlgorithmType || (exports.HxEncryptingAlgorithmType = {}));
function getHxEncryptingAlgorithmTypeAsString(value) {
    return HxEncryptingAlgorithmType[value];
}
exports.getHxEncryptingAlgorithmTypeAsString = getHxEncryptingAlgorithmTypeAsString;
function getHxEncryptingAlgorithmTypeFromString(value) {
    return HxEncryptingAlgorithmType[value];
}
exports.getHxEncryptingAlgorithmTypeFromString = getHxEncryptingAlgorithmTypeFromString;
/*-------------------------------------------------------------------------------
  HxSigningAlgorithmType
-------------------------------------------------------------------------------*/
var HxSigningAlgorithmType;
(function (HxSigningAlgorithmType) {
    HxSigningAlgorithmType[HxSigningAlgorithmType["Sha1"] = 0] = "Sha1";
    HxSigningAlgorithmType[HxSigningAlgorithmType["Md5"] = 1] = "Md5";
    HxSigningAlgorithmType[HxSigningAlgorithmType["Any"] = 2] = "Any";
    HxSigningAlgorithmType[HxSigningAlgorithmType["NotSet"] = 3] = "NotSet";
    HxSigningAlgorithmType[HxSigningAlgorithmType["Sha256"] = 4] = "Sha256";
    HxSigningAlgorithmType[HxSigningAlgorithmType["Sha384"] = 5] = "Sha384";
    HxSigningAlgorithmType[HxSigningAlgorithmType["Sha512"] = 6] = "Sha512";
    HxSigningAlgorithmType[HxSigningAlgorithmType["Unknown"] = 7] = "Unknown";
})(HxSigningAlgorithmType = exports.HxSigningAlgorithmType || (exports.HxSigningAlgorithmType = {}));
function getHxSigningAlgorithmTypeAsString(value) {
    return HxSigningAlgorithmType[value];
}
exports.getHxSigningAlgorithmTypeAsString = getHxSigningAlgorithmTypeAsString;
function getHxSigningAlgorithmTypeFromString(value) {
    return HxSigningAlgorithmType[value];
}
exports.getHxSigningAlgorithmTypeFromString = getHxSigningAlgorithmTypeFromString;
/*-------------------------------------------------------------------------------
  HxInlineStatusType
-------------------------------------------------------------------------------*/
var HxInlineStatusType;
(function (HxInlineStatusType) {
    HxInlineStatusType[HxInlineStatusType["NotInline"] = 0] = "NotInline";
    HxInlineStatusType[HxInlineStatusType["MaybeInline"] = 1] = "MaybeInline";
    HxInlineStatusType[HxInlineStatusType["Inline"] = 2] = "Inline";
    HxInlineStatusType[HxInlineStatusType["Unknown"] = 3] = "Unknown";
})(HxInlineStatusType = exports.HxInlineStatusType || (exports.HxInlineStatusType = {}));
function getHxInlineStatusTypeAsString(value) {
    return HxInlineStatusType[value];
}
exports.getHxInlineStatusTypeAsString = getHxInlineStatusTypeAsString;
function getHxInlineStatusTypeFromString(value) {
    return HxInlineStatusType[value];
}
exports.getHxInlineStatusTypeFromString = getHxInlineStatusTypeFromString;
/*-------------------------------------------------------------------------------
  HxAccentColorSetting
-------------------------------------------------------------------------------*/
var HxAccentColorSetting;
(function (HxAccentColorSetting) {
    HxAccentColorSetting[HxAccentColorSetting["Invalid"] = 12] = "Invalid";
    HxAccentColorSetting[HxAccentColorSetting["AC1"] = 0] = "AC1";
    HxAccentColorSetting[HxAccentColorSetting["AC2"] = 1] = "AC2";
    HxAccentColorSetting[HxAccentColorSetting["AC3"] = 2] = "AC3";
    HxAccentColorSetting[HxAccentColorSetting["AC4"] = 3] = "AC4";
    HxAccentColorSetting[HxAccentColorSetting["AC5"] = 4] = "AC5";
    HxAccentColorSetting[HxAccentColorSetting["AC6"] = 6] = "AC6";
    HxAccentColorSetting[HxAccentColorSetting["AC7"] = 7] = "AC7";
    HxAccentColorSetting[HxAccentColorSetting["AC8"] = 8] = "AC8";
    HxAccentColorSetting[HxAccentColorSetting["AC9"] = 9] = "AC9";
    HxAccentColorSetting[HxAccentColorSetting["AC10"] = 10] = "AC10";
    HxAccentColorSetting[HxAccentColorSetting["AC11"] = 11] = "AC11";
    HxAccentColorSetting[HxAccentColorSetting["System"] = 5] = "System";
})(HxAccentColorSetting = exports.HxAccentColorSetting || (exports.HxAccentColorSetting = {}));
function getHxAccentColorSettingAsString(value) {
    return HxAccentColorSetting[value];
}
exports.getHxAccentColorSettingAsString = getHxAccentColorSettingAsString;
function getHxAccentColorSettingFromString(value) {
    return HxAccentColorSetting[value];
}
exports.getHxAccentColorSettingFromString = getHxAccentColorSettingFromString;
/*-------------------------------------------------------------------------------
  HxThemeSetting
-------------------------------------------------------------------------------*/
var HxThemeSetting;
(function (HxThemeSetting) {
    HxThemeSetting[HxThemeSetting["Invalid"] = 6] = "Invalid";
    HxThemeSetting[HxThemeSetting["Light"] = 0] = "Light";
    HxThemeSetting[HxThemeSetting["Dark"] = 1] = "Dark";
    HxThemeSetting[HxThemeSetting["System"] = 3] = "System";
})(HxThemeSetting = exports.HxThemeSetting || (exports.HxThemeSetting = {}));
function getHxThemeSettingAsString(value) {
    return HxThemeSetting[value];
}
exports.getHxThemeSettingAsString = getHxThemeSettingAsString;
function getHxThemeSettingFromString(value) {
    return HxThemeSetting[value];
}
exports.getHxThemeSettingFromString = getHxThemeSettingFromString;
/*-------------------------------------------------------------------------------
  HxBackgroundModeSetting
-------------------------------------------------------------------------------*/
var HxBackgroundModeSetting;
(function (HxBackgroundModeSetting) {
    HxBackgroundModeSetting[HxBackgroundModeSetting["Invalid"] = 2] = "Invalid";
    HxBackgroundModeSetting[HxBackgroundModeSetting["HalfScreen"] = 0] = "HalfScreen";
    HxBackgroundModeSetting[HxBackgroundModeSetting["FullScreen"] = 1] = "FullScreen";
})(HxBackgroundModeSetting = exports.HxBackgroundModeSetting || (exports.HxBackgroundModeSetting = {}));
function getHxBackgroundModeSettingAsString(value) {
    return HxBackgroundModeSetting[value];
}
exports.getHxBackgroundModeSettingAsString = getHxBackgroundModeSettingAsString;
function getHxBackgroundModeSettingFromString(value) {
    return HxBackgroundModeSetting[value];
}
exports.getHxBackgroundModeSettingFromString = getHxBackgroundModeSettingFromString;
/*-------------------------------------------------------------------------------
  HxBackgroundImageSetting
-------------------------------------------------------------------------------*/
var HxBackgroundImageSetting;
(function (HxBackgroundImageSetting) {
    HxBackgroundImageSetting[HxBackgroundImageSetting["Invalid"] = 10] = "Invalid";
    HxBackgroundImageSetting[HxBackgroundImageSetting["None"] = 0] = "None";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Bkgr1"] = 2] = "Bkgr1";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Bkgr1a"] = 9] = "Bkgr1a";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Bkgr2"] = 3] = "Bkgr2";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Bkgr3"] = 4] = "Bkgr3";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Bkgr4"] = 5] = "Bkgr4";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Bkgr5"] = 6] = "Bkgr5";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Bkgr6"] = 7] = "Bkgr6";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Bkgr7"] = 8] = "Bkgr7";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Custom"] = 1] = "Custom";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Bkgr8"] = 11] = "Bkgr8";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Bkgr9"] = 12] = "Bkgr9";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Bkgr10"] = 13] = "Bkgr10";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Bkgr11"] = 14] = "Bkgr11";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Bkgr12"] = 15] = "Bkgr12";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Bkgr13"] = 16] = "Bkgr13";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Bkgr14"] = 17] = "Bkgr14";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Bkgr15"] = 18] = "Bkgr15";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Bkgr16"] = 19] = "Bkgr16";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Bkgr17"] = 20] = "Bkgr17";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Bkgr18"] = 21] = "Bkgr18";
    HxBackgroundImageSetting[HxBackgroundImageSetting["Bkgr19"] = 22] = "Bkgr19";
})(HxBackgroundImageSetting = exports.HxBackgroundImageSetting || (exports.HxBackgroundImageSetting = {}));
function getHxBackgroundImageSettingAsString(value) {
    return HxBackgroundImageSetting[value];
}
exports.getHxBackgroundImageSettingAsString = getHxBackgroundImageSettingAsString;
function getHxBackgroundImageSettingFromString(value) {
    return HxBackgroundImageSetting[value];
}
exports.getHxBackgroundImageSettingFromString = getHxBackgroundImageSettingFromString;
/*-------------------------------------------------------------------------------
  HxBackgroundImageDarknessValue
-------------------------------------------------------------------------------*/
var HxBackgroundImageDarknessValue;
(function (HxBackgroundImageDarknessValue) {
    HxBackgroundImageDarknessValue[HxBackgroundImageDarknessValue["Light"] = 0] = "Light";
    HxBackgroundImageDarknessValue[HxBackgroundImageDarknessValue["Dark"] = 1] = "Dark";
    HxBackgroundImageDarknessValue[HxBackgroundImageDarknessValue["NeedsAnalysis"] = 2] = "NeedsAnalysis";
})(HxBackgroundImageDarknessValue = exports.HxBackgroundImageDarknessValue || (exports.HxBackgroundImageDarknessValue = {}));
function getHxBackgroundImageDarknessValueAsString(value) {
    return HxBackgroundImageDarknessValue[value];
}
exports.getHxBackgroundImageDarknessValueAsString = getHxBackgroundImageDarknessValueAsString;
function getHxBackgroundImageDarknessValueFromString(value) {
    return HxBackgroundImageDarknessValue[value];
}
exports.getHxBackgroundImageDarknessValueFromString = getHxBackgroundImageDarknessValueFromString;
/*-------------------------------------------------------------------------------
  HxResizeImageToSizeSetting
-------------------------------------------------------------------------------*/
var HxResizeImageToSizeSetting;
(function (HxResizeImageToSizeSetting) {
    HxResizeImageToSizeSetting[HxResizeImageToSizeSetting["None"] = 0] = "None";
    HxResizeImageToSizeSetting[HxResizeImageToSizeSetting["Large"] = 1] = "Large";
    HxResizeImageToSizeSetting[HxResizeImageToSizeSetting["Medium"] = 2] = "Medium";
    HxResizeImageToSizeSetting[HxResizeImageToSizeSetting["Small"] = 3] = "Small";
    HxResizeImageToSizeSetting[HxResizeImageToSizeSetting["ExtraSmall"] = 4] = "ExtraSmall";
})(HxResizeImageToSizeSetting = exports.HxResizeImageToSizeSetting || (exports.HxResizeImageToSizeSetting = {}));
function getHxResizeImageToSizeSettingAsString(value) {
    return HxResizeImageToSizeSetting[value];
}
exports.getHxResizeImageToSizeSettingAsString = getHxResizeImageToSizeSettingAsString;
function getHxResizeImageToSizeSettingFromString(value) {
    return HxResizeImageToSizeSetting[value];
}
exports.getHxResizeImageToSizeSettingFromString = getHxResizeImageToSizeSettingFromString;
/*-------------------------------------------------------------------------------
  HxApplyAllAccountsLocalSettingsMap
-------------------------------------------------------------------------------*/
var HxApplyAllAccountsLocalSettingsMap;
(function (HxApplyAllAccountsLocalSettingsMap) {
    HxApplyAllAccountsLocalSettingsMap[HxApplyAllAccountsLocalSettingsMap["None"] = 0] = "None";
    HxApplyAllAccountsLocalSettingsMap[HxApplyAllAccountsLocalSettingsMap["QuickActions"] = 1] = "QuickActions";
    HxApplyAllAccountsLocalSettingsMap[HxApplyAllAccountsLocalSettingsMap["Signature"] = 2] = "Signature";
    HxApplyAllAccountsLocalSettingsMap[HxApplyAllAccountsLocalSettingsMap["Notifications"] = 4] = "Notifications";
    HxApplyAllAccountsLocalSettingsMap[HxApplyAllAccountsLocalSettingsMap["ViewMode"] = 8] = "ViewMode";
    HxApplyAllAccountsLocalSettingsMap[HxApplyAllAccountsLocalSettingsMap["ExternalContent"] = 16] = "ExternalContent";
    HxApplyAllAccountsLocalSettingsMap[HxApplyAllAccountsLocalSettingsMap["DefaultFont"] = 32] = "DefaultFont";
})(HxApplyAllAccountsLocalSettingsMap = exports.HxApplyAllAccountsLocalSettingsMap || (exports.HxApplyAllAccountsLocalSettingsMap = {}));
function getHxApplyAllAccountsLocalSettingsMapAsString(value) {
    return HxApplyAllAccountsLocalSettingsMap[value];
}
exports.getHxApplyAllAccountsLocalSettingsMapAsString = getHxApplyAllAccountsLocalSettingsMapAsString;
function getHxApplyAllAccountsLocalSettingsMapFromString(value) {
    return HxApplyAllAccountsLocalSettingsMap[value];
}
exports.getHxApplyAllAccountsLocalSettingsMapFromString = getHxApplyAllAccountsLocalSettingsMapFromString;
/*-------------------------------------------------------------------------------
  HxNullableBoolType
-------------------------------------------------------------------------------*/
var HxNullableBoolType;
(function (HxNullableBoolType) {
    HxNullableBoolType[HxNullableBoolType["Unset"] = 0] = "Unset";
    HxNullableBoolType[HxNullableBoolType["True"] = 1] = "True";
    HxNullableBoolType[HxNullableBoolType["False"] = 2] = "False";
})(HxNullableBoolType = exports.HxNullableBoolType || (exports.HxNullableBoolType = {}));
function getHxNullableBoolTypeAsString(value) {
    return HxNullableBoolType[value];
}
exports.getHxNullableBoolTypeAsString = getHxNullableBoolTypeAsString;
function getHxNullableBoolTypeFromString(value) {
    return HxNullableBoolType[value];
}
exports.getHxNullableBoolTypeFromString = getHxNullableBoolTypeFromString;
/*-------------------------------------------------------------------------------
  HxNotificationGroupingState
-------------------------------------------------------------------------------*/
var HxNotificationGroupingState;
(function (HxNotificationGroupingState) {
    HxNotificationGroupingState[HxNotificationGroupingState["NotSet"] = 0] = "NotSet";
    HxNotificationGroupingState[HxNotificationGroupingState["DoNotShow"] = 1] = "DoNotShow";
    HxNotificationGroupingState[HxNotificationGroupingState["ShowNotConfigured"] = 2] = "ShowNotConfigured";
    HxNotificationGroupingState[HxNotificationGroupingState["ShowAlreadyConfigured"] = 3] = "ShowAlreadyConfigured";
})(HxNotificationGroupingState = exports.HxNotificationGroupingState || (exports.HxNotificationGroupingState = {}));
function getHxNotificationGroupingStateAsString(value) {
    return HxNotificationGroupingState[value];
}
exports.getHxNotificationGroupingStateAsString = getHxNotificationGroupingStateAsString;
function getHxNotificationGroupingStateFromString(value) {
    return HxNotificationGroupingState[value];
}
exports.getHxNotificationGroupingStateFromString = getHxNotificationGroupingStateFromString;
/*-------------------------------------------------------------------------------
  HxMailWindowDeleteActionType
-------------------------------------------------------------------------------*/
var HxMailWindowDeleteActionType;
(function (HxMailWindowDeleteActionType) {
    HxMailWindowDeleteActionType[HxMailWindowDeleteActionType["DeleteNone"] = 0] = "DeleteNone";
    HxMailWindowDeleteActionType[HxMailWindowDeleteActionType["DeleteAllButOne"] = 1] = "DeleteAllButOne";
    HxMailWindowDeleteActionType[HxMailWindowDeleteActionType["DeleteAll"] = 2] = "DeleteAll";
})(HxMailWindowDeleteActionType = exports.HxMailWindowDeleteActionType || (exports.HxMailWindowDeleteActionType = {}));
function getHxMailWindowDeleteActionTypeAsString(value) {
    return HxMailWindowDeleteActionType[value];
}
exports.getHxMailWindowDeleteActionTypeAsString = getHxMailWindowDeleteActionTypeAsString;
function getHxMailWindowDeleteActionTypeFromString(value) {
    return HxMailWindowDeleteActionType[value];
}
exports.getHxMailWindowDeleteActionTypeFromString = getHxMailWindowDeleteActionTypeFromString;
/*-------------------------------------------------------------------------------
  HxConversationClassificationType
-------------------------------------------------------------------------------*/
var HxConversationClassificationType;
(function (HxConversationClassificationType) {
    HxConversationClassificationType[HxConversationClassificationType["None"] = 0] = "None";
    HxConversationClassificationType[HxConversationClassificationType["Focused"] = 1] = "Focused";
    HxConversationClassificationType[HxConversationClassificationType["Other"] = 2] = "Other";
})(HxConversationClassificationType = exports.HxConversationClassificationType || (exports.HxConversationClassificationType = {}));
function getHxConversationClassificationTypeAsString(value) {
    return HxConversationClassificationType[value];
}
exports.getHxConversationClassificationTypeAsString = getHxConversationClassificationTypeAsString;
function getHxConversationClassificationTypeFromString(value) {
    return HxConversationClassificationType[value];
}
exports.getHxConversationClassificationTypeFromString = getHxConversationClassificationTypeFromString;
/*-------------------------------------------------------------------------------
  HxMarkAsReadSetting
-------------------------------------------------------------------------------*/
var HxMarkAsReadSetting;
(function (HxMarkAsReadSetting) {
    HxMarkAsReadSetting[HxMarkAsReadSetting["Invalid"] = 3] = "Invalid";
    HxMarkAsReadSetting[HxMarkAsReadSetting["SelectionChanged"] = 0] = "SelectionChanged";
    HxMarkAsReadSetting[HxMarkAsReadSetting["Off"] = 1] = "Off";
    HxMarkAsReadSetting[HxMarkAsReadSetting["Viewed"] = 2] = "Viewed";
})(HxMarkAsReadSetting = exports.HxMarkAsReadSetting || (exports.HxMarkAsReadSetting = {}));
function getHxMarkAsReadSettingAsString(value) {
    return HxMarkAsReadSetting[value];
}
exports.getHxMarkAsReadSettingAsString = getHxMarkAsReadSettingAsString;
function getHxMarkAsReadSettingFromString(value) {
    return HxMarkAsReadSetting[value];
}
exports.getHxMarkAsReadSettingFromString = getHxMarkAsReadSettingFromString;
/*-------------------------------------------------------------------------------
  HxOneRMSurfaceArea
-------------------------------------------------------------------------------*/
var HxOneRMSurfaceArea;
(function (HxOneRMSurfaceArea) {
    HxOneRMSurfaceArea[HxOneRMSurfaceArea["None"] = 0] = "None";
    HxOneRMSurfaceArea[HxOneRMSurfaceArea["ModalDialog"] = 1] = "ModalDialog";
    HxOneRMSurfaceArea[HxOneRMSurfaceArea["AnchoredToSettingsButton"] = 2] = "AnchoredToSettingsButton";
})(HxOneRMSurfaceArea = exports.HxOneRMSurfaceArea || (exports.HxOneRMSurfaceArea = {}));
function getHxOneRMSurfaceAreaAsString(value) {
    return HxOneRMSurfaceArea[value];
}
exports.getHxOneRMSurfaceAreaAsString = getHxOneRMSurfaceAreaAsString;
function getHxOneRMSurfaceAreaFromString(value) {
    return HxOneRMSurfaceArea[value];
}
exports.getHxOneRMSurfaceAreaFromString = getHxOneRMSurfaceAreaFromString;
/*-------------------------------------------------------------------------------
  HxDraftDirtyStateFlags
-------------------------------------------------------------------------------*/
var HxDraftDirtyStateFlags;
(function (HxDraftDirtyStateFlags) {
    HxDraftDirtyStateFlags[HxDraftDirtyStateFlags["None"] = 0] = "None";
    HxDraftDirtyStateFlags[HxDraftDirtyStateFlags["SubjectDirty"] = 1] = "SubjectDirty";
    HxDraftDirtyStateFlags[HxDraftDirtyStateFlags["BodyDirty"] = 2] = "BodyDirty";
    HxDraftDirtyStateFlags[HxDraftDirtyStateFlags["AttachmentsDirty"] = 4] = "AttachmentsDirty";
    HxDraftDirtyStateFlags[HxDraftDirtyStateFlags["ToRecipientsDirty"] = 8] = "ToRecipientsDirty";
    HxDraftDirtyStateFlags[HxDraftDirtyStateFlags["CcRecipientsDirty"] = 16] = "CcRecipientsDirty";
    HxDraftDirtyStateFlags[HxDraftDirtyStateFlags["BccRecipientsDirty"] = 32] = "BccRecipientsDirty";
    HxDraftDirtyStateFlags[HxDraftDirtyStateFlags["ImportanceDirty"] = 64] = "ImportanceDirty";
    HxDraftDirtyStateFlags[HxDraftDirtyStateFlags["SignedDirty"] = 128] = "SignedDirty";
    HxDraftDirtyStateFlags[HxDraftDirtyStateFlags["EncryptedDirty"] = 256] = "EncryptedDirty";
    HxDraftDirtyStateFlags[HxDraftDirtyStateFlags["IRMDirty"] = 1024] = "IRMDirty";
    HxDraftDirtyStateFlags[HxDraftDirtyStateFlags["MipLabelDirty"] = 2048] = "MipLabelDirty";
    HxDraftDirtyStateFlags[HxDraftDirtyStateFlags["SenderEmailDirty"] = 4096] = "SenderEmailDirty";
    HxDraftDirtyStateFlags[HxDraftDirtyStateFlags["RequestReadReceiptDirty"] = 8192] = "RequestReadReceiptDirty";
    HxDraftDirtyStateFlags[HxDraftDirtyStateFlags["RequestDeliveryReceiptDirty"] = 16384] = "RequestDeliveryReceiptDirty";
})(HxDraftDirtyStateFlags = exports.HxDraftDirtyStateFlags || (exports.HxDraftDirtyStateFlags = {}));
function getHxDraftDirtyStateFlagsAsString(value) {
    return HxDraftDirtyStateFlags[value];
}
exports.getHxDraftDirtyStateFlagsAsString = getHxDraftDirtyStateFlagsAsString;
function getHxDraftDirtyStateFlagsFromString(value) {
    return HxDraftDirtyStateFlags[value];
}
exports.getHxDraftDirtyStateFlagsFromString = getHxDraftDirtyStateFlagsFromString;
/*-------------------------------------------------------------------------------
  HxSharingAction
-------------------------------------------------------------------------------*/
var HxSharingAction;
(function (HxSharingAction) {
    HxSharingAction[HxSharingAction["Unknown"] = 4] = "Unknown";
    HxSharingAction[HxSharingAction["AcceptAndViewCalendar"] = 0] = "AcceptAndViewCalendar";
    HxSharingAction[HxSharingAction["ViewCalendar"] = 1] = "ViewCalendar";
    HxSharingAction[HxSharingAction["AddThisCalendar"] = 2] = "AddThisCalendar";
    HxSharingAction[HxSharingAction["Accept"] = 3] = "Accept";
})(HxSharingAction = exports.HxSharingAction || (exports.HxSharingAction = {}));
function getHxSharingActionAsString(value) {
    return HxSharingAction[value];
}
exports.getHxSharingActionAsString = getHxSharingActionAsString;
function getHxSharingActionFromString(value) {
    return HxSharingAction[value];
}
exports.getHxSharingActionFromString = getHxSharingActionFromString;
/*-------------------------------------------------------------------------------
  HxSharingActionType
-------------------------------------------------------------------------------*/
var HxSharingActionType;
(function (HxSharingActionType) {
    HxSharingActionType[HxSharingActionType["None"] = 0] = "None";
    HxSharingActionType[HxSharingActionType["Accept"] = 1] = "Accept";
})(HxSharingActionType = exports.HxSharingActionType || (exports.HxSharingActionType = {}));
function getHxSharingActionTypeAsString(value) {
    return HxSharingActionType[value];
}
exports.getHxSharingActionTypeAsString = getHxSharingActionTypeAsString;
function getHxSharingActionTypeFromString(value) {
    return HxSharingActionType[value];
}
exports.getHxSharingActionTypeFromString = getHxSharingActionTypeFromString;
/*-------------------------------------------------------------------------------
  HxSharingActionImportance
-------------------------------------------------------------------------------*/
var HxSharingActionImportance;
(function (HxSharingActionImportance) {
    HxSharingActionImportance[HxSharingActionImportance["Unknown"] = 2] = "Unknown";
    HxSharingActionImportance[HxSharingActionImportance["Primary"] = 0] = "Primary";
    HxSharingActionImportance[HxSharingActionImportance["Secondary"] = 1] = "Secondary";
})(HxSharingActionImportance = exports.HxSharingActionImportance || (exports.HxSharingActionImportance = {}));
function getHxSharingActionImportanceAsString(value) {
    return HxSharingActionImportance[value];
}
exports.getHxSharingActionImportanceAsString = getHxSharingActionImportanceAsString;
function getHxSharingActionImportanceFromString(value) {
    return HxSharingActionImportance[value];
}
exports.getHxSharingActionImportanceFromString = getHxSharingActionImportanceFromString;
/*-------------------------------------------------------------------------------
  HxNotificationSettingsDefaultVersion
-------------------------------------------------------------------------------*/
var HxNotificationSettingsDefaultVersion;
(function (HxNotificationSettingsDefaultVersion) {
    HxNotificationSettingsDefaultVersion[HxNotificationSettingsDefaultVersion["OffByDefault"] = 0] = "OffByDefault";
    HxNotificationSettingsDefaultVersion[HxNotificationSettingsDefaultVersion["BannerByDefault"] = 1] = "BannerByDefault";
})(HxNotificationSettingsDefaultVersion = exports.HxNotificationSettingsDefaultVersion || (exports.HxNotificationSettingsDefaultVersion = {}));
function getHxNotificationSettingsDefaultVersionAsString(value) {
    return HxNotificationSettingsDefaultVersion[value];
}
exports.getHxNotificationSettingsDefaultVersionAsString = getHxNotificationSettingsDefaultVersionAsString;
function getHxNotificationSettingsDefaultVersionFromString(value) {
    return HxNotificationSettingsDefaultVersion[value];
}
exports.getHxNotificationSettingsDefaultVersionFromString = getHxNotificationSettingsDefaultVersionFromString;
/*-------------------------------------------------------------------------------
  HxCalendarSharingDetailLevelType
-------------------------------------------------------------------------------*/
var HxCalendarSharingDetailLevelType;
(function (HxCalendarSharingDetailLevelType) {
    HxCalendarSharingDetailLevelType[HxCalendarSharingDetailLevelType["Disabled"] = 0] = "Disabled";
    HxCalendarSharingDetailLevelType[HxCalendarSharingDetailLevelType["AvailabilityOnly"] = 1] = "AvailabilityOnly";
    HxCalendarSharingDetailLevelType[HxCalendarSharingDetailLevelType["LimitedDetails"] = 2] = "LimitedDetails";
    HxCalendarSharingDetailLevelType[HxCalendarSharingDetailLevelType["FullDetails"] = 3] = "FullDetails";
    HxCalendarSharingDetailLevelType[HxCalendarSharingDetailLevelType["Editor"] = 4] = "Editor";
    HxCalendarSharingDetailLevelType[HxCalendarSharingDetailLevelType["Delegate"] = 5] = "Delegate";
    HxCalendarSharingDetailLevelType[HxCalendarSharingDetailLevelType["Custom"] = 6] = "Custom";
})(HxCalendarSharingDetailLevelType = exports.HxCalendarSharingDetailLevelType || (exports.HxCalendarSharingDetailLevelType = {}));
function getHxCalendarSharingDetailLevelTypeAsString(value) {
    return HxCalendarSharingDetailLevelType[value];
}
exports.getHxCalendarSharingDetailLevelTypeAsString = getHxCalendarSharingDetailLevelTypeAsString;
function getHxCalendarSharingDetailLevelTypeFromString(value) {
    return HxCalendarSharingDetailLevelType[value];
}
exports.getHxCalendarSharingDetailLevelTypeFromString = getHxCalendarSharingDetailLevelTypeFromString;
/*-------------------------------------------------------------------------------
  HxDeliverMeetingRequestsType
-------------------------------------------------------------------------------*/
var HxDeliverMeetingRequestsType;
(function (HxDeliverMeetingRequestsType) {
    HxDeliverMeetingRequestsType[HxDeliverMeetingRequestsType["None"] = 0] = "None";
    HxDeliverMeetingRequestsType[HxDeliverMeetingRequestsType["DelegatesOnly"] = 1] = "DelegatesOnly";
    HxDeliverMeetingRequestsType[HxDeliverMeetingRequestsType["DelegatesAndMe"] = 2] = "DelegatesAndMe";
    HxDeliverMeetingRequestsType[HxDeliverMeetingRequestsType["DelegatesAndSendInformationToMe"] = 3] = "DelegatesAndSendInformationToMe";
    HxDeliverMeetingRequestsType[HxDeliverMeetingRequestsType["NoForward"] = 4] = "NoForward";
})(HxDeliverMeetingRequestsType = exports.HxDeliverMeetingRequestsType || (exports.HxDeliverMeetingRequestsType = {}));
function getHxDeliverMeetingRequestsTypeAsString(value) {
    return HxDeliverMeetingRequestsType[value];
}
exports.getHxDeliverMeetingRequestsTypeAsString = getHxDeliverMeetingRequestsTypeAsString;
function getHxDeliverMeetingRequestsTypeFromString(value) {
    return HxDeliverMeetingRequestsType[value];
}
exports.getHxDeliverMeetingRequestsTypeFromString = getHxDeliverMeetingRequestsTypeFromString;
/*-------------------------------------------------------------------------------
  HxMailboxDeprovisionStatusType
-------------------------------------------------------------------------------*/
var HxMailboxDeprovisionStatusType;
(function (HxMailboxDeprovisionStatusType) {
    HxMailboxDeprovisionStatusType[HxMailboxDeprovisionStatusType["None"] = 0] = "None";
    HxMailboxDeprovisionStatusType[HxMailboxDeprovisionStatusType["DeprovisionStarted"] = 3] = "DeprovisionStarted";
    HxMailboxDeprovisionStatusType[HxMailboxDeprovisionStatusType["DeprovisionSuccess"] = 1] = "DeprovisionSuccess";
    HxMailboxDeprovisionStatusType[HxMailboxDeprovisionStatusType["DeprovisionFailed"] = 2] = "DeprovisionFailed";
})(HxMailboxDeprovisionStatusType = exports.HxMailboxDeprovisionStatusType || (exports.HxMailboxDeprovisionStatusType = {}));
function getHxMailboxDeprovisionStatusTypeAsString(value) {
    return HxMailboxDeprovisionStatusType[value];
}
exports.getHxMailboxDeprovisionStatusTypeAsString = getHxMailboxDeprovisionStatusTypeAsString;
function getHxMailboxDeprovisionStatusTypeFromString(value) {
    return HxMailboxDeprovisionStatusType[value];
}
exports.getHxMailboxDeprovisionStatusTypeFromString = getHxMailboxDeprovisionStatusTypeFromString;
/*-------------------------------------------------------------------------------
  HxTruncatedStateType
-------------------------------------------------------------------------------*/
var HxTruncatedStateType;
(function (HxTruncatedStateType) {
    HxTruncatedStateType[HxTruncatedStateType["Unknown"] = 0] = "Unknown";
    HxTruncatedStateType[HxTruncatedStateType["Truncated"] = 1] = "Truncated";
    HxTruncatedStateType[HxTruncatedStateType["Full"] = 2] = "Full";
})(HxTruncatedStateType = exports.HxTruncatedStateType || (exports.HxTruncatedStateType = {}));
function getHxTruncatedStateTypeAsString(value) {
    return HxTruncatedStateType[value];
}
exports.getHxTruncatedStateTypeAsString = getHxTruncatedStateTypeAsString;
function getHxTruncatedStateTypeFromString(value) {
    return HxTruncatedStateType[value];
}
exports.getHxTruncatedStateTypeFromString = getHxTruncatedStateTypeFromString;
/*-------------------------------------------------------------------------------
  HxUnistoreNotificationSource
-------------------------------------------------------------------------------*/
var HxUnistoreNotificationSource;
(function (HxUnistoreNotificationSource) {
    HxUnistoreNotificationSource[HxUnistoreNotificationSource["Appointments"] = 0] = "Appointments";
    HxUnistoreNotificationSource[HxUnistoreNotificationSource["Contacts"] = 1] = "Contacts";
    HxUnistoreNotificationSource[HxUnistoreNotificationSource["Email"] = 2] = "Email";
})(HxUnistoreNotificationSource = exports.HxUnistoreNotificationSource || (exports.HxUnistoreNotificationSource = {}));
function getHxUnistoreNotificationSourceAsString(value) {
    return HxUnistoreNotificationSource[value];
}
exports.getHxUnistoreNotificationSourceAsString = getHxUnistoreNotificationSourceAsString;
function getHxUnistoreNotificationSourceFromString(value) {
    return HxUnistoreNotificationSource[value];
}
exports.getHxUnistoreNotificationSourceFromString = getHxUnistoreNotificationSourceFromString;
/*-------------------------------------------------------------------------------
  HxMoveToPreselectedOption
-------------------------------------------------------------------------------*/
var HxMoveToPreselectedOption;
(function (HxMoveToPreselectedOption) {
    HxMoveToPreselectedOption[HxMoveToPreselectedOption["Primary"] = 0] = "Primary";
    HxMoveToPreselectedOption[HxMoveToPreselectedOption["Secondary"] = 1] = "Secondary";
    HxMoveToPreselectedOption[HxMoveToPreselectedOption["Inbox"] = 2] = "Inbox";
    HxMoveToPreselectedOption[HxMoveToPreselectedOption["Junk"] = 3] = "Junk";
})(HxMoveToPreselectedOption = exports.HxMoveToPreselectedOption || (exports.HxMoveToPreselectedOption = {}));
function getHxMoveToPreselectedOptionAsString(value) {
    return HxMoveToPreselectedOption[value];
}
exports.getHxMoveToPreselectedOptionAsString = getHxMoveToPreselectedOptionAsString;
function getHxMoveToPreselectedOptionFromString(value) {
    return HxMoveToPreselectedOption[value];
}
exports.getHxMoveToPreselectedOptionFromString = getHxMoveToPreselectedOptionFromString;
/*-------------------------------------------------------------------------------
  HxScheduleStatusType
-------------------------------------------------------------------------------*/
var HxScheduleStatusType;
(function (HxScheduleStatusType) {
    HxScheduleStatusType[HxScheduleStatusType["None"] = 0] = "None";
    HxScheduleStatusType[HxScheduleStatusType["Scheduled"] = 1] = "Scheduled";
    HxScheduleStatusType[HxScheduleStatusType["ScheduledTimeExpired"] = 2] = "ScheduledTimeExpired";
})(HxScheduleStatusType = exports.HxScheduleStatusType || (exports.HxScheduleStatusType = {}));
function getHxScheduleStatusTypeAsString(value) {
    return HxScheduleStatusType[value];
}
exports.getHxScheduleStatusTypeAsString = getHxScheduleStatusTypeAsString;
function getHxScheduleStatusTypeFromString(value) {
    return HxScheduleStatusType[value];
}
exports.getHxScheduleStatusTypeFromString = getHxScheduleStatusTypeFromString;
/*-------------------------------------------------------------------------------
  HxMeetingRequestType
-------------------------------------------------------------------------------*/
var HxMeetingRequestType;
(function (HxMeetingRequestType) {
    HxMeetingRequestType[HxMeetingRequestType["Request"] = 0] = "Request";
    HxMeetingRequestType[HxMeetingRequestType["InformationUpdate"] = 1] = "InformationUpdate";
    HxMeetingRequestType[HxMeetingRequestType["Outdated"] = 2] = "Outdated";
})(HxMeetingRequestType = exports.HxMeetingRequestType || (exports.HxMeetingRequestType = {}));
function getHxMeetingRequestTypeAsString(value) {
    return HxMeetingRequestType[value];
}
exports.getHxMeetingRequestTypeAsString = getHxMeetingRequestTypeAsString;
function getHxMeetingRequestTypeFromString(value) {
    return HxMeetingRequestType[value];
}
exports.getHxMeetingRequestTypeFromString = getHxMeetingRequestTypeFromString;
/*-------------------------------------------------------------------------------
  HxClientExtensionNotificationMessageType
-------------------------------------------------------------------------------*/
var HxClientExtensionNotificationMessageType;
(function (HxClientExtensionNotificationMessageType) {
    HxClientExtensionNotificationMessageType[HxClientExtensionNotificationMessageType["InformationalMessage"] = 0] = "InformationalMessage";
    HxClientExtensionNotificationMessageType[HxClientExtensionNotificationMessageType["ProgressIndicator"] = 1] = "ProgressIndicator";
    HxClientExtensionNotificationMessageType[HxClientExtensionNotificationMessageType["ErrorMessage"] = 2] = "ErrorMessage";
})(HxClientExtensionNotificationMessageType = exports.HxClientExtensionNotificationMessageType || (exports.HxClientExtensionNotificationMessageType = {}));
function getHxClientExtensionNotificationMessageTypeAsString(value) {
    return HxClientExtensionNotificationMessageType[value];
}
exports.getHxClientExtensionNotificationMessageTypeAsString = getHxClientExtensionNotificationMessageTypeAsString;
function getHxClientExtensionNotificationMessageTypeFromString(value) {
    return HxClientExtensionNotificationMessageType[value];
}
exports.getHxClientExtensionNotificationMessageTypeFromString = getHxClientExtensionNotificationMessageTypeFromString;
/*-------------------------------------------------------------------------------
  HxMimeEncoding
-------------------------------------------------------------------------------*/
var HxMimeEncoding;
(function (HxMimeEncoding) {
    HxMimeEncoding[HxMimeEncoding["SevenBit"] = 0] = "SevenBit";
    HxMimeEncoding[HxMimeEncoding["EightBit"] = 1] = "EightBit";
    HxMimeEncoding[HxMimeEncoding["Binary"] = 2] = "Binary";
    HxMimeEncoding[HxMimeEncoding["BaseSixtyFour"] = 3] = "BaseSixtyFour";
    HxMimeEncoding[HxMimeEncoding["QuotedPrintable"] = 4] = "QuotedPrintable";
    HxMimeEncoding[HxMimeEncoding["Other"] = 5] = "Other";
})(HxMimeEncoding = exports.HxMimeEncoding || (exports.HxMimeEncoding = {}));
function getHxMimeEncodingAsString(value) {
    return HxMimeEncoding[value];
}
exports.getHxMimeEncodingAsString = getHxMimeEncodingAsString;
function getHxMimeEncodingFromString(value) {
    return HxMimeEncoding[value];
}
exports.getHxMimeEncodingFromString = getHxMimeEncodingFromString;
/*-------------------------------------------------------------------------------
  HxMimeType
-------------------------------------------------------------------------------*/
var HxMimeType;
(function (HxMimeType) {
    HxMimeType[HxMimeType["PlainText"] = 0] = "PlainText";
    HxMimeType[HxMimeType["Html"] = 1] = "Html";
    HxMimeType[HxMimeType["Other"] = 2] = "Other";
})(HxMimeType = exports.HxMimeType || (exports.HxMimeType = {}));
function getHxMimeTypeAsString(value) {
    return HxMimeType[value];
}
exports.getHxMimeTypeAsString = getHxMimeTypeAsString;
function getHxMimeTypeFromString(value) {
    return HxMimeType[value];
}
exports.getHxMimeTypeFromString = getHxMimeTypeFromString;
/*-------------------------------------------------------------------------------
  HxCreateFolderActionErrorType
-------------------------------------------------------------------------------*/
var HxCreateFolderActionErrorType;
(function (HxCreateFolderActionErrorType) {
    HxCreateFolderActionErrorType[HxCreateFolderActionErrorType["NameCollision"] = 0] = "NameCollision";
    HxCreateFolderActionErrorType[HxCreateFolderActionErrorType["SocketError"] = 1] = "SocketError";
    HxCreateFolderActionErrorType[HxCreateFolderActionErrorType["ServerError"] = 2] = "ServerError";
    HxCreateFolderActionErrorType[HxCreateFolderActionErrorType["PermissionsError"] = 3] = "PermissionsError";
    HxCreateFolderActionErrorType[HxCreateFolderActionErrorType["GenericError"] = 4] = "GenericError";
})(HxCreateFolderActionErrorType = exports.HxCreateFolderActionErrorType || (exports.HxCreateFolderActionErrorType = {}));
function getHxCreateFolderActionErrorTypeAsString(value) {
    return HxCreateFolderActionErrorType[value];
}
exports.getHxCreateFolderActionErrorTypeAsString = getHxCreateFolderActionErrorTypeAsString;
function getHxCreateFolderActionErrorTypeFromString(value) {
    return HxCreateFolderActionErrorType[value];
}
exports.getHxCreateFolderActionErrorTypeFromString = getHxCreateFolderActionErrorTypeFromString;
/*-------------------------------------------------------------------------------
  HxDeleteOrEmptyFolderActionErrorType
-------------------------------------------------------------------------------*/
var HxDeleteOrEmptyFolderActionErrorType;
(function (HxDeleteOrEmptyFolderActionErrorType) {
    HxDeleteOrEmptyFolderActionErrorType[HxDeleteOrEmptyFolderActionErrorType["CouldNotDeleteEverything"] = 0] = "CouldNotDeleteEverything";
    HxDeleteOrEmptyFolderActionErrorType[HxDeleteOrEmptyFolderActionErrorType["SocketError"] = 1] = "SocketError";
    HxDeleteOrEmptyFolderActionErrorType[HxDeleteOrEmptyFolderActionErrorType["ServerError"] = 2] = "ServerError";
    HxDeleteOrEmptyFolderActionErrorType[HxDeleteOrEmptyFolderActionErrorType["PermissionsError"] = 3] = "PermissionsError";
    HxDeleteOrEmptyFolderActionErrorType[HxDeleteOrEmptyFolderActionErrorType["GenericError"] = 4] = "GenericError";
})(HxDeleteOrEmptyFolderActionErrorType = exports.HxDeleteOrEmptyFolderActionErrorType || (exports.HxDeleteOrEmptyFolderActionErrorType = {}));
function getHxDeleteOrEmptyFolderActionErrorTypeAsString(value) {
    return HxDeleteOrEmptyFolderActionErrorType[value];
}
exports.getHxDeleteOrEmptyFolderActionErrorTypeAsString = getHxDeleteOrEmptyFolderActionErrorTypeAsString;
function getHxDeleteOrEmptyFolderActionErrorTypeFromString(value) {
    return HxDeleteOrEmptyFolderActionErrorType[value];
}
exports.getHxDeleteOrEmptyFolderActionErrorTypeFromString = getHxDeleteOrEmptyFolderActionErrorTypeFromString;
/*-------------------------------------------------------------------------------
  HxSmimeComposeErrorType
-------------------------------------------------------------------------------*/
var HxSmimeComposeErrorType;
(function (HxSmimeComposeErrorType) {
    HxSmimeComposeErrorType[HxSmimeComposeErrorType["UnknownError"] = 0] = "UnknownError";
    HxSmimeComposeErrorType[HxSmimeComposeErrorType["FailedPolicyCheckForHardCert"] = 1] = "FailedPolicyCheckForHardCert";
    HxSmimeComposeErrorType[HxSmimeComposeErrorType["MissingRecipientsPublicKey"] = 2] = "MissingRecipientsPublicKey";
    HxSmimeComposeErrorType[HxSmimeComposeErrorType["FailedWithInvalidRecipient"] = 3] = "FailedWithInvalidRecipient";
    HxSmimeComposeErrorType[HxSmimeComposeErrorType["MissingSenderEncryptionKey"] = 4] = "MissingSenderEncryptionKey";
    HxSmimeComposeErrorType[HxSmimeComposeErrorType["MissingSenderSigningKey"] = 5] = "MissingSenderSigningKey";
    HxSmimeComposeErrorType[HxSmimeComposeErrorType["FailedPolicyCheckForEncryption"] = 6] = "FailedPolicyCheckForEncryption";
    HxSmimeComposeErrorType[HxSmimeComposeErrorType["FailedWithZeroValidRecipient"] = 7] = "FailedWithZeroValidRecipient";
})(HxSmimeComposeErrorType = exports.HxSmimeComposeErrorType || (exports.HxSmimeComposeErrorType = {}));
function getHxSmimeComposeErrorTypeAsString(value) {
    return HxSmimeComposeErrorType[value];
}
exports.getHxSmimeComposeErrorTypeAsString = getHxSmimeComposeErrorTypeAsString;
function getHxSmimeComposeErrorTypeFromString(value) {
    return HxSmimeComposeErrorType[value];
}
exports.getHxSmimeComposeErrorTypeFromString = getHxSmimeComposeErrorTypeFromString;
/*-------------------------------------------------------------------------------
  HxStorageMaintenanceState
-------------------------------------------------------------------------------*/
var HxStorageMaintenanceState;
(function (HxStorageMaintenanceState) {
    HxStorageMaintenanceState[HxStorageMaintenanceState["None"] = 0] = "None";
    HxStorageMaintenanceState[HxStorageMaintenanceState["InProgress"] = 1] = "InProgress";
    HxStorageMaintenanceState[HxStorageMaintenanceState["Cancelled"] = 2] = "Cancelled";
    HxStorageMaintenanceState[HxStorageMaintenanceState["Complete"] = 3] = "Complete";
})(HxStorageMaintenanceState = exports.HxStorageMaintenanceState || (exports.HxStorageMaintenanceState = {}));
function getHxStorageMaintenanceStateAsString(value) {
    return HxStorageMaintenanceState[value];
}
exports.getHxStorageMaintenanceStateAsString = getHxStorageMaintenanceStateAsString;
function getHxStorageMaintenanceStateFromString(value) {
    return HxStorageMaintenanceState[value];
}
exports.getHxStorageMaintenanceStateFromString = getHxStorageMaintenanceStateFromString;
/*-------------------------------------------------------------------------------
  HxO365SubscriptionStatusType
-------------------------------------------------------------------------------*/
var HxO365SubscriptionStatusType;
(function (HxO365SubscriptionStatusType) {
    HxO365SubscriptionStatusType[HxO365SubscriptionStatusType["Unknown"] = 0] = "Unknown";
    HxO365SubscriptionStatusType[HxO365SubscriptionStatusType["Unpaid"] = 1] = "Unpaid";
    HxO365SubscriptionStatusType[HxO365SubscriptionStatusType["OrgPaid"] = 2] = "OrgPaid";
    HxO365SubscriptionStatusType[HxO365SubscriptionStatusType["ConsumerPaid"] = 3] = "ConsumerPaid";
})(HxO365SubscriptionStatusType = exports.HxO365SubscriptionStatusType || (exports.HxO365SubscriptionStatusType = {}));
function getHxO365SubscriptionStatusTypeAsString(value) {
    return HxO365SubscriptionStatusType[value];
}
exports.getHxO365SubscriptionStatusTypeAsString = getHxO365SubscriptionStatusTypeAsString;
function getHxO365SubscriptionStatusTypeFromString(value) {
    return HxO365SubscriptionStatusType[value];
}
exports.getHxO365SubscriptionStatusTypeFromString = getHxO365SubscriptionStatusTypeFromString;
/*-------------------------------------------------------------------------------
  HxFavoriteType
-------------------------------------------------------------------------------*/
var HxFavoriteType;
(function (HxFavoriteType) {
    HxFavoriteType[HxFavoriteType["None"] = 0] = "None";
    HxFavoriteType[HxFavoriteType["FavoritePerson"] = 3] = "FavoritePerson";
    HxFavoriteType[HxFavoriteType["Group"] = 2] = "Group";
    HxFavoriteType[HxFavoriteType["View"] = 1] = "View";
})(HxFavoriteType = exports.HxFavoriteType || (exports.HxFavoriteType = {}));
function getHxFavoriteTypeAsString(value) {
    return HxFavoriteType[value];
}
exports.getHxFavoriteTypeAsString = getHxFavoriteTypeAsString;
function getHxFavoriteTypeFromString(value) {
    return HxFavoriteType[value];
}
exports.getHxFavoriteTypeFromString = getHxFavoriteTypeFromString;
/*-------------------------------------------------------------------------------
  HxDensitySetting
-------------------------------------------------------------------------------*/
var HxDensitySetting;
(function (HxDensitySetting) {
    HxDensitySetting[HxDensitySetting["Invalid"] = 3] = "Invalid";
    HxDensitySetting[HxDensitySetting["Low"] = 0] = "Low";
    HxDensitySetting[HxDensitySetting["Medium"] = 1] = "Medium";
    HxDensitySetting[HxDensitySetting["High"] = 2] = "High";
})(HxDensitySetting = exports.HxDensitySetting || (exports.HxDensitySetting = {}));
function getHxDensitySettingAsString(value) {
    return HxDensitySetting[value];
}
exports.getHxDensitySettingAsString = getHxDensitySettingAsString;
function getHxDensitySettingFromString(value) {
    return HxDensitySetting[value];
}
exports.getHxDensitySettingFromString = getHxDensitySettingFromString;
/*-------------------------------------------------------------------------------
  HxHandshakeCancelState
-------------------------------------------------------------------------------*/
var HxHandshakeCancelState;
(function (HxHandshakeCancelState) {
    HxHandshakeCancelState[HxHandshakeCancelState["None"] = 0] = "None";
    HxHandshakeCancelState[HxHandshakeCancelState["CancelReceived"] = 1] = "CancelReceived";
    HxHandshakeCancelState[HxHandshakeCancelState["CancelResponded"] = 2] = "CancelResponded";
    HxHandshakeCancelState[HxHandshakeCancelState["Suspended"] = 3] = "Suspended";
})(HxHandshakeCancelState = exports.HxHandshakeCancelState || (exports.HxHandshakeCancelState = {}));
function getHxHandshakeCancelStateAsString(value) {
    return HxHandshakeCancelState[value];
}
exports.getHxHandshakeCancelStateAsString = getHxHandshakeCancelStateAsString;
function getHxHandshakeCancelStateFromString(value) {
    return HxHandshakeCancelState[value];
}
exports.getHxHandshakeCancelStateFromString = getHxHandshakeCancelStateFromString;
/*-------------------------------------------------------------------------------
  HxCreateOrMarkAsScheduledFolderActionErrorType
-------------------------------------------------------------------------------*/
var HxCreateOrMarkAsScheduledFolderActionErrorType;
(function (HxCreateOrMarkAsScheduledFolderActionErrorType) {
    HxCreateOrMarkAsScheduledFolderActionErrorType[HxCreateOrMarkAsScheduledFolderActionErrorType["FolderAlreadyExists"] = 0] = "FolderAlreadyExists";
    HxCreateOrMarkAsScheduledFolderActionErrorType[HxCreateOrMarkAsScheduledFolderActionErrorType["FolderNotFound"] = 1] = "FolderNotFound";
    HxCreateOrMarkAsScheduledFolderActionErrorType[HxCreateOrMarkAsScheduledFolderActionErrorType["ServerError"] = 2] = "ServerError";
    HxCreateOrMarkAsScheduledFolderActionErrorType[HxCreateOrMarkAsScheduledFolderActionErrorType["GenericError"] = 3] = "GenericError";
})(HxCreateOrMarkAsScheduledFolderActionErrorType = exports.HxCreateOrMarkAsScheduledFolderActionErrorType || (exports.HxCreateOrMarkAsScheduledFolderActionErrorType = {}));
function getHxCreateOrMarkAsScheduledFolderActionErrorTypeAsString(value) {
    return HxCreateOrMarkAsScheduledFolderActionErrorType[value];
}
exports.getHxCreateOrMarkAsScheduledFolderActionErrorTypeAsString = getHxCreateOrMarkAsScheduledFolderActionErrorTypeAsString;
function getHxCreateOrMarkAsScheduledFolderActionErrorTypeFromString(value) {
    return HxCreateOrMarkAsScheduledFolderActionErrorType[value];
}
exports.getHxCreateOrMarkAsScheduledFolderActionErrorTypeFromString = getHxCreateOrMarkAsScheduledFolderActionErrorTypeFromString;
/*-------------------------------------------------------------------------------
  HxLocationEntityType
-------------------------------------------------------------------------------*/
var HxLocationEntityType;
(function (HxLocationEntityType) {
    HxLocationEntityType[HxLocationEntityType["Unknown"] = 0] = "Unknown";
    HxLocationEntityType[HxLocationEntityType["ConferenceRoom"] = 1] = "ConferenceRoom";
    HxLocationEntityType[HxLocationEntityType["HomeAddress"] = 2] = "HomeAddress";
    HxLocationEntityType[HxLocationEntityType["BusinessAddress"] = 3] = "BusinessAddress";
    HxLocationEntityType[HxLocationEntityType["GeoCoordinates"] = 4] = "GeoCoordinates";
    HxLocationEntityType[HxLocationEntityType["StreetAddress"] = 5] = "StreetAddress";
    HxLocationEntityType[HxLocationEntityType["Hotel"] = 6] = "Hotel";
    HxLocationEntityType[HxLocationEntityType["Restaurant"] = 7] = "Restaurant";
    HxLocationEntityType[HxLocationEntityType["LocalBusiness"] = 8] = "LocalBusiness";
    HxLocationEntityType[HxLocationEntityType["PostalAddress"] = 9] = "PostalAddress";
})(HxLocationEntityType = exports.HxLocationEntityType || (exports.HxLocationEntityType = {}));
function getHxLocationEntityTypeAsString(value) {
    return HxLocationEntityType[value];
}
exports.getHxLocationEntityTypeAsString = getHxLocationEntityTypeAsString;
function getHxLocationEntityTypeFromString(value) {
    return HxLocationEntityType[value];
}
exports.getHxLocationEntityTypeFromString = getHxLocationEntityTypeFromString;
/*-------------------------------------------------------------------------------
  HxToastsType
-------------------------------------------------------------------------------*/
var HxToastsType;
(function (HxToastsType) {
    HxToastsType[HxToastsType["None"] = 2] = "None";
    HxToastsType[HxToastsType["AllMail"] = 0] = "AllMail";
    HxToastsType[HxToastsType["FocusedInbox"] = 1] = "FocusedInbox";
    HxToastsType[HxToastsType["FavoritePeople"] = 3] = "FavoritePeople";
})(HxToastsType = exports.HxToastsType || (exports.HxToastsType = {}));
function getHxToastsTypeAsString(value) {
    return HxToastsType[value];
}
exports.getHxToastsTypeAsString = getHxToastsTypeAsString;
function getHxToastsTypeFromString(value) {
    return HxToastsType[value];
}
exports.getHxToastsTypeFromString = getHxToastsTypeFromString;
/*-------------------------------------------------------------------------------
  HxCloudCachePromptInteractionType
-------------------------------------------------------------------------------*/
var HxCloudCachePromptInteractionType;
(function (HxCloudCachePromptInteractionType) {
    HxCloudCachePromptInteractionType[HxCloudCachePromptInteractionType["None"] = 0] = "None";
    HxCloudCachePromptInteractionType[HxCloudCachePromptInteractionType["CloudCachePromptSeen"] = 1] = "CloudCachePromptSeen";
    HxCloudCachePromptInteractionType[HxCloudCachePromptInteractionType["UserDeclinedCloudCacheForNow"] = 2] = "UserDeclinedCloudCacheForNow";
    HxCloudCachePromptInteractionType[HxCloudCachePromptInteractionType["UserDeclinedCloudCacheForever"] = 3] = "UserDeclinedCloudCacheForever";
    HxCloudCachePromptInteractionType[HxCloudCachePromptInteractionType["CloudCachePromptAccepted"] = 4] = "CloudCachePromptAccepted";
})(HxCloudCachePromptInteractionType = exports.HxCloudCachePromptInteractionType || (exports.HxCloudCachePromptInteractionType = {}));
function getHxCloudCachePromptInteractionTypeAsString(value) {
    return HxCloudCachePromptInteractionType[value];
}
exports.getHxCloudCachePromptInteractionTypeAsString = getHxCloudCachePromptInteractionTypeAsString;
function getHxCloudCachePromptInteractionTypeFromString(value) {
    return HxCloudCachePromptInteractionType[value];
}
exports.getHxCloudCachePromptInteractionTypeFromString = getHxCloudCachePromptInteractionTypeFromString;
/*-------------------------------------------------------------------------------
  HxPresenceAvailability
-------------------------------------------------------------------------------*/
var HxPresenceAvailability;
(function (HxPresenceAvailability) {
    HxPresenceAvailability[HxPresenceAvailability["Unknown"] = 0] = "Unknown";
    HxPresenceAvailability[HxPresenceAvailability["Available"] = 1] = "Available";
    HxPresenceAvailability[HxPresenceAvailability["Busy"] = 2] = "Busy";
    HxPresenceAvailability[HxPresenceAvailability["DoNotDisturb"] = 3] = "DoNotDisturb";
    HxPresenceAvailability[HxPresenceAvailability["Away"] = 4] = "Away";
    HxPresenceAvailability[HxPresenceAvailability["Offline"] = 5] = "Offline";
})(HxPresenceAvailability = exports.HxPresenceAvailability || (exports.HxPresenceAvailability = {}));
function getHxPresenceAvailabilityAsString(value) {
    return HxPresenceAvailability[value];
}
exports.getHxPresenceAvailabilityAsString = getHxPresenceAvailabilityAsString;
function getHxPresenceAvailabilityFromString(value) {
    return HxPresenceAvailability[value];
}
exports.getHxPresenceAvailabilityFromString = getHxPresenceAvailabilityFromString;
/*-------------------------------------------------------------------------------
  HxLocationIdType
-------------------------------------------------------------------------------*/
var HxLocationIdType;
(function (HxLocationIdType) {
    HxLocationIdType[HxLocationIdType["Unknown"] = 0] = "Unknown";
    HxLocationIdType[HxLocationIdType["LocationStore"] = 1] = "LocationStore";
    HxLocationIdType[HxLocationIdType["Directory"] = 2] = "Directory";
    HxLocationIdType[HxLocationIdType["Private"] = 3] = "Private";
    HxLocationIdType[HxLocationIdType["Bing"] = 4] = "Bing";
})(HxLocationIdType = exports.HxLocationIdType || (exports.HxLocationIdType = {}));
function getHxLocationIdTypeAsString(value) {
    return HxLocationIdType[value];
}
exports.getHxLocationIdTypeAsString = getHxLocationIdTypeAsString;
function getHxLocationIdTypeFromString(value) {
    return HxLocationIdType[value];
}
exports.getHxLocationIdTypeFromString = getHxLocationIdTypeFromString;
/*-------------------------------------------------------------------------------
  HxDelegateFolderPermissionLevelType
-------------------------------------------------------------------------------*/
var HxDelegateFolderPermissionLevelType;
(function (HxDelegateFolderPermissionLevelType) {
    HxDelegateFolderPermissionLevelType[HxDelegateFolderPermissionLevelType["Default"] = 0] = "Default";
    HxDelegateFolderPermissionLevelType[HxDelegateFolderPermissionLevelType["None"] = 1] = "None";
    HxDelegateFolderPermissionLevelType[HxDelegateFolderPermissionLevelType["Editor"] = 2] = "Editor";
    HxDelegateFolderPermissionLevelType[HxDelegateFolderPermissionLevelType["Reviewer"] = 3] = "Reviewer";
    HxDelegateFolderPermissionLevelType[HxDelegateFolderPermissionLevelType["Author"] = 4] = "Author";
    HxDelegateFolderPermissionLevelType[HxDelegateFolderPermissionLevelType["Custom"] = 5] = "Custom";
})(HxDelegateFolderPermissionLevelType = exports.HxDelegateFolderPermissionLevelType || (exports.HxDelegateFolderPermissionLevelType = {}));
function getHxDelegateFolderPermissionLevelTypeAsString(value) {
    return HxDelegateFolderPermissionLevelType[value];
}
exports.getHxDelegateFolderPermissionLevelTypeAsString = getHxDelegateFolderPermissionLevelTypeAsString;
function getHxDelegateFolderPermissionLevelTypeFromString(value) {
    return HxDelegateFolderPermissionLevelType[value];
}
exports.getHxDelegateFolderPermissionLevelTypeFromString = getHxDelegateFolderPermissionLevelTypeFromString;
/*-------------------------------------------------------------------------------
  HxSuggestedReplyType
-------------------------------------------------------------------------------*/
var HxSuggestedReplyType;
(function (HxSuggestedReplyType) {
    HxSuggestedReplyType[HxSuggestedReplyType["Default"] = 0] = "Default";
    HxSuggestedReplyType[HxSuggestedReplyType["SmallDevice"] = 1] = "SmallDevice";
})(HxSuggestedReplyType = exports.HxSuggestedReplyType || (exports.HxSuggestedReplyType = {}));
function getHxSuggestedReplyTypeAsString(value) {
    return HxSuggestedReplyType[value];
}
exports.getHxSuggestedReplyTypeAsString = getHxSuggestedReplyTypeAsString;
function getHxSuggestedReplyTypeFromString(value) {
    return HxSuggestedReplyType[value];
}
exports.getHxSuggestedReplyTypeFromString = getHxSuggestedReplyTypeFromString;
/*-------------------------------------------------------------------------------
  HxSharedAccountType
-------------------------------------------------------------------------------*/
var HxSharedAccountType;
(function (HxSharedAccountType) {
    HxSharedAccountType[HxSharedAccountType["None"] = 0] = "None";
    HxSharedAccountType[HxSharedAccountType["Unknown"] = 1] = "Unknown";
    HxSharedAccountType[HxSharedAccountType["SharedMailbox"] = 2] = "SharedMailbox";
    HxSharedAccountType[HxSharedAccountType["DelegateMailbox"] = 3] = "DelegateMailbox";
    HxSharedAccountType[HxSharedAccountType["PartialAccessDelegateMailbox"] = 4] = "PartialAccessDelegateMailbox";
})(HxSharedAccountType = exports.HxSharedAccountType || (exports.HxSharedAccountType = {}));
function getHxSharedAccountTypeAsString(value) {
    return HxSharedAccountType[value];
}
exports.getHxSharedAccountTypeAsString = getHxSharedAccountTypeAsString;
function getHxSharedAccountTypeFromString(value) {
    return HxSharedAccountType[value];
}
exports.getHxSharedAccountTypeFromString = getHxSharedAccountTypeFromString;
/*-------------------------------------------------------------------------------
  HxRemoteMailboxSyncStatusType
-------------------------------------------------------------------------------*/
var HxRemoteMailboxSyncStatusType;
(function (HxRemoteMailboxSyncStatusType) {
    HxRemoteMailboxSyncStatusType[HxRemoteMailboxSyncStatusType["None"] = 0] = "None";
    HxRemoteMailboxSyncStatusType[HxRemoteMailboxSyncStatusType["Queued"] = 1] = "Queued";
    HxRemoteMailboxSyncStatusType[HxRemoteMailboxSyncStatusType["InProgress"] = 2] = "InProgress";
    HxRemoteMailboxSyncStatusType[HxRemoteMailboxSyncStatusType["AutoSuspended"] = 3] = "AutoSuspended";
    HxRemoteMailboxSyncStatusType[HxRemoteMailboxSyncStatusType["CompletionInProgress"] = 4] = "CompletionInProgress";
    HxRemoteMailboxSyncStatusType[HxRemoteMailboxSyncStatusType["Synced"] = 5] = "Synced";
    HxRemoteMailboxSyncStatusType[HxRemoteMailboxSyncStatusType["Completed"] = 6] = "Completed";
    HxRemoteMailboxSyncStatusType[HxRemoteMailboxSyncStatusType["CompletedWithWarning"] = 7] = "CompletedWithWarning";
    HxRemoteMailboxSyncStatusType[HxRemoteMailboxSyncStatusType["Retrying"] = 8] = "Retrying";
    HxRemoteMailboxSyncStatusType[HxRemoteMailboxSyncStatusType["Suspended"] = 9] = "Suspended";
    HxRemoteMailboxSyncStatusType[HxRemoteMailboxSyncStatusType["Failed"] = 10] = "Failed";
    HxRemoteMailboxSyncStatusType[HxRemoteMailboxSyncStatusType["Unknown"] = 11] = "Unknown";
})(HxRemoteMailboxSyncStatusType = exports.HxRemoteMailboxSyncStatusType || (exports.HxRemoteMailboxSyncStatusType = {}));
function getHxRemoteMailboxSyncStatusTypeAsString(value) {
    return HxRemoteMailboxSyncStatusType[value];
}
exports.getHxRemoteMailboxSyncStatusTypeAsString = getHxRemoteMailboxSyncStatusTypeAsString;
function getHxRemoteMailboxSyncStatusTypeFromString(value) {
    return HxRemoteMailboxSyncStatusType[value];
}
exports.getHxRemoteMailboxSyncStatusTypeFromString = getHxRemoteMailboxSyncStatusTypeFromString;
/*-------------------------------------------------------------------------------
  HxRemoteMailboxSyncActionableErrorType
-------------------------------------------------------------------------------*/
var HxRemoteMailboxSyncActionableErrorType;
(function (HxRemoteMailboxSyncActionableErrorType) {
    HxRemoteMailboxSyncActionableErrorType[HxRemoteMailboxSyncActionableErrorType["None"] = 0] = "None";
    HxRemoteMailboxSyncActionableErrorType[HxRemoteMailboxSyncActionableErrorType["ImapDisabled"] = 1] = "ImapDisabled";
    HxRemoteMailboxSyncActionableErrorType[HxRemoteMailboxSyncActionableErrorType["ImapRequiredFoldersMissing"] = 2] = "ImapRequiredFoldersMissing";
    HxRemoteMailboxSyncActionableErrorType[HxRemoteMailboxSyncActionableErrorType["InvalidRemoteRefreshToken"] = 3] = "InvalidRemoteRefreshToken";
    HxRemoteMailboxSyncActionableErrorType[HxRemoteMailboxSyncActionableErrorType["EasTooManyFolders"] = 4] = "EasTooManyFolders";
    HxRemoteMailboxSyncActionableErrorType[HxRemoteMailboxSyncActionableErrorType["EasMailboxQuotaExceeded"] = 5] = "EasMailboxQuotaExceeded";
    HxRemoteMailboxSyncActionableErrorType[HxRemoteMailboxSyncActionableErrorType["EasMaximumDevicesReached"] = 6] = "EasMaximumDevicesReached";
    HxRemoteMailboxSyncActionableErrorType[HxRemoteMailboxSyncActionableErrorType["EasUserDisabledForSync"] = 7] = "EasUserDisabledForSync";
    HxRemoteMailboxSyncActionableErrorType[HxRemoteMailboxSyncActionableErrorType["EasUserOnNewMailboxCannotSync"] = 8] = "EasUserOnNewMailboxCannotSync";
    HxRemoteMailboxSyncActionableErrorType[HxRemoteMailboxSyncActionableErrorType["EasUserOnLegacyMailboxCannotSync"] = 9] = "EasUserOnLegacyMailboxCannotSync";
    HxRemoteMailboxSyncActionableErrorType[HxRemoteMailboxSyncActionableErrorType["EasDeviceIsBlockedForThisUser"] = 10] = "EasDeviceIsBlockedForThisUser";
    HxRemoteMailboxSyncActionableErrorType[HxRemoteMailboxSyncActionableErrorType["EasAccountDisabled"] = 11] = "EasAccountDisabled";
    HxRemoteMailboxSyncActionableErrorType[HxRemoteMailboxSyncActionableErrorType["EasExternallyManagedDevicesNotAllowed"] = 12] = "EasExternallyManagedDevicesNotAllowed";
    HxRemoteMailboxSyncActionableErrorType[HxRemoteMailboxSyncActionableErrorType["Unknown"] = 13] = "Unknown";
})(HxRemoteMailboxSyncActionableErrorType = exports.HxRemoteMailboxSyncActionableErrorType || (exports.HxRemoteMailboxSyncActionableErrorType = {}));
function getHxRemoteMailboxSyncActionableErrorTypeAsString(value) {
    return HxRemoteMailboxSyncActionableErrorType[value];
}
exports.getHxRemoteMailboxSyncActionableErrorTypeAsString = getHxRemoteMailboxSyncActionableErrorTypeAsString;
function getHxRemoteMailboxSyncActionableErrorTypeFromString(value) {
    return HxRemoteMailboxSyncActionableErrorType[value];
}
exports.getHxRemoteMailboxSyncActionableErrorTypeFromString = getHxRemoteMailboxSyncActionableErrorTypeFromString;
/*-------------------------------------------------------------------------------
  HxSyncRequestOptionsType
-------------------------------------------------------------------------------*/
var HxSyncRequestOptionsType;
(function (HxSyncRequestOptionsType) {
    HxSyncRequestOptionsType[HxSyncRequestOptionsType["None"] = 0] = "None";
    HxSyncRequestOptionsType[HxSyncRequestOptionsType["Mail"] = 1] = "Mail";
    HxSyncRequestOptionsType[HxSyncRequestOptionsType["Calendar"] = 2] = "Calendar";
    HxSyncRequestOptionsType[HxSyncRequestOptionsType["Contact"] = 4] = "Contact";
})(HxSyncRequestOptionsType = exports.HxSyncRequestOptionsType || (exports.HxSyncRequestOptionsType = {}));
function getHxSyncRequestOptionsTypeAsString(value) {
    return HxSyncRequestOptionsType[value];
}
exports.getHxSyncRequestOptionsTypeAsString = getHxSyncRequestOptionsTypeAsString;
function getHxSyncRequestOptionsTypeFromString(value) {
    return HxSyncRequestOptionsType[value];
}
exports.getHxSyncRequestOptionsTypeFromString = getHxSyncRequestOptionsTypeFromString;
/*-------------------------------------------------------------------------------
  HxAccountCreationFailureType
-------------------------------------------------------------------------------*/
var HxAccountCreationFailureType;
(function (HxAccountCreationFailureType) {
    HxAccountCreationFailureType[HxAccountCreationFailureType["None"] = 0] = "None";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_InvalidCredentials"] = 1] = "Err_InvalidCredentials";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_Denied"] = 2] = "Err_Denied";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_Duplicate"] = 3] = "Err_Duplicate";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_AutoD"] = 4] = "Err_AutoD";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_AuthNeeded"] = 5] = "Err_AuthNeeded";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_Unknown"] = 6] = "Err_Unknown";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_TurnMailSyncOn"] = 7] = "Err_TurnMailSyncOn";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_PolicyBlocksAccountCreation"] = 8] = "Err_PolicyBlocksAccountCreation";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_RedirectToBasicAuth"] = 9] = "Err_RedirectToBasicAuth";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_DeviceAccountBlackforestNotSupported"] = 10] = "Err_DeviceAccountBlackforestNotSupported";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_DefaultAccountWasAddedPreviously"] = 11] = "Err_DefaultAccountWasAddedPreviously";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_AccountIsNotSharedAccount"] = 12] = "Err_AccountIsNotSharedAccount";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_InvalidPrimaryAccountForSharedAccount"] = 13] = "Err_InvalidPrimaryAccountForSharedAccount";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_PreconditionCheckFailed"] = 14] = "Err_PreconditionCheckFailed";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_ProvisioningError"] = 15] = "Err_ProvisioningError";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_DeviceAccountWithMSANotSupported"] = 16] = "Err_DeviceAccountWithMSANotSupported";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_CloudEnvironmentMismatch"] = 17] = "Err_CloudEnvironmentMismatch";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_SslCertificateError"] = 18] = "Err_SslCertificateError";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_OutgoingServerInvalidCredentials"] = 19] = "Err_OutgoingServerInvalidCredentials";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_OutgoingServerSslCertificateError"] = 20] = "Err_OutgoingServerSslCertificateError";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_InvalidServerConfig"] = 21] = "Err_InvalidServerConfig";
    HxAccountCreationFailureType[HxAccountCreationFailureType["Err_InvalidOutgoingServerConfig"] = 22] = "Err_InvalidOutgoingServerConfig";
})(HxAccountCreationFailureType = exports.HxAccountCreationFailureType || (exports.HxAccountCreationFailureType = {}));
function getHxAccountCreationFailureTypeAsString(value) {
    return HxAccountCreationFailureType[value];
}
exports.getHxAccountCreationFailureTypeAsString = getHxAccountCreationFailureTypeAsString;
function getHxAccountCreationFailureTypeFromString(value) {
    return HxAccountCreationFailureType[value];
}
exports.getHxAccountCreationFailureTypeFromString = getHxAccountCreationFailureTypeFromString;
/*-------------------------------------------------------------------------------
  HxMobilePresenceStatus
-------------------------------------------------------------------------------*/
var HxMobilePresenceStatus;
(function (HxMobilePresenceStatus) {
    HxMobilePresenceStatus[HxMobilePresenceStatus["Unknown"] = 0] = "Unknown";
    HxMobilePresenceStatus[HxMobilePresenceStatus["Yes"] = 1] = "Yes";
    HxMobilePresenceStatus[HxMobilePresenceStatus["No"] = 2] = "No";
})(HxMobilePresenceStatus = exports.HxMobilePresenceStatus || (exports.HxMobilePresenceStatus = {}));
function getHxMobilePresenceStatusAsString(value) {
    return HxMobilePresenceStatus[value];
}
exports.getHxMobilePresenceStatusAsString = getHxMobilePresenceStatusAsString;
function getHxMobilePresenceStatusFromString(value) {
    return HxMobilePresenceStatus[value];
}
exports.getHxMobilePresenceStatusFromString = getHxMobilePresenceStatusFromString;
/*-------------------------------------------------------------------------------
  HxFetchCdnFilesErrorType
-------------------------------------------------------------------------------*/
var HxFetchCdnFilesErrorType;
(function (HxFetchCdnFilesErrorType) {
    HxFetchCdnFilesErrorType[HxFetchCdnFilesErrorType["ServerError_FileNotFound"] = 0] = "ServerError_FileNotFound";
    HxFetchCdnFilesErrorType[HxFetchCdnFilesErrorType["ServerError_Timeout"] = 1] = "ServerError_Timeout";
    HxFetchCdnFilesErrorType[HxFetchCdnFilesErrorType["ServerError_TransientFailure"] = 2] = "ServerError_TransientFailure";
    HxFetchCdnFilesErrorType[HxFetchCdnFilesErrorType["SyncError_Offline"] = 3] = "SyncError_Offline";
    HxFetchCdnFilesErrorType[HxFetchCdnFilesErrorType["UsageError_UntrackedFile"] = 4] = "UsageError_UntrackedFile";
    HxFetchCdnFilesErrorType[HxFetchCdnFilesErrorType["UsageError_BadPath"] = 5] = "UsageError_BadPath";
    HxFetchCdnFilesErrorType[HxFetchCdnFilesErrorType["FileSystemError"] = 6] = "FileSystemError";
    HxFetchCdnFilesErrorType[HxFetchCdnFilesErrorType["UnknownError"] = 7] = "UnknownError";
    HxFetchCdnFilesErrorType[HxFetchCdnFilesErrorType["None"] = 8] = "None";
})(HxFetchCdnFilesErrorType = exports.HxFetchCdnFilesErrorType || (exports.HxFetchCdnFilesErrorType = {}));
function getHxFetchCdnFilesErrorTypeAsString(value) {
    return HxFetchCdnFilesErrorType[value];
}
exports.getHxFetchCdnFilesErrorTypeAsString = getHxFetchCdnFilesErrorTypeAsString;
function getHxFetchCdnFilesErrorTypeFromString(value) {
    return HxFetchCdnFilesErrorType[value];
}
exports.getHxFetchCdnFilesErrorTypeFromString = getHxFetchCdnFilesErrorTypeFromString;
/*-------------------------------------------------------------------------------
  HxCdnFileDownloadBehaviorType
-------------------------------------------------------------------------------*/
var HxCdnFileDownloadBehaviorType;
(function (HxCdnFileDownloadBehaviorType) {
    HxCdnFileDownloadBehaviorType[HxCdnFileDownloadBehaviorType["Always"] = 0] = "Always";
    HxCdnFileDownloadBehaviorType[HxCdnFileDownloadBehaviorType["Lazy"] = 1] = "Lazy";
})(HxCdnFileDownloadBehaviorType = exports.HxCdnFileDownloadBehaviorType || (exports.HxCdnFileDownloadBehaviorType = {}));
function getHxCdnFileDownloadBehaviorTypeAsString(value) {
    return HxCdnFileDownloadBehaviorType[value];
}
exports.getHxCdnFileDownloadBehaviorTypeAsString = getHxCdnFileDownloadBehaviorTypeAsString;
function getHxCdnFileDownloadBehaviorTypeFromString(value) {
    return HxCdnFileDownloadBehaviorType[value];
}
exports.getHxCdnFileDownloadBehaviorTypeFromString = getHxCdnFileDownloadBehaviorTypeFromString;
/*-------------------------------------------------------------------------------
  HxCdnFileDownloadReactionType
-------------------------------------------------------------------------------*/
var HxCdnFileDownloadReactionType;
(function (HxCdnFileDownloadReactionType) {
    HxCdnFileDownloadReactionType[HxCdnFileDownloadReactionType["Sync"] = 0] = "Sync";
    HxCdnFileDownloadReactionType[HxCdnFileDownloadReactionType["Fetch"] = 1] = "Fetch";
})(HxCdnFileDownloadReactionType = exports.HxCdnFileDownloadReactionType || (exports.HxCdnFileDownloadReactionType = {}));
function getHxCdnFileDownloadReactionTypeAsString(value) {
    return HxCdnFileDownloadReactionType[value];
}
exports.getHxCdnFileDownloadReactionTypeAsString = getHxCdnFileDownloadReactionTypeAsString;
function getHxCdnFileDownloadReactionTypeFromString(value) {
    return HxCdnFileDownloadReactionType[value];
}
exports.getHxCdnFileDownloadReactionTypeFromString = getHxCdnFileDownloadReactionTypeFromString;
/*-------------------------------------------------------------------------------
  HxToDoTaskStatus
-------------------------------------------------------------------------------*/
var HxToDoTaskStatus;
(function (HxToDoTaskStatus) {
    HxToDoTaskStatus[HxToDoTaskStatus["NotStarted"] = 0] = "NotStarted";
    HxToDoTaskStatus[HxToDoTaskStatus["InProgress"] = 1] = "InProgress";
    HxToDoTaskStatus[HxToDoTaskStatus["Completed"] = 2] = "Completed";
})(HxToDoTaskStatus = exports.HxToDoTaskStatus || (exports.HxToDoTaskStatus = {}));
function getHxToDoTaskStatusAsString(value) {
    return HxToDoTaskStatus[value];
}
exports.getHxToDoTaskStatusAsString = getHxToDoTaskStatusAsString;
function getHxToDoTaskStatusFromString(value) {
    return HxToDoTaskStatus[value];
}
exports.getHxToDoTaskStatusFromString = getHxToDoTaskStatusFromString;
/*-------------------------------------------------------------------------------
  HxToDoTaskImportance
-------------------------------------------------------------------------------*/
var HxToDoTaskImportance;
(function (HxToDoTaskImportance) {
    HxToDoTaskImportance[HxToDoTaskImportance["Normal"] = 0] = "Normal";
    HxToDoTaskImportance[HxToDoTaskImportance["Low"] = 1] = "Low";
    HxToDoTaskImportance[HxToDoTaskImportance["High"] = 2] = "High";
})(HxToDoTaskImportance = exports.HxToDoTaskImportance || (exports.HxToDoTaskImportance = {}));
function getHxToDoTaskImportanceAsString(value) {
    return HxToDoTaskImportance[value];
}
exports.getHxToDoTaskImportanceAsString = getHxToDoTaskImportanceAsString;
function getHxToDoTaskImportanceFromString(value) {
    return HxToDoTaskImportance[value];
}
exports.getHxToDoTaskImportanceFromString = getHxToDoTaskImportanceFromString;
/*-------------------------------------------------------------------------------
  HxAddInFailureType
-------------------------------------------------------------------------------*/
var HxAddInFailureType;
(function (HxAddInFailureType) {
    HxAddInFailureType[HxAddInFailureType["None"] = 0] = "None";
    HxAddInFailureType[HxAddInFailureType["Unknown"] = 1] = "Unknown";
    HxAddInFailureType[HxAddInFailureType["HxCoreInternalError"] = 2] = "HxCoreInternalError";
    HxAddInFailureType[HxAddInFailureType["ServerAddInCacheExpired"] = 7] = "ServerAddInCacheExpired";
    HxAddInFailureType[HxAddInFailureType["CannotDownloadAddInManifest"] = 3] = "CannotDownloadAddInManifest";
    HxAddInFailureType[HxAddInFailureType["LackingPermissionsToInstallMarketplaceAddIn"] = 4] = "LackingPermissionsToInstallMarketplaceAddIn";
    HxAddInFailureType[HxAddInFailureType["NotSupportedForUser"] = 5] = "NotSupportedForUser";
    HxAddInFailureType[HxAddInFailureType["NotAuthorized"] = 6] = "NotAuthorized";
})(HxAddInFailureType = exports.HxAddInFailureType || (exports.HxAddInFailureType = {}));
function getHxAddInFailureTypeAsString(value) {
    return HxAddInFailureType[value];
}
exports.getHxAddInFailureTypeAsString = getHxAddInFailureTypeAsString;
function getHxAddInFailureTypeFromString(value) {
    return HxAddInFailureType[value];
}
exports.getHxAddInFailureTypeFromString = getHxAddInFailureTypeFromString;
/*-------------------------------------------------------------------------------
  HxPermissionActionType
-------------------------------------------------------------------------------*/
var HxPermissionActionType;
(function (HxPermissionActionType) {
    HxPermissionActionType[HxPermissionActionType["None"] = 0] = "None";
    HxPermissionActionType[HxPermissionActionType["Owned"] = 1] = "Owned";
    HxPermissionActionType[HxPermissionActionType["All"] = 2] = "All";
})(HxPermissionActionType = exports.HxPermissionActionType || (exports.HxPermissionActionType = {}));
function getHxPermissionActionTypeAsString(value) {
    return HxPermissionActionType[value];
}
exports.getHxPermissionActionTypeAsString = getHxPermissionActionTypeAsString;
function getHxPermissionActionTypeFromString(value) {
    return HxPermissionActionType[value];
}
exports.getHxPermissionActionTypeFromString = getHxPermissionActionTypeFromString;
/*-------------------------------------------------------------------------------
  HxPermissionReadAccessType
-------------------------------------------------------------------------------*/
var HxPermissionReadAccessType;
(function (HxPermissionReadAccessType) {
    HxPermissionReadAccessType[HxPermissionReadAccessType["None"] = 0] = "None";
    HxPermissionReadAccessType[HxPermissionReadAccessType["FullDetails"] = 1] = "FullDetails";
})(HxPermissionReadAccessType = exports.HxPermissionReadAccessType || (exports.HxPermissionReadAccessType = {}));
function getHxPermissionReadAccessTypeAsString(value) {
    return HxPermissionReadAccessType[value];
}
exports.getHxPermissionReadAccessTypeAsString = getHxPermissionReadAccessTypeAsString;
function getHxPermissionReadAccessTypeFromString(value) {
    return HxPermissionReadAccessType[value];
}
exports.getHxPermissionReadAccessTypeFromString = getHxPermissionReadAccessTypeFromString;
/*-------------------------------------------------------------------------------
  HxModuleIdentifier
-------------------------------------------------------------------------------*/
var HxModuleIdentifier;
(function (HxModuleIdentifier) {
    HxModuleIdentifier[HxModuleIdentifier["Mail"] = 0] = "Mail";
    HxModuleIdentifier[HxModuleIdentifier["Calendar"] = 1] = "Calendar";
    HxModuleIdentifier[HxModuleIdentifier["Accounts"] = 2] = "Accounts";
})(HxModuleIdentifier = exports.HxModuleIdentifier || (exports.HxModuleIdentifier = {}));
function getHxModuleIdentifierAsString(value) {
    return HxModuleIdentifier[value];
}
exports.getHxModuleIdentifierAsString = getHxModuleIdentifierAsString;
function getHxModuleIdentifierFromString(value) {
    return HxModuleIdentifier[value];
}
exports.getHxModuleIdentifierFromString = getHxModuleIdentifierFromString;
/*-------------------------------------------------------------------------------
  HxImapFolderAttributes
-------------------------------------------------------------------------------*/
var HxImapFolderAttributes;
(function (HxImapFolderAttributes) {
    HxImapFolderAttributes[HxImapFolderAttributes["None"] = 0] = "None";
    HxImapFolderAttributes[HxImapFolderAttributes["NoSelect"] = 1] = "NoSelect";
    HxImapFolderAttributes[HxImapFolderAttributes["NoInferiors"] = 2] = "NoInferiors";
    HxImapFolderAttributes[HxImapFolderAttributes["All"] = 4] = "All";
})(HxImapFolderAttributes = exports.HxImapFolderAttributes || (exports.HxImapFolderAttributes = {}));
function getHxImapFolderAttributesAsString(value) {
    return HxImapFolderAttributes[value];
}
exports.getHxImapFolderAttributesAsString = getHxImapFolderAttributesAsString;
function getHxImapFolderAttributesFromString(value) {
    return HxImapFolderAttributes[value];
}
exports.getHxImapFolderAttributesFromString = getHxImapFolderAttributesFromString;
/*-------------------------------------------------------------------------------
  HxProtectionStatus
-------------------------------------------------------------------------------*/
var HxProtectionStatus;
(function (HxProtectionStatus) {
    HxProtectionStatus[HxProtectionStatus["Unknown"] = 0] = "Unknown";
    HxProtectionStatus[HxProtectionStatus["Unprotected"] = 1] = "Unprotected";
    HxProtectionStatus[HxProtectionStatus["Protected"] = 2] = "Protected";
    HxProtectionStatus[HxProtectionStatus["ProtectedToOtherIdentity"] = 3] = "ProtectedToOtherIdentity";
    HxProtectionStatus[HxProtectionStatus["NotProtectable"] = 4] = "NotProtectable";
    HxProtectionStatus[HxProtectionStatus["Revoked"] = 5] = "Revoked";
    HxProtectionStatus[HxProtectionStatus["ItemDoesNotExist"] = 6] = "ItemDoesNotExist";
    HxProtectionStatus[HxProtectionStatus["AccessSuspended"] = 7] = "AccessSuspended";
    HxProtectionStatus[HxProtectionStatus["LicenseExpired"] = 8] = "LicenseExpired";
    HxProtectionStatus[HxProtectionStatus["Failed"] = 9] = "Failed";
    HxProtectionStatus[HxProtectionStatus["BadData"] = 10] = "BadData";
    HxProtectionStatus[HxProtectionStatus["FileInUse"] = 11] = "FileInUse";
})(HxProtectionStatus = exports.HxProtectionStatus || (exports.HxProtectionStatus = {}));
function getHxProtectionStatusAsString(value) {
    return HxProtectionStatus[value];
}
exports.getHxProtectionStatusAsString = getHxProtectionStatusAsString;
function getHxProtectionStatusFromString(value) {
    return HxProtectionStatus[value];
}
exports.getHxProtectionStatusFromString = getHxProtectionStatusFromString;
/*-------------------------------------------------------------------------------
  HxDataProtectionType
-------------------------------------------------------------------------------*/
var HxDataProtectionType;
(function (HxDataProtectionType) {
    HxDataProtectionType[HxDataProtectionType["Unknown"] = 0] = "Unknown";
    HxDataProtectionType[HxDataProtectionType["EDP"] = 1] = "EDP";
    HxDataProtectionType[HxDataProtectionType["CDPL"] = 2] = "CDPL";
    HxDataProtectionType[HxDataProtectionType["Intune"] = 3] = "Intune";
})(HxDataProtectionType = exports.HxDataProtectionType || (exports.HxDataProtectionType = {}));
function getHxDataProtectionTypeAsString(value) {
    return HxDataProtectionType[value];
}
exports.getHxDataProtectionTypeAsString = getHxDataProtectionTypeAsString;
function getHxDataProtectionTypeFromString(value) {
    return HxDataProtectionType[value];
}
exports.getHxDataProtectionTypeFromString = getHxDataProtectionTypeFromString;
/*-------------------------------------------------------------------------------
  HxPolicyEvaluationResult
-------------------------------------------------------------------------------*/
var HxPolicyEvaluationResult;
(function (HxPolicyEvaluationResult) {
    HxPolicyEvaluationResult[HxPolicyEvaluationResult["Allowed"] = 0] = "Allowed";
    HxPolicyEvaluationResult[HxPolicyEvaluationResult["Blocked"] = 1] = "Blocked";
    HxPolicyEvaluationResult[HxPolicyEvaluationResult["ConsentRequired"] = 2] = "ConsentRequired";
})(HxPolicyEvaluationResult = exports.HxPolicyEvaluationResult || (exports.HxPolicyEvaluationResult = {}));
function getHxPolicyEvaluationResultAsString(value) {
    return HxPolicyEvaluationResult[value];
}
exports.getHxPolicyEvaluationResultAsString = getHxPolicyEvaluationResultAsString;
function getHxPolicyEvaluationResultFromString(value) {
    return HxPolicyEvaluationResult[value];
}
exports.getHxPolicyEvaluationResultFromString = getHxPolicyEvaluationResultFromString;
/*-------------------------------------------------------------------------------
  HxAadLogoTheme
-------------------------------------------------------------------------------*/
var HxAadLogoTheme;
(function (HxAadLogoTheme) {
    HxAadLogoTheme[HxAadLogoTheme["Light"] = 0] = "Light";
    HxAadLogoTheme[HxAadLogoTheme["Dark"] = 1] = "Dark";
    HxAadLogoTheme[HxAadLogoTheme["None"] = 2] = "None";
})(HxAadLogoTheme = exports.HxAadLogoTheme || (exports.HxAadLogoTheme = {}));
function getHxAadLogoThemeAsString(value) {
    return HxAadLogoTheme[value];
}
exports.getHxAadLogoThemeAsString = getHxAadLogoThemeAsString;
function getHxAadLogoThemeFromString(value) {
    return HxAadLogoTheme[value];
}
exports.getHxAadLogoThemeFromString = getHxAadLogoThemeFromString;
/*-------------------------------------------------------------------------------
  HxMailSearchInteractionType
-------------------------------------------------------------------------------*/
var HxMailSearchInteractionType;
(function (HxMailSearchInteractionType) {
    HxMailSearchInteractionType[HxMailSearchInteractionType["EntityClicked"] = 0] = "EntityClicked";
    HxMailSearchInteractionType[HxMailSearchInteractionType["Print"] = 1] = "Print";
    HxMailSearchInteractionType[HxMailSearchInteractionType["OpenedAnAttachment"] = 2] = "OpenedAnAttachment";
    HxMailSearchInteractionType[HxMailSearchInteractionType["ReadingPaneDisplayStart"] = 3] = "ReadingPaneDisplayStart";
    HxMailSearchInteractionType[HxMailSearchInteractionType["ReadingPaneDisplayEnd"] = 4] = "ReadingPaneDisplayEnd";
    HxMailSearchInteractionType[HxMailSearchInteractionType["PopOut"] = 5] = "PopOut";
    HxMailSearchInteractionType[HxMailSearchInteractionType["HyperlinkClicked"] = 6] = "HyperlinkClicked";
})(HxMailSearchInteractionType = exports.HxMailSearchInteractionType || (exports.HxMailSearchInteractionType = {}));
function getHxMailSearchInteractionTypeAsString(value) {
    return HxMailSearchInteractionType[value];
}
exports.getHxMailSearchInteractionTypeAsString = getHxMailSearchInteractionTypeAsString;
function getHxMailSearchInteractionTypeFromString(value) {
    return HxMailSearchInteractionType[value];
}
exports.getHxMailSearchInteractionTypeFromString = getHxMailSearchInteractionTypeFromString;
/*-------------------------------------------------------------------------------
  HxSearchState
-------------------------------------------------------------------------------*/
var HxSearchState;
(function (HxSearchState) {
    HxSearchState[HxSearchState["NotStarted"] = 0] = "NotStarted";
    HxSearchState[HxSearchState["InProgress"] = 1] = "InProgress";
    HxSearchState[HxSearchState["CompletedSuccess"] = 2] = "CompletedSuccess";
    HxSearchState[HxSearchState["CompletedFailure"] = 3] = "CompletedFailure";
})(HxSearchState = exports.HxSearchState || (exports.HxSearchState = {}));
function getHxSearchStateAsString(value) {
    return HxSearchState[value];
}
exports.getHxSearchStateAsString = getHxSearchStateAsString;
function getHxSearchStateFromString(value) {
    return HxSearchState[value];
}
exports.getHxSearchStateFromString = getHxSearchStateFromString;
/*-------------------------------------------------------------------------------
  HxSearchInstrumentationFailureReason
-------------------------------------------------------------------------------*/
var HxSearchInstrumentationFailureReason;
(function (HxSearchInstrumentationFailureReason) {
    HxSearchInstrumentationFailureReason[HxSearchInstrumentationFailureReason["Unknown"] = 0] = "Unknown";
    HxSearchInstrumentationFailureReason[HxSearchInstrumentationFailureReason["None"] = 1] = "None";
    HxSearchInstrumentationFailureReason[HxSearchInstrumentationFailureReason["Cancelled"] = 2] = "Cancelled";
    HxSearchInstrumentationFailureReason[HxSearchInstrumentationFailureReason["NotCompleted"] = 3] = "NotCompleted";
    HxSearchInstrumentationFailureReason[HxSearchInstrumentationFailureReason["NotDisplayed"] = 4] = "NotDisplayed";
    HxSearchInstrumentationFailureReason[HxSearchInstrumentationFailureReason["Failure"] = 5] = "Failure";
})(HxSearchInstrumentationFailureReason = exports.HxSearchInstrumentationFailureReason || (exports.HxSearchInstrumentationFailureReason = {}));
function getHxSearchInstrumentationFailureReasonAsString(value) {
    return HxSearchInstrumentationFailureReason[value];
}
exports.getHxSearchInstrumentationFailureReasonAsString = getHxSearchInstrumentationFailureReasonAsString;
function getHxSearchInstrumentationFailureReasonFromString(value) {
    return HxSearchInstrumentationFailureReason[value];
}
exports.getHxSearchInstrumentationFailureReasonFromString = getHxSearchInstrumentationFailureReasonFromString;
/*-------------------------------------------------------------------------------
  HxSearchInstrumentationEventType
-------------------------------------------------------------------------------*/
var HxSearchInstrumentationEventType;
(function (HxSearchInstrumentationEventType) {
    HxSearchInstrumentationEventType[HxSearchInstrumentationEventType["ResponseReceived"] = 0] = "ResponseReceived";
    HxSearchInstrumentationEventType[HxSearchInstrumentationEventType["EntityClicked"] = 1] = "EntityClicked";
    HxSearchInstrumentationEventType[HxSearchInstrumentationEventType["SearchDone"] = 2] = "SearchDone";
    HxSearchInstrumentationEventType[HxSearchInstrumentationEventType["ReadingPaneDisplayStart"] = 19] = "ReadingPaneDisplayStart";
    HxSearchInstrumentationEventType[HxSearchInstrumentationEventType["ReadingPaneDisplayEnd"] = 20] = "ReadingPaneDisplayEnd";
    HxSearchInstrumentationEventType[HxSearchInstrumentationEventType["PopOut"] = 21] = "PopOut";
})(HxSearchInstrumentationEventType = exports.HxSearchInstrumentationEventType || (exports.HxSearchInstrumentationEventType = {}));
function getHxSearchInstrumentationEventTypeAsString(value) {
    return HxSearchInstrumentationEventType[value];
}
exports.getHxSearchInstrumentationEventTypeAsString = getHxSearchInstrumentationEventTypeAsString;
function getHxSearchInstrumentationEventTypeFromString(value) {
    return HxSearchInstrumentationEventType[value];
}
exports.getHxSearchInstrumentationEventTypeFromString = getHxSearchInstrumentationEventTypeFromString;
/*-------------------------------------------------------------------------------
  HxSearchInstrumentationType
-------------------------------------------------------------------------------*/
var HxSearchInstrumentationType;
(function (HxSearchInstrumentationType) {
    HxSearchInstrumentationType[HxSearchInstrumentationType["Suggestion"] = 0] = "Suggestion";
    HxSearchInstrumentationType[HxSearchInstrumentationType["ExecuteSearch"] = 2] = "ExecuteSearch";
    HxSearchInstrumentationType[HxSearchInstrumentationType["SubstrateSearch"] = 3] = "SubstrateSearch";
    HxSearchInstrumentationType[HxSearchInstrumentationType["FindContactsBySearchString"] = 4] = "FindContactsBySearchString";
    HxSearchInstrumentationType[HxSearchInstrumentationType["SearchContacts"] = 5] = "SearchContacts";
    HxSearchInstrumentationType[HxSearchInstrumentationType["SearchPeopleForAddressingOffline"] = 8] = "SearchPeopleForAddressingOffline";
    HxSearchInstrumentationType[HxSearchInstrumentationType["SearchPeopleForAddressingOnline"] = 9] = "SearchPeopleForAddressingOnline";
})(HxSearchInstrumentationType = exports.HxSearchInstrumentationType || (exports.HxSearchInstrumentationType = {}));
function getHxSearchInstrumentationTypeAsString(value) {
    return HxSearchInstrumentationType[value];
}
exports.getHxSearchInstrumentationTypeAsString = getHxSearchInstrumentationTypeAsString;
function getHxSearchInstrumentationTypeFromString(value) {
    return HxSearchInstrumentationType[value];
}
exports.getHxSearchInstrumentationTypeFromString = getHxSearchInstrumentationTypeFromString;
/*-------------------------------------------------------------------------------
  HxSearchProviderType
-------------------------------------------------------------------------------*/
var HxSearchProviderType;
(function (HxSearchProviderType) {
    HxSearchProviderType[HxSearchProviderType["None"] = 0] = "None";
    HxSearchProviderType[HxSearchProviderType["DeviceSyncOnline"] = 1] = "DeviceSyncOnline";
    HxSearchProviderType[HxSearchProviderType["DeviceSyncOffline"] = 2] = "DeviceSyncOffline";
    HxSearchProviderType[HxSearchProviderType["ExecuteSearch"] = 3] = "ExecuteSearch";
    HxSearchProviderType[HxSearchProviderType["SubstrateSearch"] = 4] = "SubstrateSearch";
    HxSearchProviderType[HxSearchProviderType["HxSDeviceOffline"] = 5] = "HxSDeviceOffline";
    HxSearchProviderType[HxSearchProviderType["WSS"] = 6] = "WSS";
    HxSearchProviderType[HxSearchProviderType["Spotlight"] = 7] = "Spotlight";
    HxSearchProviderType[HxSearchProviderType["HxStore"] = 9] = "HxStore";
})(HxSearchProviderType = exports.HxSearchProviderType || (exports.HxSearchProviderType = {}));
function getHxSearchProviderTypeAsString(value) {
    return HxSearchProviderType[value];
}
exports.getHxSearchProviderTypeAsString = getHxSearchProviderTypeAsString;
function getHxSearchProviderTypeFromString(value) {
    return HxSearchProviderType[value];
}
exports.getHxSearchProviderTypeFromString = getHxSearchProviderTypeFromString;
/*-------------------------------------------------------------------------------
  HxSearchFeedbackType
-------------------------------------------------------------------------------*/
var HxSearchFeedbackType;
(function (HxSearchFeedbackType) {
    HxSearchFeedbackType[HxSearchFeedbackType["None"] = 0] = "None";
    HxSearchFeedbackType[HxSearchFeedbackType["NoResults"] = 1] = "NoResults";
    HxSearchFeedbackType[HxSearchFeedbackType["Slow"] = 2] = "Slow";
    HxSearchFeedbackType[HxSearchFeedbackType["ResultsIrrelevant"] = 4] = "ResultsIrrelevant";
    HxSearchFeedbackType[HxSearchFeedbackType["Incomplete"] = 8] = "Incomplete";
    HxSearchFeedbackType[HxSearchFeedbackType["SuggestionsIrrelevant"] = 16] = "SuggestionsIrrelevant";
    HxSearchFeedbackType[HxSearchFeedbackType["HardToUse"] = 32] = "HardToUse";
    HxSearchFeedbackType[HxSearchFeedbackType["Other"] = 64] = "Other";
})(HxSearchFeedbackType = exports.HxSearchFeedbackType || (exports.HxSearchFeedbackType = {}));
function getHxSearchFeedbackTypeAsString(value) {
    return HxSearchFeedbackType[value];
}
exports.getHxSearchFeedbackTypeAsString = getHxSearchFeedbackTypeAsString;
function getHxSearchFeedbackTypeFromString(value) {
    return HxSearchFeedbackType[value];
}
exports.getHxSearchFeedbackTypeFromString = getHxSearchFeedbackTypeFromString;
/*-------------------------------------------------------------------------------
  HxSearchResultClearingBehavior
-------------------------------------------------------------------------------*/
var HxSearchResultClearingBehavior;
(function (HxSearchResultClearingBehavior) {
    HxSearchResultClearingBehavior[HxSearchResultClearingBehavior["ClearOnRequest"] = 0] = "ClearOnRequest";
    HxSearchResultClearingBehavior[HxSearchResultClearingBehavior["ClearOnNewResults"] = 1] = "ClearOnNewResults";
    HxSearchResultClearingBehavior[HxSearchResultClearingBehavior["NoClear"] = 2] = "NoClear";
})(HxSearchResultClearingBehavior = exports.HxSearchResultClearingBehavior || (exports.HxSearchResultClearingBehavior = {}));
function getHxSearchResultClearingBehaviorAsString(value) {
    return HxSearchResultClearingBehavior[value];
}
exports.getHxSearchResultClearingBehaviorAsString = getHxSearchResultClearingBehaviorAsString;
function getHxSearchResultClearingBehaviorFromString(value) {
    return HxSearchResultClearingBehavior[value];
}
exports.getHxSearchResultClearingBehaviorFromString = getHxSearchResultClearingBehaviorFromString;
/*-------------------------------------------------------------------------------
  HxSearchScope
-------------------------------------------------------------------------------*/
var HxSearchScope;
(function (HxSearchScope) {
    HxSearchScope[HxSearchScope["Unknown"] = 0] = "Unknown";
    HxSearchScope[HxSearchScope["AllFolders"] = 1] = "AllFolders";
    HxSearchScope[HxSearchScope["JustThisFolder"] = 2] = "JustThisFolder";
    HxSearchScope[HxSearchScope["ThisFolderAndSubFolders"] = 3] = "ThisFolderAndSubFolders";
})(HxSearchScope = exports.HxSearchScope || (exports.HxSearchScope = {}));
function getHxSearchScopeAsString(value) {
    return HxSearchScope[value];
}
exports.getHxSearchScopeAsString = getHxSearchScopeAsString;
function getHxSearchScopeFromString(value) {
    return HxSearchScope[value];
}
exports.getHxSearchScopeFromString = getHxSearchScopeFromString;
/*-------------------------------------------------------------------------------
  HxSearchSuggestionType
-------------------------------------------------------------------------------*/
var HxSearchSuggestionType;
(function (HxSearchSuggestionType) {
    HxSearchSuggestionType[HxSearchSuggestionType["None"] = 0] = "None";
    HxSearchSuggestionType[HxSearchSuggestionType["Keyword"] = 1] = "Keyword";
    HxSearchSuggestionType[HxSearchSuggestionType["People"] = 2] = "People";
})(HxSearchSuggestionType = exports.HxSearchSuggestionType || (exports.HxSearchSuggestionType = {}));
function getHxSearchSuggestionTypeAsString(value) {
    return HxSearchSuggestionType[value];
}
exports.getHxSearchSuggestionTypeAsString = getHxSearchSuggestionTypeAsString;
function getHxSearchSuggestionTypeFromString(value) {
    return HxSearchSuggestionType[value];
}
exports.getHxSearchSuggestionTypeFromString = getHxSearchSuggestionTypeFromString;
/*-------------------------------------------------------------------------------
  HxSearchInstrumentationScenario
-------------------------------------------------------------------------------*/
var HxSearchInstrumentationScenario;
(function (HxSearchInstrumentationScenario) {
    HxSearchInstrumentationScenario[HxSearchInstrumentationScenario["Unknown"] = 0] = "Unknown";
    HxSearchInstrumentationScenario[HxSearchInstrumentationScenario["Mail"] = 1] = "Mail";
    HxSearchInstrumentationScenario[HxSearchInstrumentationScenario["Calendar"] = 2] = "Calendar";
    HxSearchInstrumentationScenario[HxSearchInstrumentationScenario["People"] = 3] = "People";
    HxSearchInstrumentationScenario[HxSearchInstrumentationScenario["Suggestions"] = 4] = "Suggestions";
    HxSearchInstrumentationScenario[HxSearchInstrumentationScenario["CustomKey"] = 5] = "CustomKey";
    HxSearchInstrumentationScenario[HxSearchInstrumentationScenario["Answers"] = 6] = "Answers";
    HxSearchInstrumentationScenario[HxSearchInstrumentationScenario["Top"] = 7] = "Top";
    HxSearchInstrumentationScenario[HxSearchInstrumentationScenario["Recipient"] = 8] = "Recipient";
    HxSearchInstrumentationScenario[HxSearchInstrumentationScenario["Files"] = 9] = "Files";
})(HxSearchInstrumentationScenario = exports.HxSearchInstrumentationScenario || (exports.HxSearchInstrumentationScenario = {}));
function getHxSearchInstrumentationScenarioAsString(value) {
    return HxSearchInstrumentationScenario[value];
}
exports.getHxSearchInstrumentationScenarioAsString = getHxSearchInstrumentationScenarioAsString;
function getHxSearchInstrumentationScenarioFromString(value) {
    return HxSearchInstrumentationScenario[value];
}
exports.getHxSearchInstrumentationScenarioFromString = getHxSearchInstrumentationScenarioFromString;
/*-------------------------------------------------------------------------------
  HxPeopleSearchResultsType
-------------------------------------------------------------------------------*/
var HxPeopleSearchResultsType;
(function (HxPeopleSearchResultsType) {
    HxPeopleSearchResultsType[HxPeopleSearchResultsType["SearchPeople"] = 0] = "SearchPeople";
    HxPeopleSearchResultsType[HxPeopleSearchResultsType["SearchPeopleForAddressingOnline"] = 5] = "SearchPeopleForAddressingOnline";
    HxPeopleSearchResultsType[HxPeopleSearchResultsType["SearchPeopleForAddressingOffline"] = 6] = "SearchPeopleForAddressingOffline";
    HxPeopleSearchResultsType[HxPeopleSearchResultsType["SearchContacts"] = 3] = "SearchContacts";
    HxPeopleSearchResultsType[HxPeopleSearchResultsType["FindContactsBySearchString"] = 4] = "FindContactsBySearchString";
})(HxPeopleSearchResultsType = exports.HxPeopleSearchResultsType || (exports.HxPeopleSearchResultsType = {}));
function getHxPeopleSearchResultsTypeAsString(value) {
    return HxPeopleSearchResultsType[value];
}
exports.getHxPeopleSearchResultsTypeAsString = getHxPeopleSearchResultsTypeAsString;
function getHxPeopleSearchResultsTypeFromString(value) {
    return HxPeopleSearchResultsType[value];
}
exports.getHxPeopleSearchResultsTypeFromString = getHxPeopleSearchResultsTypeFromString;
/*-------------------------------------------------------------------------------
  HxSearchScenario
-------------------------------------------------------------------------------*/
var HxSearchScenario;
(function (HxSearchScenario) {
    HxSearchScenario[HxSearchScenario["None"] = 0] = "None";
    HxSearchScenario[HxSearchScenario["Answers"] = 32] = "Answers";
    HxSearchScenario[HxSearchScenario["Attachments"] = 1] = "Attachments";
    HxSearchScenario[HxSearchScenario["Calendar"] = 2] = "Calendar";
    HxSearchScenario[HxSearchScenario["Mail"] = 4] = "Mail";
    HxSearchScenario[HxSearchScenario["People"] = 8] = "People";
    HxSearchScenario[HxSearchScenario["Suggestions"] = 16] = "Suggestions";
    HxSearchScenario[HxSearchScenario["Top"] = 64] = "Top";
    HxSearchScenario[HxSearchScenario["Files"] = 128] = "Files";
})(HxSearchScenario = exports.HxSearchScenario || (exports.HxSearchScenario = {}));
function getHxSearchScenarioAsString(value) {
    return HxSearchScenario[value];
}
exports.getHxSearchScenarioAsString = getHxSearchScenarioAsString;
function getHxSearchScenarioFromString(value) {
    return HxSearchScenario[value];
}
exports.getHxSearchScenarioFromString = getHxSearchScenarioFromString;
/*-------------------------------------------------------------------------------
  HxCalendarSearchSortDirection
-------------------------------------------------------------------------------*/
var HxCalendarSearchSortDirection;
(function (HxCalendarSearchSortDirection) {
    HxCalendarSearchSortDirection[HxCalendarSearchSortDirection["Descending"] = 0] = "Descending";
    HxCalendarSearchSortDirection[HxCalendarSearchSortDirection["Ascending"] = 1] = "Ascending";
    HxCalendarSearchSortDirection[HxCalendarSearchSortDirection["Proximity"] = 2] = "Proximity";
})(HxCalendarSearchSortDirection = exports.HxCalendarSearchSortDirection || (exports.HxCalendarSearchSortDirection = {}));
function getHxCalendarSearchSortDirectionAsString(value) {
    return HxCalendarSearchSortDirection[value];
}
exports.getHxCalendarSearchSortDirectionAsString = getHxCalendarSearchSortDirectionAsString;
function getHxCalendarSearchSortDirectionFromString(value) {
    return HxCalendarSearchSortDirection[value];
}
exports.getHxCalendarSearchSortDirectionFromString = getHxCalendarSearchSortDirectionFromString;
/*-------------------------------------------------------------------------------
  HxSearchResultType
-------------------------------------------------------------------------------*/
var HxSearchResultType;
(function (HxSearchResultType) {
    HxSearchResultType[HxSearchResultType["Message"] = 0] = "Message";
    HxSearchResultType[HxSearchResultType["Appointment"] = 1] = "Appointment";
    HxSearchResultType[HxSearchResultType["Person"] = 2] = "Person";
    HxSearchResultType[HxSearchResultType["File"] = 3] = "File";
})(HxSearchResultType = exports.HxSearchResultType || (exports.HxSearchResultType = {}));
function getHxSearchResultTypeAsString(value) {
    return HxSearchResultType[value];
}
exports.getHxSearchResultTypeAsString = getHxSearchResultTypeAsString;
function getHxSearchResultTypeFromString(value) {
    return HxSearchResultType[value];
}
exports.getHxSearchResultTypeFromString = getHxSearchResultTypeFromString;
/*-------------------------------------------------------------------------------
  HxComposeContextType
-------------------------------------------------------------------------------*/
var HxComposeContextType;
(function (HxComposeContextType) {
    HxComposeContextType[HxComposeContextType["MailCompose"] = 0] = "MailCompose";
    HxComposeContextType[HxComposeContextType["EventCompose"] = 1] = "EventCompose";
})(HxComposeContextType = exports.HxComposeContextType || (exports.HxComposeContextType = {}));
function getHxComposeContextTypeAsString(value) {
    return HxComposeContextType[value];
}
exports.getHxComposeContextTypeAsString = getHxComposeContextTypeAsString;
function getHxComposeContextTypeFromString(value) {
    return HxComposeContextType[value];
}
exports.getHxComposeContextTypeFromString = getHxComposeContextTypeFromString;
/*-------------------------------------------------------------------------------
  HxTeachingCalloutType
-------------------------------------------------------------------------------*/
var HxTeachingCalloutType;
(function (HxTeachingCalloutType) {
    HxTeachingCalloutType[HxTeachingCalloutType["None"] = 0] = "None";
    HxTeachingCalloutType[HxTeachingCalloutType["Swipe"] = 1] = "Swipe";
    HxTeachingCalloutType[HxTeachingCalloutType["ChangeSwipe"] = 2] = "ChangeSwipe";
    HxTeachingCalloutType[HxTeachingCalloutType["RateOurApp"] = 4] = "RateOurApp";
    HxTeachingCalloutType[HxTeachingCalloutType["FocusedInbox"] = 32] = "FocusedInbox";
    HxTeachingCalloutType[HxTeachingCalloutType["InterestingCalendars"] = 64] = "InterestingCalendars";
    HxTeachingCalloutType[HxTeachingCalloutType["AtMentionsFilter"] = 128] = "AtMentionsFilter";
    HxTeachingCalloutType[HxTeachingCalloutType["FamilyCalendar"] = 1024] = "FamilyCalendar";
    HxTeachingCalloutType[HxTeachingCalloutType["SportsPromotion"] = 4096] = "SportsPromotion";
    HxTeachingCalloutType[HxTeachingCalloutType["NewEventPromotion"] = 8192] = "NewEventPromotion";
    HxTeachingCalloutType[HxTeachingCalloutType["AddAccountPromotion"] = 16384] = "AddAccountPromotion";
    HxTeachingCalloutType[HxTeachingCalloutType["TryNewCalendarApp"] = 32768] = "TryNewCalendarApp";
})(HxTeachingCalloutType = exports.HxTeachingCalloutType || (exports.HxTeachingCalloutType = {}));
function getHxTeachingCalloutTypeAsString(value) {
    return HxTeachingCalloutType[value];
}
exports.getHxTeachingCalloutTypeAsString = getHxTeachingCalloutTypeAsString;
function getHxTeachingCalloutTypeFromString(value) {
    return HxTeachingCalloutType[value];
}
exports.getHxTeachingCalloutTypeFromString = getHxTeachingCalloutTypeFromString;
/*-------------------------------------------------------------------------------
  HxTeachingTriggerType
-------------------------------------------------------------------------------*/
var HxTeachingTriggerType;
(function (HxTeachingTriggerType) {
    HxTeachingTriggerType[HxTeachingTriggerType["None"] = 0] = "None";
    HxTeachingTriggerType[HxTeachingTriggerType["Archive"] = 1] = "Archive";
    HxTeachingTriggerType[HxTeachingTriggerType["Delete"] = 2] = "Delete";
    HxTeachingTriggerType[HxTeachingTriggerType["MoveTo"] = 3] = "MoveTo";
    HxTeachingTriggerType[HxTeachingTriggerType["ToggleFlag"] = 4] = "ToggleFlag";
    HxTeachingTriggerType[HxTeachingTriggerType["ToggleRead"] = 5] = "ToggleRead";
    HxTeachingTriggerType[HxTeachingTriggerType["SendMail"] = 6] = "SendMail";
    HxTeachingTriggerType[HxTeachingTriggerType["ReadMail"] = 7] = "ReadMail";
    HxTeachingTriggerType[HxTeachingTriggerType["AllFoldersOpened"] = 8] = "AllFoldersOpened";
    HxTeachingTriggerType[HxTeachingTriggerType["LinkedMailAccountsChanged"] = 9] = "LinkedMailAccountsChanged";
    HxTeachingTriggerType[HxTeachingTriggerType["CurrentViewChanged"] = 11] = "CurrentViewChanged";
    HxTeachingTriggerType[HxTeachingTriggerType["ActivityColumnPaneLoaded"] = 12] = "ActivityColumnPaneLoaded";
    HxTeachingTriggerType[HxTeachingTriggerType["ConversationWithMentionOpened"] = 13] = "ConversationWithMentionOpened";
    HxTeachingTriggerType[HxTeachingTriggerType["MessageViewReady"] = 14] = "MessageViewReady";
})(HxTeachingTriggerType = exports.HxTeachingTriggerType || (exports.HxTeachingTriggerType = {}));
function getHxTeachingTriggerTypeAsString(value) {
    return HxTeachingTriggerType[value];
}
exports.getHxTeachingTriggerTypeAsString = getHxTeachingTriggerTypeAsString;
function getHxTeachingTriggerTypeFromString(value) {
    return HxTeachingTriggerType[value];
}
exports.getHxTeachingTriggerTypeFromString = getHxTeachingTriggerTypeFromString;
/*-------------------------------------------------------------------------------
  HxAppointmentRepeatItemType
-------------------------------------------------------------------------------*/
var HxAppointmentRepeatItemType;
(function (HxAppointmentRepeatItemType) {
    HxAppointmentRepeatItemType[HxAppointmentRepeatItemType["Single"] = 0] = "Single";
    HxAppointmentRepeatItemType[HxAppointmentRepeatItemType["Instance"] = 1] = "Instance";
    HxAppointmentRepeatItemType[HxAppointmentRepeatItemType["Exception"] = 2] = "Exception";
    HxAppointmentRepeatItemType[HxAppointmentRepeatItemType["Series"] = 3] = "Series";
})(HxAppointmentRepeatItemType = exports.HxAppointmentRepeatItemType || (exports.HxAppointmentRepeatItemType = {}));
function getHxAppointmentRepeatItemTypeAsString(value) {
    return HxAppointmentRepeatItemType[value];
}
exports.getHxAppointmentRepeatItemTypeAsString = getHxAppointmentRepeatItemTypeAsString;
function getHxAppointmentRepeatItemTypeFromString(value) {
    return HxAppointmentRepeatItemType[value];
}
exports.getHxAppointmentRepeatItemTypeFromString = getHxAppointmentRepeatItemTypeFromString;
/*-------------------------------------------------------------------------------
  HxAppointmentSensitivity
-------------------------------------------------------------------------------*/
var HxAppointmentSensitivity;
(function (HxAppointmentSensitivity) {
    HxAppointmentSensitivity[HxAppointmentSensitivity["Normal"] = 0] = "Normal";
    HxAppointmentSensitivity[HxAppointmentSensitivity["Personal"] = 1] = "Personal";
    HxAppointmentSensitivity[HxAppointmentSensitivity["Private"] = 2] = "Private";
    HxAppointmentSensitivity[HxAppointmentSensitivity["Confidential"] = 3] = "Confidential";
})(HxAppointmentSensitivity = exports.HxAppointmentSensitivity || (exports.HxAppointmentSensitivity = {}));
function getHxAppointmentSensitivityAsString(value) {
    return HxAppointmentSensitivity[value];
}
exports.getHxAppointmentSensitivityAsString = getHxAppointmentSensitivityAsString;
function getHxAppointmentSensitivityFromString(value) {
    return HxAppointmentSensitivity[value];
}
exports.getHxAppointmentSensitivityFromString = getHxAppointmentSensitivityFromString;
/*-------------------------------------------------------------------------------
  HxAppointmentFreeBusyState
-------------------------------------------------------------------------------*/
var HxAppointmentFreeBusyState;
(function (HxAppointmentFreeBusyState) {
    HxAppointmentFreeBusyState[HxAppointmentFreeBusyState["Free"] = 0] = "Free";
    HxAppointmentFreeBusyState[HxAppointmentFreeBusyState["Tentative"] = 1] = "Tentative";
    HxAppointmentFreeBusyState[HxAppointmentFreeBusyState["Busy"] = 2] = "Busy";
    HxAppointmentFreeBusyState[HxAppointmentFreeBusyState["OOF"] = 3] = "OOF";
    HxAppointmentFreeBusyState[HxAppointmentFreeBusyState["WorkingElsewhere"] = 4] = "WorkingElsewhere";
    HxAppointmentFreeBusyState[HxAppointmentFreeBusyState["Unknown"] = 5] = "Unknown";
})(HxAppointmentFreeBusyState = exports.HxAppointmentFreeBusyState || (exports.HxAppointmentFreeBusyState = {}));
function getHxAppointmentFreeBusyStateAsString(value) {
    return HxAppointmentFreeBusyState[value];
}
exports.getHxAppointmentFreeBusyStateAsString = getHxAppointmentFreeBusyStateAsString;
function getHxAppointmentFreeBusyStateFromString(value) {
    return HxAppointmentFreeBusyState[value];
}
exports.getHxAppointmentFreeBusyStateFromString = getHxAppointmentFreeBusyStateFromString;
/*-------------------------------------------------------------------------------
  HxAppointmentPropertyId
-------------------------------------------------------------------------------*/
var HxAppointmentPropertyId;
(function (HxAppointmentPropertyId) {
    HxAppointmentPropertyId[HxAppointmentPropertyId["None"] = 0] = "None";
    HxAppointmentPropertyId[HxAppointmentPropertyId["Id"] = 1] = "Id";
    HxAppointmentPropertyId[HxAppointmentPropertyId["CalendarId"] = 2] = "CalendarId";
    HxAppointmentPropertyId[HxAppointmentPropertyId["Subject"] = 3] = "Subject";
    HxAppointmentPropertyId[HxAppointmentPropertyId["Location"] = 4] = "Location";
    HxAppointmentPropertyId[HxAppointmentPropertyId["IsOrganizer"] = 5] = "IsOrganizer";
    HxAppointmentPropertyId[HxAppointmentPropertyId["Organizer"] = 6] = "Organizer";
    HxAppointmentPropertyId[HxAppointmentPropertyId["Categories"] = 7] = "Categories";
    HxAppointmentPropertyId[HxAppointmentPropertyId["IsReminderSet"] = 8] = "IsReminderSet";
    HxAppointmentPropertyId[HxAppointmentPropertyId["ReminderLeadTime"] = 9] = "ReminderLeadTime";
    HxAppointmentPropertyId[HxAppointmentPropertyId["FreeBusyState"] = 11] = "FreeBusyState";
    HxAppointmentPropertyId[HxAppointmentPropertyId["Sensitivity"] = 12] = "Sensitivity";
    HxAppointmentPropertyId[HxAppointmentPropertyId["Importance"] = 13] = "Importance";
    HxAppointmentPropertyId[HxAppointmentPropertyId["RepeatSeriesData"] = 14] = "RepeatSeriesData";
    HxAppointmentPropertyId[HxAppointmentPropertyId["Attachments"] = 15] = "Attachments";
    HxAppointmentPropertyId[HxAppointmentPropertyId["Attendees"] = 16] = "Attendees";
    HxAppointmentPropertyId[HxAppointmentPropertyId["DirtyAttendees"] = 17] = "DirtyAttendees";
    HxAppointmentPropertyId[HxAppointmentPropertyId["Body"] = 18] = "Body";
    HxAppointmentPropertyId[HxAppointmentPropertyId["IsAllDay"] = 19] = "IsAllDay";
    HxAppointmentPropertyId[HxAppointmentPropertyId["ResponseStatus"] = 20] = "ResponseStatus";
    HxAppointmentPropertyId[HxAppointmentPropertyId["HasAttendees"] = 21] = "HasAttendees";
    HxAppointmentPropertyId[HxAppointmentPropertyId["SendTime"] = 22] = "SendTime";
    HxAppointmentPropertyId[HxAppointmentPropertyId["CancellationTime"] = 23] = "CancellationTime";
    HxAppointmentPropertyId[HxAppointmentPropertyId["RepeatItemType"] = 24] = "RepeatItemType";
    HxAppointmentPropertyId[HxAppointmentPropertyId["TimeRangeUtc"] = 25] = "TimeRangeUtc";
    HxAppointmentPropertyId[HxAppointmentPropertyId["ParentAppointmentId"] = 26] = "ParentAppointmentId";
    HxAppointmentPropertyId[HxAppointmentPropertyId["IsCancelled"] = 27] = "IsCancelled";
    HxAppointmentPropertyId[HxAppointmentPropertyId["PropertiesToCommit"] = 28] = "PropertiesToCommit";
    HxAppointmentPropertyId[HxAppointmentPropertyId["ExceptionalProperties"] = 29] = "ExceptionalProperties";
    HxAppointmentPropertyId[HxAppointmentPropertyId["AddedInstances"] = 30] = "AddedInstances";
    HxAppointmentPropertyId[HxAppointmentPropertyId["RemovedInstances"] = 31] = "RemovedInstances";
    HxAppointmentPropertyId[HxAppointmentPropertyId["ResponsesRequested"] = 32] = "ResponsesRequested";
    HxAppointmentPropertyId[HxAppointmentPropertyId["StartTimeZoneId"] = 33] = "StartTimeZoneId";
    HxAppointmentPropertyId[HxAppointmentPropertyId["StartTimeZoneRule"] = 34] = "StartTimeZoneRule";
    HxAppointmentPropertyId[HxAppointmentPropertyId["EndTimeZoneId"] = 35] = "EndTimeZoneId";
    HxAppointmentPropertyId[HxAppointmentPropertyId["EndTimeZoneRule"] = 36] = "EndTimeZoneRule";
    HxAppointmentPropertyId[HxAppointmentPropertyId["OriginalStartDate"] = 37] = "OriginalStartDate";
    HxAppointmentPropertyId[HxAppointmentPropertyId["DeviceLocalId"] = 38] = "DeviceLocalId";
    HxAppointmentPropertyId[HxAppointmentPropertyId["DeviceRoamingId"] = 39] = "DeviceRoamingId";
    HxAppointmentPropertyId[HxAppointmentPropertyId["Uri"] = 40] = "Uri";
    HxAppointmentPropertyId[HxAppointmentPropertyId["LegacyCalendarColor"] = 67] = "LegacyCalendarColor";
    HxAppointmentPropertyId[HxAppointmentPropertyId["CategoryColor"] = 42] = "CategoryColor";
    HxAppointmentPropertyId[HxAppointmentPropertyId["BodyPreview"] = 43] = "BodyPreview";
    HxAppointmentPropertyId[HxAppointmentPropertyId["IsOnlineMeeting"] = 44] = "IsOnlineMeeting";
    HxAppointmentPropertyId[HxAppointmentPropertyId["OnlineMeetingConfLink"] = 45] = "OnlineMeetingConfLink";
    HxAppointmentPropertyId[HxAppointmentPropertyId["OnlineMeetingExternalLink"] = 46] = "OnlineMeetingExternalLink";
    HxAppointmentPropertyId[HxAppointmentPropertyId["IntendedFreeBusyState"] = 47] = "IntendedFreeBusyState";
    HxAppointmentPropertyId[HxAppointmentPropertyId["CapabilitiesData"] = 48] = "CapabilitiesData";
    HxAppointmentPropertyId[HxAppointmentPropertyId["AccountId"] = 49] = "AccountId";
    HxAppointmentPropertyId[HxAppointmentPropertyId["BodyType"] = 50] = "BodyType";
    HxAppointmentPropertyId[HxAppointmentPropertyId["Charm"] = 51] = "Charm";
    HxAppointmentPropertyId[HxAppointmentPropertyId["TailoredEventType"] = 52] = "TailoredEventType";
    HxAppointmentPropertyId[HxAppointmentPropertyId["TailoredEventDetails"] = 53] = "TailoredEventDetails";
    HxAppointmentPropertyId[HxAppointmentPropertyId["ResponseTime"] = 54] = "ResponseTime";
    HxAppointmentPropertyId[HxAppointmentPropertyId["LinkedEmail"] = 55] = "LinkedEmail";
    HxAppointmentPropertyId[HxAppointmentPropertyId["ReminderTime"] = 57] = "ReminderTime";
    HxAppointmentPropertyId[HxAppointmentPropertyId["OutlookReferencePartId"] = 60] = "OutlookReferencePartId";
    HxAppointmentPropertyId[HxAppointmentPropertyId["CalendarColor"] = 41] = "CalendarColor";
    HxAppointmentPropertyId[HxAppointmentPropertyId["EnhancedLocationCollection"] = 62] = "EnhancedLocationCollection";
    HxAppointmentPropertyId[HxAppointmentPropertyId["ServerId"] = 63] = "ServerId";
    HxAppointmentPropertyId[HxAppointmentPropertyId["AddedAttachments"] = 64] = "AddedAttachments";
    HxAppointmentPropertyId[HxAppointmentPropertyId["RemovedAttachments"] = 65] = "RemovedAttachments";
    HxAppointmentPropertyId[HxAppointmentPropertyId["DraftId"] = 66] = "DraftId";
    HxAppointmentPropertyId[HxAppointmentPropertyId["DoNotForwardMeeting"] = 68] = "DoNotForwardMeeting";
    HxAppointmentPropertyId[HxAppointmentPropertyId["OnlineMeetingProvider"] = 69] = "OnlineMeetingProvider";
    HxAppointmentPropertyId[HxAppointmentPropertyId["OnlineMeetingJoinUrl"] = 70] = "OnlineMeetingJoinUrl";
    HxAppointmentPropertyId[HxAppointmentPropertyId["OnlineMeetingConferenceId"] = 71] = "OnlineMeetingConferenceId";
    HxAppointmentPropertyId[HxAppointmentPropertyId["OnlineMeetingTollNumber"] = 72] = "OnlineMeetingTollNumber";
    HxAppointmentPropertyId[HxAppointmentPropertyId["OnlineMeetingTollFreeNumbers"] = 73] = "OnlineMeetingTollFreeNumbers";
    HxAppointmentPropertyId[HxAppointmentPropertyId["OnlineMeetingQuickDial"] = 74] = "OnlineMeetingQuickDial";
    HxAppointmentPropertyId[HxAppointmentPropertyId["ConferenceMeetingInfo"] = 75] = "ConferenceMeetingInfo";
    HxAppointmentPropertyId[HxAppointmentPropertyId["DisallowNewTimeProposal"] = 76] = "DisallowNewTimeProposal";
    HxAppointmentPropertyId[HxAppointmentPropertyId["IsDraft"] = 77] = "IsDraft";
})(HxAppointmentPropertyId = exports.HxAppointmentPropertyId || (exports.HxAppointmentPropertyId = {}));
function getHxAppointmentPropertyIdAsString(value) {
    return HxAppointmentPropertyId[value];
}
exports.getHxAppointmentPropertyIdAsString = getHxAppointmentPropertyIdAsString;
function getHxAppointmentPropertyIdFromString(value) {
    return HxAppointmentPropertyId[value];
}
exports.getHxAppointmentPropertyIdFromString = getHxAppointmentPropertyIdFromString;
/*-------------------------------------------------------------------------------
  HxAppointmentSummaryCardView
-------------------------------------------------------------------------------*/
var HxAppointmentSummaryCardView;
(function (HxAppointmentSummaryCardView) {
    HxAppointmentSummaryCardView[HxAppointmentSummaryCardView["System"] = 0] = "System";
    HxAppointmentSummaryCardView[HxAppointmentSummaryCardView["App"] = 1] = "App";
})(HxAppointmentSummaryCardView = exports.HxAppointmentSummaryCardView || (exports.HxAppointmentSummaryCardView = {}));
function getHxAppointmentSummaryCardViewAsString(value) {
    return HxAppointmentSummaryCardView[value];
}
exports.getHxAppointmentSummaryCardViewAsString = getHxAppointmentSummaryCardViewAsString;
function getHxAppointmentSummaryCardViewFromString(value) {
    return HxAppointmentSummaryCardView[value];
}
exports.getHxAppointmentSummaryCardViewFromString = getHxAppointmentSummaryCardViewFromString;
/*-------------------------------------------------------------------------------
  HxAttendeeType
-------------------------------------------------------------------------------*/
var HxAttendeeType;
(function (HxAttendeeType) {
    HxAttendeeType[HxAttendeeType["Required"] = 0] = "Required";
    HxAttendeeType[HxAttendeeType["Optional"] = 1] = "Optional";
    HxAttendeeType[HxAttendeeType["Resource"] = 2] = "Resource";
})(HxAttendeeType = exports.HxAttendeeType || (exports.HxAttendeeType = {}));
function getHxAttendeeTypeAsString(value) {
    return HxAttendeeType[value];
}
exports.getHxAttendeeTypeAsString = getHxAttendeeTypeAsString;
function getHxAttendeeTypeFromString(value) {
    return HxAttendeeType[value];
}
exports.getHxAttendeeTypeFromString = getHxAttendeeTypeFromString;
/*-------------------------------------------------------------------------------
  HxAvailabilityDataResponseCodeType
-------------------------------------------------------------------------------*/
var HxAvailabilityDataResponseCodeType;
(function (HxAvailabilityDataResponseCodeType) {
    HxAvailabilityDataResponseCodeType[HxAvailabilityDataResponseCodeType["Success"] = 0] = "Success";
    HxAvailabilityDataResponseCodeType[HxAvailabilityDataResponseCodeType["Warning"] = 1] = "Warning";
    HxAvailabilityDataResponseCodeType[HxAvailabilityDataResponseCodeType["Error"] = 2] = "Error";
})(HxAvailabilityDataResponseCodeType = exports.HxAvailabilityDataResponseCodeType || (exports.HxAvailabilityDataResponseCodeType = {}));
function getHxAvailabilityDataResponseCodeTypeAsString(value) {
    return HxAvailabilityDataResponseCodeType[value];
}
exports.getHxAvailabilityDataResponseCodeTypeAsString = getHxAvailabilityDataResponseCodeTypeAsString;
function getHxAvailabilityDataResponseCodeTypeFromString(value) {
    return HxAvailabilityDataResponseCodeType[value];
}
exports.getHxAvailabilityDataResponseCodeTypeFromString = getHxAvailabilityDataResponseCodeTypeFromString;
/*-------------------------------------------------------------------------------
  HxLegacyCalendarColorType
-------------------------------------------------------------------------------*/
var HxLegacyCalendarColorType;
(function (HxLegacyCalendarColorType) {
    HxLegacyCalendarColorType[HxLegacyCalendarColorType["None"] = 0] = "None";
    HxLegacyCalendarColorType[HxLegacyCalendarColorType["Auto"] = 1] = "Auto";
    HxLegacyCalendarColorType[HxLegacyCalendarColorType["LightBlue"] = 2] = "LightBlue";
    HxLegacyCalendarColorType[HxLegacyCalendarColorType["LightGreen"] = 3] = "LightGreen";
    HxLegacyCalendarColorType[HxLegacyCalendarColorType["LightOrange"] = 4] = "LightOrange";
    HxLegacyCalendarColorType[HxLegacyCalendarColorType["LightGray"] = 5] = "LightGray";
    HxLegacyCalendarColorType[HxLegacyCalendarColorType["LightYellow"] = 6] = "LightYellow";
    HxLegacyCalendarColorType[HxLegacyCalendarColorType["LightTeal"] = 7] = "LightTeal";
    HxLegacyCalendarColorType[HxLegacyCalendarColorType["LightPink"] = 8] = "LightPink";
    HxLegacyCalendarColorType[HxLegacyCalendarColorType["LightPeach"] = 9] = "LightPeach";
    HxLegacyCalendarColorType[HxLegacyCalendarColorType["LightRed"] = 10] = "LightRed";
    HxLegacyCalendarColorType[HxLegacyCalendarColorType["MaxColor"] = 11] = "MaxColor";
})(HxLegacyCalendarColorType = exports.HxLegacyCalendarColorType || (exports.HxLegacyCalendarColorType = {}));
function getHxLegacyCalendarColorTypeAsString(value) {
    return HxLegacyCalendarColorType[value];
}
exports.getHxLegacyCalendarColorTypeAsString = getHxLegacyCalendarColorTypeAsString;
function getHxLegacyCalendarColorTypeFromString(value) {
    return HxLegacyCalendarColorType[value];
}
exports.getHxLegacyCalendarColorTypeFromString = getHxLegacyCalendarColorTypeFromString;
/*-------------------------------------------------------------------------------
  HxCalendarColorOptions
-------------------------------------------------------------------------------*/
var HxCalendarColorOptions;
(function (HxCalendarColorOptions) {
    HxCalendarColorOptions[HxCalendarColorOptions["Light"] = 0] = "Light";
    HxCalendarColorOptions[HxCalendarColorOptions["Bright"] = 1] = "Bright";
})(HxCalendarColorOptions = exports.HxCalendarColorOptions || (exports.HxCalendarColorOptions = {}));
function getHxCalendarColorOptionsAsString(value) {
    return HxCalendarColorOptions[value];
}
exports.getHxCalendarColorOptionsAsString = getHxCalendarColorOptionsAsString;
function getHxCalendarColorOptionsFromString(value) {
    return HxCalendarColorOptions[value];
}
exports.getHxCalendarColorOptionsFromString = getHxCalendarColorOptionsFromString;
/*-------------------------------------------------------------------------------
  HxCategoryColorType
-------------------------------------------------------------------------------*/
var HxCategoryColorType;
(function (HxCategoryColorType) {
    HxCategoryColorType[HxCategoryColorType["NoneSet"] = 0] = "NoneSet";
    HxCategoryColorType[HxCategoryColorType["Red"] = 1] = "Red";
    HxCategoryColorType[HxCategoryColorType["Orange"] = 2] = "Orange";
    HxCategoryColorType[HxCategoryColorType["Peach"] = 3] = "Peach";
    HxCategoryColorType[HxCategoryColorType["Yellow"] = 4] = "Yellow";
    HxCategoryColorType[HxCategoryColorType["Green"] = 5] = "Green";
    HxCategoryColorType[HxCategoryColorType["Teal"] = 6] = "Teal";
    HxCategoryColorType[HxCategoryColorType["Olive"] = 7] = "Olive";
    HxCategoryColorType[HxCategoryColorType["Blue"] = 8] = "Blue";
    HxCategoryColorType[HxCategoryColorType["Purple"] = 9] = "Purple";
    HxCategoryColorType[HxCategoryColorType["Maroon"] = 10] = "Maroon";
    HxCategoryColorType[HxCategoryColorType["Steel"] = 11] = "Steel";
    HxCategoryColorType[HxCategoryColorType["DarkSteel"] = 12] = "DarkSteel";
    HxCategoryColorType[HxCategoryColorType["Gray"] = 13] = "Gray";
    HxCategoryColorType[HxCategoryColorType["DarkGray"] = 14] = "DarkGray";
    HxCategoryColorType[HxCategoryColorType["Black"] = 15] = "Black";
    HxCategoryColorType[HxCategoryColorType["DarkRed"] = 16] = "DarkRed";
    HxCategoryColorType[HxCategoryColorType["DarkOrange"] = 17] = "DarkOrange";
    HxCategoryColorType[HxCategoryColorType["DarkPeach"] = 18] = "DarkPeach";
    HxCategoryColorType[HxCategoryColorType["DarkYellow"] = 19] = "DarkYellow";
    HxCategoryColorType[HxCategoryColorType["DarkGreen"] = 20] = "DarkGreen";
    HxCategoryColorType[HxCategoryColorType["DarkTeal"] = 21] = "DarkTeal";
    HxCategoryColorType[HxCategoryColorType["DarkOlive"] = 22] = "DarkOlive";
    HxCategoryColorType[HxCategoryColorType["DarkBlue"] = 23] = "DarkBlue";
    HxCategoryColorType[HxCategoryColorType["DarkPurple"] = 24] = "DarkPurple";
    HxCategoryColorType[HxCategoryColorType["DarkMaroon"] = 25] = "DarkMaroon";
    HxCategoryColorType[HxCategoryColorType["MaxColor"] = 26] = "MaxColor";
})(HxCategoryColorType = exports.HxCategoryColorType || (exports.HxCategoryColorType = {}));
function getHxCategoryColorTypeAsString(value) {
    return HxCategoryColorType[value];
}
exports.getHxCategoryColorTypeAsString = getHxCategoryColorTypeAsString;
function getHxCategoryColorTypeFromString(value) {
    return HxCategoryColorType[value];
}
exports.getHxCategoryColorTypeFromString = getHxCategoryColorTypeFromString;
/*-------------------------------------------------------------------------------
  HxFreeBusyViewType
-------------------------------------------------------------------------------*/
var HxFreeBusyViewType;
(function (HxFreeBusyViewType) {
    HxFreeBusyViewType[HxFreeBusyViewType["None"] = 0] = "None";
    HxFreeBusyViewType[HxFreeBusyViewType["MergedOnly"] = 1] = "MergedOnly";
    HxFreeBusyViewType[HxFreeBusyViewType["FreeBusy"] = 2] = "FreeBusy";
    HxFreeBusyViewType[HxFreeBusyViewType["FreeBusyMerged"] = 3] = "FreeBusyMerged";
    HxFreeBusyViewType[HxFreeBusyViewType["Detailed"] = 4] = "Detailed";
    HxFreeBusyViewType[HxFreeBusyViewType["DetailedMerged"] = 5] = "DetailedMerged";
})(HxFreeBusyViewType = exports.HxFreeBusyViewType || (exports.HxFreeBusyViewType = {}));
function getHxFreeBusyViewTypeAsString(value) {
    return HxFreeBusyViewType[value];
}
exports.getHxFreeBusyViewTypeAsString = getHxFreeBusyViewTypeAsString;
function getHxFreeBusyViewTypeFromString(value) {
    return HxFreeBusyViewType[value];
}
exports.getHxFreeBusyViewTypeFromString = getHxFreeBusyViewTypeFromString;
/*-------------------------------------------------------------------------------
  HxNetworkStatusCodeType
-------------------------------------------------------------------------------*/
var HxNetworkStatusCodeType;
(function (HxNetworkStatusCodeType) {
    HxNetworkStatusCodeType[HxNetworkStatusCodeType["Success"] = 0] = "Success";
    HxNetworkStatusCodeType[HxNetworkStatusCodeType["Failed"] = 1] = "Failed";
})(HxNetworkStatusCodeType = exports.HxNetworkStatusCodeType || (exports.HxNetworkStatusCodeType = {}));
function getHxNetworkStatusCodeTypeAsString(value) {
    return HxNetworkStatusCodeType[value];
}
exports.getHxNetworkStatusCodeTypeAsString = getHxNetworkStatusCodeTypeAsString;
function getHxNetworkStatusCodeTypeFromString(value) {
    return HxNetworkStatusCodeType[value];
}
exports.getHxNetworkStatusCodeTypeFromString = getHxNetworkStatusCodeTypeFromString;
/*-------------------------------------------------------------------------------
  HxRepeatExpansionType
-------------------------------------------------------------------------------*/
var HxRepeatExpansionType;
(function (HxRepeatExpansionType) {
    HxRepeatExpansionType[HxRepeatExpansionType["NoExpansion"] = 0] = "NoExpansion";
    HxRepeatExpansionType[HxRepeatExpansionType["NormalExpansion"] = 1] = "NormalExpansion";
    HxRepeatExpansionType[HxRepeatExpansionType["NonHxSDestructiveUpdate"] = 2] = "NonHxSDestructiveUpdate";
})(HxRepeatExpansionType = exports.HxRepeatExpansionType || (exports.HxRepeatExpansionType = {}));
function getHxRepeatExpansionTypeAsString(value) {
    return HxRepeatExpansionType[value];
}
exports.getHxRepeatExpansionTypeAsString = getHxRepeatExpansionTypeAsString;
function getHxRepeatExpansionTypeFromString(value) {
    return HxRepeatExpansionType[value];
}
exports.getHxRepeatExpansionTypeFromString = getHxRepeatExpansionTypeFromString;
/*-------------------------------------------------------------------------------
  HxCalendarReadAccessType
-------------------------------------------------------------------------------*/
var HxCalendarReadAccessType;
(function (HxCalendarReadAccessType) {
    HxCalendarReadAccessType[HxCalendarReadAccessType["Full"] = 0] = "Full";
    HxCalendarReadAccessType[HxCalendarReadAccessType["Limited"] = 1] = "Limited";
    HxCalendarReadAccessType[HxCalendarReadAccessType["SystemOnly"] = 2] = "SystemOnly";
})(HxCalendarReadAccessType = exports.HxCalendarReadAccessType || (exports.HxCalendarReadAccessType = {}));
function getHxCalendarReadAccessTypeAsString(value) {
    return HxCalendarReadAccessType[value];
}
exports.getHxCalendarReadAccessTypeAsString = getHxCalendarReadAccessTypeAsString;
function getHxCalendarReadAccessTypeFromString(value) {
    return HxCalendarReadAccessType[value];
}
exports.getHxCalendarReadAccessTypeFromString = getHxCalendarReadAccessTypeFromString;
/*-------------------------------------------------------------------------------
  HxCalendarViewStateType
-------------------------------------------------------------------------------*/
var HxCalendarViewStateType;
(function (HxCalendarViewStateType) {
    HxCalendarViewStateType[HxCalendarViewStateType["Enabled"] = 0] = "Enabled";
    HxCalendarViewStateType[HxCalendarViewStateType["Disabled"] = 1] = "Disabled";
})(HxCalendarViewStateType = exports.HxCalendarViewStateType || (exports.HxCalendarViewStateType = {}));
function getHxCalendarViewStateTypeAsString(value) {
    return HxCalendarViewStateType[value];
}
exports.getHxCalendarViewStateTypeAsString = getHxCalendarViewStateTypeAsString;
function getHxCalendarViewStateTypeFromString(value) {
    return HxCalendarViewStateType[value];
}
exports.getHxCalendarViewStateTypeFromString = getHxCalendarViewStateTypeFromString;
/*-------------------------------------------------------------------------------
  HxCalendarPropertyId
-------------------------------------------------------------------------------*/
var HxCalendarPropertyId;
(function (HxCalendarPropertyId) {
    HxCalendarPropertyId[HxCalendarPropertyId["None"] = 0] = "None";
    HxCalendarPropertyId[HxCalendarPropertyId["Id"] = 1] = "Id";
    HxCalendarPropertyId[HxCalendarPropertyId["DisplayName"] = 2] = "DisplayName";
    HxCalendarPropertyId[HxCalendarPropertyId["LegacyColor"] = 20] = "LegacyColor";
    HxCalendarPropertyId[HxCalendarPropertyId["Index"] = 4] = "Index";
    HxCalendarPropertyId[HxCalendarPropertyId["ParentGroupId"] = 5] = "ParentGroupId";
    HxCalendarPropertyId[HxCalendarPropertyId["IsDefault"] = 6] = "IsDefault";
    HxCalendarPropertyId[HxCalendarPropertyId["AccountId"] = 7] = "AccountId";
    HxCalendarPropertyId[HxCalendarPropertyId["CapabilitiesData"] = 8] = "CapabilitiesData";
    HxCalendarPropertyId[HxCalendarPropertyId["State"] = 9] = "State";
    HxCalendarPropertyId[HxCalendarPropertyId["ServerId"] = 10] = "ServerId";
    HxCalendarPropertyId[HxCalendarPropertyId["FolderType"] = 11] = "FolderType";
    HxCalendarPropertyId[HxCalendarPropertyId["SummaryCardView"] = 12] = "SummaryCardView";
    HxCalendarPropertyId[HxCalendarPropertyId["RemoteId"] = 13] = "RemoteId";
    HxCalendarPropertyId[HxCalendarPropertyId["FamilyPuid"] = 15] = "FamilyPuid";
    HxCalendarPropertyId[HxCalendarPropertyId["SharedOwnerEmailAddress"] = 17] = "SharedOwnerEmailAddress";
    HxCalendarPropertyId[HxCalendarPropertyId["SharedOwnerName"] = 18] = "SharedOwnerName";
    HxCalendarPropertyId[HxCalendarPropertyId["Color"] = 3] = "Color";
    HxCalendarPropertyId[HxCalendarPropertyId["EnableOnlineMeeting"] = 21] = "EnableOnlineMeeting";
    HxCalendarPropertyId[HxCalendarPropertyId["DefaultOnlineMeetingProvider"] = 22] = "DefaultOnlineMeetingProvider";
    HxCalendarPropertyId[HxCalendarPropertyId["AllowedOnlineMeetingProviders"] = 23] = "AllowedOnlineMeetingProviders";
    HxCalendarPropertyId[HxCalendarPropertyId["DeviceId"] = 24] = "DeviceId";
})(HxCalendarPropertyId = exports.HxCalendarPropertyId || (exports.HxCalendarPropertyId = {}));
function getHxCalendarPropertyIdAsString(value) {
    return HxCalendarPropertyId[value];
}
exports.getHxCalendarPropertyIdAsString = getHxCalendarPropertyIdAsString;
function getHxCalendarPropertyIdFromString(value) {
    return HxCalendarPropertyId[value];
}
exports.getHxCalendarPropertyIdFromString = getHxCalendarPropertyIdFromString;
/*-------------------------------------------------------------------------------
  HxAppointmentBodyFormatting
-------------------------------------------------------------------------------*/
var HxAppointmentBodyFormatting;
(function (HxAppointmentBodyFormatting) {
    HxAppointmentBodyFormatting[HxAppointmentBodyFormatting["PlainText"] = 0] = "PlainText";
    HxAppointmentBodyFormatting[HxAppointmentBodyFormatting["Html"] = 1] = "Html";
})(HxAppointmentBodyFormatting = exports.HxAppointmentBodyFormatting || (exports.HxAppointmentBodyFormatting = {}));
function getHxAppointmentBodyFormattingAsString(value) {
    return HxAppointmentBodyFormatting[value];
}
exports.getHxAppointmentBodyFormattingAsString = getHxAppointmentBodyFormattingAsString;
function getHxAppointmentBodyFormattingFromString(value) {
    return HxAppointmentBodyFormatting[value];
}
exports.getHxAppointmentBodyFormattingFromString = getHxAppointmentBodyFormattingFromString;
/*-------------------------------------------------------------------------------
  HxWeatherDegreeType
-------------------------------------------------------------------------------*/
var HxWeatherDegreeType;
(function (HxWeatherDegreeType) {
    HxWeatherDegreeType[HxWeatherDegreeType["Default"] = 0] = "Default";
    HxWeatherDegreeType[HxWeatherDegreeType["Celsius"] = 1] = "Celsius";
    HxWeatherDegreeType[HxWeatherDegreeType["Fahrenheit"] = 2] = "Fahrenheit";
    HxWeatherDegreeType[HxWeatherDegreeType["None"] = 3] = "None";
})(HxWeatherDegreeType = exports.HxWeatherDegreeType || (exports.HxWeatherDegreeType = {}));
function getHxWeatherDegreeTypeAsString(value) {
    return HxWeatherDegreeType[value];
}
exports.getHxWeatherDegreeTypeAsString = getHxWeatherDegreeTypeAsString;
function getHxWeatherDegreeTypeFromString(value) {
    return HxWeatherDegreeType[value];
}
exports.getHxWeatherDegreeTypeFromString = getHxWeatherDegreeTypeFromString;
/*-------------------------------------------------------------------------------
  HxTailoredType
-------------------------------------------------------------------------------*/
var HxTailoredType;
(function (HxTailoredType) {
    HxTailoredType[HxTailoredType["None"] = 0] = "None";
    HxTailoredType[HxTailoredType["Flight"] = 1] = "Flight";
    HxTailoredType[HxTailoredType["Package"] = 2] = "Package";
    HxTailoredType[HxTailoredType["HotelReservation"] = 4] = "HotelReservation";
    HxTailoredType[HxTailoredType["CarReservation"] = 8] = "CarReservation";
    HxTailoredType[HxTailoredType["DiningReservation"] = 16] = "DiningReservation";
    HxTailoredType[HxTailoredType["EntertainmentTicket"] = 32] = "EntertainmentTicket";
    HxTailoredType[HxTailoredType["Invoice"] = 64] = "Invoice";
    HxTailoredType[HxTailoredType["ServiceAppointment"] = 128] = "ServiceAppointment";
})(HxTailoredType = exports.HxTailoredType || (exports.HxTailoredType = {}));
function getHxTailoredTypeAsString(value) {
    return HxTailoredType[value];
}
exports.getHxTailoredTypeAsString = getHxTailoredTypeAsString;
function getHxTailoredTypeFromString(value) {
    return HxTailoredType[value];
}
exports.getHxTailoredTypeFromString = getHxTailoredTypeFromString;
/*-------------------------------------------------------------------------------
  HxCalendarCatalogItemType
-------------------------------------------------------------------------------*/
var HxCalendarCatalogItemType;
(function (HxCalendarCatalogItemType) {
    HxCalendarCatalogItemType[HxCalendarCatalogItemType["Unknown"] = 2] = "Unknown";
    HxCalendarCatalogItemType[HxCalendarCatalogItemType["Calendar"] = 0] = "Calendar";
    HxCalendarCatalogItemType[HxCalendarCatalogItemType["Page"] = 1] = "Page";
})(HxCalendarCatalogItemType = exports.HxCalendarCatalogItemType || (exports.HxCalendarCatalogItemType = {}));
function getHxCalendarCatalogItemTypeAsString(value) {
    return HxCalendarCatalogItemType[value];
}
exports.getHxCalendarCatalogItemTypeAsString = getHxCalendarCatalogItemTypeAsString;
function getHxCalendarCatalogItemTypeFromString(value) {
    return HxCalendarCatalogItemType[value];
}
exports.getHxCalendarCatalogItemTypeFromString = getHxCalendarCatalogItemTypeFromString;
/*-------------------------------------------------------------------------------
  HxSubscriptionStatus
-------------------------------------------------------------------------------*/
var HxSubscriptionStatus;
(function (HxSubscriptionStatus) {
    HxSubscriptionStatus[HxSubscriptionStatus["NotSubscribed"] = 3] = "NotSubscribed";
    HxSubscriptionStatus[HxSubscriptionStatus["Pending"] = 1] = "Pending";
    HxSubscriptionStatus[HxSubscriptionStatus["Subscribed"] = 2] = "Subscribed";
})(HxSubscriptionStatus = exports.HxSubscriptionStatus || (exports.HxSubscriptionStatus = {}));
function getHxSubscriptionStatusAsString(value) {
    return HxSubscriptionStatus[value];
}
exports.getHxSubscriptionStatusAsString = getHxSubscriptionStatusAsString;
function getHxSubscriptionStatusFromString(value) {
    return HxSubscriptionStatus[value];
}
exports.getHxSubscriptionStatusFromString = getHxSubscriptionStatusFromString;
/*-------------------------------------------------------------------------------
  HxCalendarFolderType
-------------------------------------------------------------------------------*/
var HxCalendarFolderType;
(function (HxCalendarFolderType) {
    HxCalendarFolderType[HxCalendarFolderType["None"] = 0] = "None";
    HxCalendarFolderType[HxCalendarFolderType["DefaultCalendar"] = 1] = "DefaultCalendar";
    HxCalendarFolderType[HxCalendarFolderType["InternetCalendar"] = 2] = "InternetCalendar";
})(HxCalendarFolderType = exports.HxCalendarFolderType || (exports.HxCalendarFolderType = {}));
function getHxCalendarFolderTypeAsString(value) {
    return HxCalendarFolderType[value];
}
exports.getHxCalendarFolderTypeAsString = getHxCalendarFolderTypeAsString;
function getHxCalendarFolderTypeFromString(value) {
    return HxCalendarFolderType[value];
}
exports.getHxCalendarFolderTypeFromString = getHxCalendarFolderTypeFromString;
/*-------------------------------------------------------------------------------
  HxEmptySuggestionsReasonType
-------------------------------------------------------------------------------*/
var HxEmptySuggestionsReasonType;
(function (HxEmptySuggestionsReasonType) {
    HxEmptySuggestionsReasonType[HxEmptySuggestionsReasonType["Unknown"] = 0] = "Unknown";
    HxEmptySuggestionsReasonType[HxEmptySuggestionsReasonType["AttendeesUnavailable"] = 1] = "AttendeesUnavailable";
    HxEmptySuggestionsReasonType[HxEmptySuggestionsReasonType["LocationsUnavailable"] = 2] = "LocationsUnavailable";
    HxEmptySuggestionsReasonType[HxEmptySuggestionsReasonType["OrganizerUnavailable"] = 3] = "OrganizerUnavailable";
    HxEmptySuggestionsReasonType[HxEmptySuggestionsReasonType["AttendeesUnavailableOrUnknown"] = 4] = "AttendeesUnavailableOrUnknown";
})(HxEmptySuggestionsReasonType = exports.HxEmptySuggestionsReasonType || (exports.HxEmptySuggestionsReasonType = {}));
function getHxEmptySuggestionsReasonTypeAsString(value) {
    return HxEmptySuggestionsReasonType[value];
}
exports.getHxEmptySuggestionsReasonTypeAsString = getHxEmptySuggestionsReasonTypeAsString;
function getHxEmptySuggestionsReasonTypeFromString(value) {
    return HxEmptySuggestionsReasonType[value];
}
exports.getHxEmptySuggestionsReasonTypeFromString = getHxEmptySuggestionsReasonTypeFromString;
/*-------------------------------------------------------------------------------
  HxMeetingTimeSuggestionsRange
-------------------------------------------------------------------------------*/
var HxMeetingTimeSuggestionsRange;
(function (HxMeetingTimeSuggestionsRange) {
    HxMeetingTimeSuggestionsRange[HxMeetingTimeSuggestionsRange["Unknown"] = 0] = "Unknown";
    HxMeetingTimeSuggestionsRange[HxMeetingTimeSuggestionsRange["Personal"] = 1] = "Personal";
    HxMeetingTimeSuggestionsRange[HxMeetingTimeSuggestionsRange["Work"] = 2] = "Work";
})(HxMeetingTimeSuggestionsRange = exports.HxMeetingTimeSuggestionsRange || (exports.HxMeetingTimeSuggestionsRange = {}));
function getHxMeetingTimeSuggestionsRangeAsString(value) {
    return HxMeetingTimeSuggestionsRange[value];
}
exports.getHxMeetingTimeSuggestionsRangeAsString = getHxMeetingTimeSuggestionsRangeAsString;
function getHxMeetingTimeSuggestionsRangeFromString(value) {
    return HxMeetingTimeSuggestionsRange[value];
}
exports.getHxMeetingTimeSuggestionsRangeFromString = getHxMeetingTimeSuggestionsRangeFromString;
/*-------------------------------------------------------------------------------
  HxLocationSuggestionsSource
-------------------------------------------------------------------------------*/
var HxLocationSuggestionsSource;
(function (HxLocationSuggestionsSource) {
    HxLocationSuggestionsSource[HxLocationSuggestionsSource["None"] = 0] = "None";
    HxLocationSuggestionsSource[HxLocationSuggestionsSource["LocationServices"] = 2] = "LocationServices";
    HxLocationSuggestionsSource[HxLocationSuggestionsSource["LocalServices"] = 8] = "LocalServices";
    HxLocationSuggestionsSource[HxLocationSuggestionsSource["Relevance"] = 16] = "Relevance";
    HxLocationSuggestionsSource[HxLocationSuggestionsSource["BingAutosuggest"] = 32] = "BingAutosuggest";
    HxLocationSuggestionsSource[HxLocationSuggestionsSource["Directory"] = 64] = "Directory";
})(HxLocationSuggestionsSource = exports.HxLocationSuggestionsSource || (exports.HxLocationSuggestionsSource = {}));
function getHxLocationSuggestionsSourceAsString(value) {
    return HxLocationSuggestionsSource[value];
}
exports.getHxLocationSuggestionsSourceAsString = getHxLocationSuggestionsSourceAsString;
function getHxLocationSuggestionsSourceFromString(value) {
    return HxLocationSuggestionsSource[value];
}
exports.getHxLocationSuggestionsSourceFromString = getHxLocationSuggestionsSourceFromString;
/*-------------------------------------------------------------------------------
  HxLocationSourceType
-------------------------------------------------------------------------------*/
var HxLocationSourceType;
(function (HxLocationSourceType) {
    HxLocationSourceType[HxLocationSourceType["None"] = 0] = "None";
    HxLocationSourceType[HxLocationSourceType["LocationServices"] = 1] = "LocationServices";
    HxLocationSourceType[HxLocationSourceType["PhonebookServices"] = 2] = "PhonebookServices";
    HxLocationSourceType[HxLocationSourceType["Device"] = 3] = "Device";
    HxLocationSourceType[HxLocationSourceType["Contact"] = 4] = "Contact";
    HxLocationSourceType[HxLocationSourceType["Resource"] = 5] = "Resource";
})(HxLocationSourceType = exports.HxLocationSourceType || (exports.HxLocationSourceType = {}));
function getHxLocationSourceTypeAsString(value) {
    return HxLocationSourceType[value];
}
exports.getHxLocationSourceTypeAsString = getHxLocationSourceTypeAsString;
function getHxLocationSourceTypeFromString(value) {
    return HxLocationSourceType[value];
}
exports.getHxLocationSourceTypeFromString = getHxLocationSourceTypeFromString;
/*-------------------------------------------------------------------------------
  HxRefreshCalendarStatusType
-------------------------------------------------------------------------------*/
var HxRefreshCalendarStatusType;
(function (HxRefreshCalendarStatusType) {
    HxRefreshCalendarStatusType[HxRefreshCalendarStatusType["Syncing"] = 0] = "Syncing";
    HxRefreshCalendarStatusType[HxRefreshCalendarStatusType["Failure"] = 1] = "Failure";
    HxRefreshCalendarStatusType[HxRefreshCalendarStatusType["Success"] = 2] = "Success";
    HxRefreshCalendarStatusType[HxRefreshCalendarStatusType["None"] = 3] = "None";
})(HxRefreshCalendarStatusType = exports.HxRefreshCalendarStatusType || (exports.HxRefreshCalendarStatusType = {}));
function getHxRefreshCalendarStatusTypeAsString(value) {
    return HxRefreshCalendarStatusType[value];
}
exports.getHxRefreshCalendarStatusTypeAsString = getHxRefreshCalendarStatusTypeAsString;
function getHxRefreshCalendarStatusTypeFromString(value) {
    return HxRefreshCalendarStatusType[value];
}
exports.getHxRefreshCalendarStatusTypeFromString = getHxRefreshCalendarStatusTypeFromString;
/*-------------------------------------------------------------------------------
  HxServiceRequestStatusType
-------------------------------------------------------------------------------*/
var HxServiceRequestStatusType;
(function (HxServiceRequestStatusType) {
    HxServiceRequestStatusType[HxServiceRequestStatusType["Failure"] = 0] = "Failure";
    HxServiceRequestStatusType[HxServiceRequestStatusType["Success"] = 1] = "Success";
    HxServiceRequestStatusType[HxServiceRequestStatusType["Offline"] = 2] = "Offline";
    HxServiceRequestStatusType[HxServiceRequestStatusType["None"] = 3] = "None";
})(HxServiceRequestStatusType = exports.HxServiceRequestStatusType || (exports.HxServiceRequestStatusType = {}));
function getHxServiceRequestStatusTypeAsString(value) {
    return HxServiceRequestStatusType[value];
}
exports.getHxServiceRequestStatusTypeAsString = getHxServiceRequestStatusTypeAsString;
function getHxServiceRequestStatusTypeFromString(value) {
    return HxServiceRequestStatusType[value];
}
exports.getHxServiceRequestStatusTypeFromString = getHxServiceRequestStatusTypeFromString;
/*-------------------------------------------------------------------------------
  HxMeetingStateType
-------------------------------------------------------------------------------*/
var HxMeetingStateType;
(function (HxMeetingStateType) {
    HxMeetingStateType[HxMeetingStateType["Confirmed"] = 0] = "Confirmed";
    HxMeetingStateType[HxMeetingStateType["Tentative"] = 1] = "Tentative";
    HxMeetingStateType[HxMeetingStateType["Cancelled"] = 2] = "Cancelled";
})(HxMeetingStateType = exports.HxMeetingStateType || (exports.HxMeetingStateType = {}));
function getHxMeetingStateTypeAsString(value) {
    return HxMeetingStateType[value];
}
exports.getHxMeetingStateTypeAsString = getHxMeetingStateTypeAsString;
function getHxMeetingStateTypeFromString(value) {
    return HxMeetingStateType[value];
}
exports.getHxMeetingStateTypeFromString = getHxMeetingStateTypeFromString;
/*-------------------------------------------------------------------------------
  HxAppointmentAttendeeRole
-------------------------------------------------------------------------------*/
var HxAppointmentAttendeeRole;
(function (HxAppointmentAttendeeRole) {
    HxAppointmentAttendeeRole[HxAppointmentAttendeeRole["Unknown"] = 0] = "Unknown";
    HxAppointmentAttendeeRole[HxAppointmentAttendeeRole["Required"] = 1] = "Required";
    HxAppointmentAttendeeRole[HxAppointmentAttendeeRole["Optional"] = 2] = "Optional";
    HxAppointmentAttendeeRole[HxAppointmentAttendeeRole["Resource"] = 3] = "Resource";
    HxAppointmentAttendeeRole[HxAppointmentAttendeeRole["Organizer"] = 4] = "Organizer";
})(HxAppointmentAttendeeRole = exports.HxAppointmentAttendeeRole || (exports.HxAppointmentAttendeeRole = {}));
function getHxAppointmentAttendeeRoleAsString(value) {
    return HxAppointmentAttendeeRole[value];
}
exports.getHxAppointmentAttendeeRoleAsString = getHxAppointmentAttendeeRoleAsString;
function getHxAppointmentAttendeeRoleFromString(value) {
    return HxAppointmentAttendeeRole[value];
}
exports.getHxAppointmentAttendeeRoleFromString = getHxAppointmentAttendeeRoleFromString;
/*-------------------------------------------------------------------------------
  HxAppointmentAttendeeStatus
-------------------------------------------------------------------------------*/
var HxAppointmentAttendeeStatus;
(function (HxAppointmentAttendeeStatus) {
    HxAppointmentAttendeeStatus[HxAppointmentAttendeeStatus["Unknown"] = 0] = "Unknown";
    HxAppointmentAttendeeStatus[HxAppointmentAttendeeStatus["Delegated"] = 1] = "Delegated";
    HxAppointmentAttendeeStatus[HxAppointmentAttendeeStatus["Accepted"] = 2] = "Accepted";
    HxAppointmentAttendeeStatus[HxAppointmentAttendeeStatus["Declined"] = 3] = "Declined";
    HxAppointmentAttendeeStatus[HxAppointmentAttendeeStatus["Tentative"] = 4] = "Tentative";
    HxAppointmentAttendeeStatus[HxAppointmentAttendeeStatus["NeedsAction"] = 5] = "NeedsAction";
})(HxAppointmentAttendeeStatus = exports.HxAppointmentAttendeeStatus || (exports.HxAppointmentAttendeeStatus = {}));
function getHxAppointmentAttendeeStatusAsString(value) {
    return HxAppointmentAttendeeStatus[value];
}
exports.getHxAppointmentAttendeeStatusAsString = getHxAppointmentAttendeeStatusAsString;
function getHxAppointmentAttendeeStatusFromString(value) {
    return HxAppointmentAttendeeStatus[value];
}
exports.getHxAppointmentAttendeeStatusFromString = getHxAppointmentAttendeeStatusFromString;
/*-------------------------------------------------------------------------------
  HxCalendarReminderType
-------------------------------------------------------------------------------*/
var HxCalendarReminderType;
(function (HxCalendarReminderType) {
    HxCalendarReminderType[HxCalendarReminderType["ZeroMinutes"] = 0] = "ZeroMinutes";
    HxCalendarReminderType[HxCalendarReminderType["FiveMinutes"] = 1] = "FiveMinutes";
    HxCalendarReminderType[HxCalendarReminderType["TenMinutes"] = 2] = "TenMinutes";
    HxCalendarReminderType[HxCalendarReminderType["FifteenMinutes"] = 3] = "FifteenMinutes";
    HxCalendarReminderType[HxCalendarReminderType["ThirtyMinutes"] = 4] = "ThirtyMinutes";
    HxCalendarReminderType[HxCalendarReminderType["OneHours"] = 5] = "OneHours";
    HxCalendarReminderType[HxCalendarReminderType["TwoHours"] = 6] = "TwoHours";
    HxCalendarReminderType[HxCalendarReminderType["ThreeHours"] = 7] = "ThreeHours";
    HxCalendarReminderType[HxCalendarReminderType["FourHours"] = 8] = "FourHours";
    HxCalendarReminderType[HxCalendarReminderType["EightHours"] = 9] = "EightHours";
    HxCalendarReminderType[HxCalendarReminderType["TwelveHours"] = 10] = "TwelveHours";
    HxCalendarReminderType[HxCalendarReminderType["OneDays"] = 11] = "OneDays";
    HxCalendarReminderType[HxCalendarReminderType["TwoDays"] = 12] = "TwoDays";
    HxCalendarReminderType[HxCalendarReminderType["ThreeDays"] = 13] = "ThreeDays";
    HxCalendarReminderType[HxCalendarReminderType["OneWeeks"] = 14] = "OneWeeks";
    HxCalendarReminderType[HxCalendarReminderType["TwoWeeks"] = 15] = "TwoWeeks";
})(HxCalendarReminderType = exports.HxCalendarReminderType || (exports.HxCalendarReminderType = {}));
function getHxCalendarReminderTypeAsString(value) {
    return HxCalendarReminderType[value];
}
exports.getHxCalendarReminderTypeAsString = getHxCalendarReminderTypeAsString;
function getHxCalendarReminderTypeFromString(value) {
    return HxCalendarReminderType[value];
}
exports.getHxCalendarReminderTypeFromString = getHxCalendarReminderTypeFromString;
/*-------------------------------------------------------------------------------
  HxOnlineMeetingProviderType
-------------------------------------------------------------------------------*/
var HxOnlineMeetingProviderType;
(function (HxOnlineMeetingProviderType) {
    HxOnlineMeetingProviderType[HxOnlineMeetingProviderType["Unknown"] = 0] = "Unknown";
    HxOnlineMeetingProviderType[HxOnlineMeetingProviderType["SkypeForBusiness"] = 1] = "SkypeForBusiness";
    HxOnlineMeetingProviderType[HxOnlineMeetingProviderType["SkypeForConsumer"] = 2] = "SkypeForConsumer";
    HxOnlineMeetingProviderType[HxOnlineMeetingProviderType["TeamsForBusiness"] = 3] = "TeamsForBusiness";
})(HxOnlineMeetingProviderType = exports.HxOnlineMeetingProviderType || (exports.HxOnlineMeetingProviderType = {}));
function getHxOnlineMeetingProviderTypeAsString(value) {
    return HxOnlineMeetingProviderType[value];
}
exports.getHxOnlineMeetingProviderTypeAsString = getHxOnlineMeetingProviderTypeAsString;
function getHxOnlineMeetingProviderTypeFromString(value) {
    return HxOnlineMeetingProviderType[value];
}
exports.getHxOnlineMeetingProviderTypeFromString = getHxOnlineMeetingProviderTypeFromString;
/*-------------------------------------------------------------------------------
  HxSortDirection
-------------------------------------------------------------------------------*/
var HxSortDirection;
(function (HxSortDirection) {
    HxSortDirection[HxSortDirection["Descending"] = 0] = "Descending";
    HxSortDirection[HxSortDirection["Ascending"] = 1] = "Ascending";
})(HxSortDirection = exports.HxSortDirection || (exports.HxSortDirection = {}));
function getHxSortDirectionAsString(value) {
    return HxSortDirection[value];
}
exports.getHxSortDirectionAsString = getHxSortDirectionAsString;
function getHxSortDirectionFromString(value) {
    return HxSortDirection[value];
}
exports.getHxSortDirectionFromString = getHxSortDirectionFromString;
/*-------------------------------------------------------------------------------
  HxCreateCalendarItemStateType
-------------------------------------------------------------------------------*/
var HxCreateCalendarItemStateType;
(function (HxCreateCalendarItemStateType) {
    HxCreateCalendarItemStateType[HxCreateCalendarItemStateType["NotCreated"] = 0] = "NotCreated";
    HxCreateCalendarItemStateType[HxCreateCalendarItemStateType["Created"] = 1] = "Created";
    HxCreateCalendarItemStateType[HxCreateCalendarItemStateType["ProviderError"] = 2] = "ProviderError";
})(HxCreateCalendarItemStateType = exports.HxCreateCalendarItemStateType || (exports.HxCreateCalendarItemStateType = {}));
function getHxCreateCalendarItemStateTypeAsString(value) {
    return HxCreateCalendarItemStateType[value];
}
exports.getHxCreateCalendarItemStateTypeAsString = getHxCreateCalendarItemStateTypeAsString;
function getHxCreateCalendarItemStateTypeFromString(value) {
    return HxCreateCalendarItemStateType[value];
}
exports.getHxCreateCalendarItemStateTypeFromString = getHxCreateCalendarItemStateTypeFromString;
/*-------------------------------------------------------------------------------
  HxCalendarSourceType
-------------------------------------------------------------------------------*/
var HxCalendarSourceType;
(function (HxCalendarSourceType) {
    HxCalendarSourceType[HxCalendarSourceType["NotSet"] = 0] = "NotSet";
    HxCalendarSourceType[HxCalendarSourceType["User"] = 1] = "User";
    HxCalendarSourceType[HxCalendarSourceType["Group"] = 2] = "Group";
    HxCalendarSourceType[HxCalendarSourceType["Remote"] = 3] = "Remote";
})(HxCalendarSourceType = exports.HxCalendarSourceType || (exports.HxCalendarSourceType = {}));
function getHxCalendarSourceTypeAsString(value) {
    return HxCalendarSourceType[value];
}
exports.getHxCalendarSourceTypeAsString = getHxCalendarSourceTypeAsString;
function getHxCalendarSourceTypeFromString(value) {
    return HxCalendarSourceType[value];
}
exports.getHxCalendarSourceTypeFromString = getHxCalendarSourceTypeFromString;
/*-------------------------------------------------------------------------------
  HxFetchCalendarStatusType
-------------------------------------------------------------------------------*/
var HxFetchCalendarStatusType;
(function (HxFetchCalendarStatusType) {
    HxFetchCalendarStatusType[HxFetchCalendarStatusType["None"] = 0] = "None";
    HxFetchCalendarStatusType[HxFetchCalendarStatusType["Syncing"] = 1] = "Syncing";
    HxFetchCalendarStatusType[HxFetchCalendarStatusType["FetchCompleted"] = 2] = "FetchCompleted";
    HxFetchCalendarStatusType[HxFetchCalendarStatusType["FetchFailed"] = 3] = "FetchFailed";
})(HxFetchCalendarStatusType = exports.HxFetchCalendarStatusType || (exports.HxFetchCalendarStatusType = {}));
function getHxFetchCalendarStatusTypeAsString(value) {
    return HxFetchCalendarStatusType[value];
}
exports.getHxFetchCalendarStatusTypeAsString = getHxFetchCalendarStatusTypeAsString;
function getHxFetchCalendarStatusTypeFromString(value) {
    return HxFetchCalendarStatusType[value];
}
exports.getHxFetchCalendarStatusTypeFromString = getHxFetchCalendarStatusTypeFromString;
/*-------------------------------------------------------------------------------
  HxSpeedyMeetingClippingType
-------------------------------------------------------------------------------*/
var HxSpeedyMeetingClippingType;
(function (HxSpeedyMeetingClippingType) {
    HxSpeedyMeetingClippingType[HxSpeedyMeetingClippingType["None"] = 0] = "None";
    HxSpeedyMeetingClippingType[HxSpeedyMeetingClippingType["StartLate"] = 1] = "StartLate";
    HxSpeedyMeetingClippingType[HxSpeedyMeetingClippingType["EndEarly"] = 2] = "EndEarly";
})(HxSpeedyMeetingClippingType = exports.HxSpeedyMeetingClippingType || (exports.HxSpeedyMeetingClippingType = {}));
function getHxSpeedyMeetingClippingTypeAsString(value) {
    return HxSpeedyMeetingClippingType[value];
}
exports.getHxSpeedyMeetingClippingTypeAsString = getHxSpeedyMeetingClippingTypeAsString;
function getHxSpeedyMeetingClippingTypeFromString(value) {
    return HxSpeedyMeetingClippingType[value];
}
exports.getHxSpeedyMeetingClippingTypeFromString = getHxSpeedyMeetingClippingTypeFromString;
/*-------------------------------------------------------------------------------
  HxContactAddressKind
-------------------------------------------------------------------------------*/
var HxContactAddressKind;
(function (HxContactAddressKind) {
    HxContactAddressKind[HxContactAddressKind["Business"] = 0] = "Business";
    HxContactAddressKind[HxContactAddressKind["Home"] = 1] = "Home";
    HxContactAddressKind[HxContactAddressKind["Other"] = 2] = "Other";
})(HxContactAddressKind = exports.HxContactAddressKind || (exports.HxContactAddressKind = {}));
function getHxContactAddressKindAsString(value) {
    return HxContactAddressKind[value];
}
exports.getHxContactAddressKindAsString = getHxContactAddressKindAsString;
function getHxContactAddressKindFromString(value) {
    return HxContactAddressKind[value];
}
exports.getHxContactAddressKindFromString = getHxContactAddressKindFromString;
/*-------------------------------------------------------------------------------
  HxContactEmailKind
-------------------------------------------------------------------------------*/
var HxContactEmailKind;
(function (HxContactEmailKind) {
    HxContactEmailKind[HxContactEmailKind["Personal"] = 0] = "Personal";
    HxContactEmailKind[HxContactEmailKind["Work"] = 1] = "Work";
    HxContactEmailKind[HxContactEmailKind["Other"] = 2] = "Other";
})(HxContactEmailKind = exports.HxContactEmailKind || (exports.HxContactEmailKind = {}));
function getHxContactEmailKindAsString(value) {
    return HxContactEmailKind[value];
}
exports.getHxContactEmailKindAsString = getHxContactEmailKindAsString;
function getHxContactEmailKindFromString(value) {
    return HxContactEmailKind[value];
}
exports.getHxContactEmailKindFromString = getHxContactEmailKindFromString;
/*-------------------------------------------------------------------------------
  HxContactDateKind
-------------------------------------------------------------------------------*/
var HxContactDateKind;
(function (HxContactDateKind) {
    HxContactDateKind[HxContactDateKind["Birthday"] = 0] = "Birthday";
    HxContactDateKind[HxContactDateKind["Anniversary"] = 1] = "Anniversary";
    HxContactDateKind[HxContactDateKind["Other"] = 2] = "Other";
})(HxContactDateKind = exports.HxContactDateKind || (exports.HxContactDateKind = {}));
function getHxContactDateKindAsString(value) {
    return HxContactDateKind[value];
}
exports.getHxContactDateKindAsString = getHxContactDateKindAsString;
function getHxContactDateKindFromString(value) {
    return HxContactDateKind[value];
}
exports.getHxContactDateKindFromString = getHxContactDateKindFromString;
/*-------------------------------------------------------------------------------
  HxContactPhoneKind
-------------------------------------------------------------------------------*/
var HxContactPhoneKind;
(function (HxContactPhoneKind) {
    HxContactPhoneKind[HxContactPhoneKind["AssistantPhone"] = 0] = "AssistantPhone";
    HxContactPhoneKind[HxContactPhoneKind["BusinessFax"] = 1] = "BusinessFax";
    HxContactPhoneKind[HxContactPhoneKind["BusinessPhone"] = 2] = "BusinessPhone";
    HxContactPhoneKind[HxContactPhoneKind["BusinessPhone2"] = 10] = "BusinessPhone2";
    HxContactPhoneKind[HxContactPhoneKind["Callback"] = 11] = "Callback";
    HxContactPhoneKind[HxContactPhoneKind["CarPhone"] = 12] = "CarPhone";
    HxContactPhoneKind[HxContactPhoneKind["CompanyMainPhone"] = 3] = "CompanyMainPhone";
    HxContactPhoneKind[HxContactPhoneKind["HomeFax"] = 4] = "HomeFax";
    HxContactPhoneKind[HxContactPhoneKind["HomePhone"] = 5] = "HomePhone";
    HxContactPhoneKind[HxContactPhoneKind["HomePhone2"] = 13] = "HomePhone2";
    HxContactPhoneKind[HxContactPhoneKind["Isdn"] = 14] = "Isdn";
    HxContactPhoneKind[HxContactPhoneKind["MobilePhone"] = 6] = "MobilePhone";
    HxContactPhoneKind[HxContactPhoneKind["OtherFax"] = 15] = "OtherFax";
    HxContactPhoneKind[HxContactPhoneKind["OtherTelephone"] = 7] = "OtherTelephone";
    HxContactPhoneKind[HxContactPhoneKind["Pager"] = 8] = "Pager";
    HxContactPhoneKind[HxContactPhoneKind["PrimaryPhone"] = 16] = "PrimaryPhone";
    HxContactPhoneKind[HxContactPhoneKind["RadioPhone"] = 9] = "RadioPhone";
    HxContactPhoneKind[HxContactPhoneKind["Telex"] = 17] = "Telex";
    HxContactPhoneKind[HxContactPhoneKind["TtyTddPhone"] = 18] = "TtyTddPhone";
    HxContactPhoneKind[HxContactPhoneKind["BusinessMobile"] = 19] = "BusinessMobile";
    HxContactPhoneKind[HxContactPhoneKind["IPPhone"] = 20] = "IPPhone";
    HxContactPhoneKind[HxContactPhoneKind["Mms"] = 21] = "Mms";
    HxContactPhoneKind[HxContactPhoneKind["Msn"] = 22] = "Msn";
})(HxContactPhoneKind = exports.HxContactPhoneKind || (exports.HxContactPhoneKind = {}));
function getHxContactPhoneKindAsString(value) {
    return HxContactPhoneKind[value];
}
exports.getHxContactPhoneKindAsString = getHxContactPhoneKindAsString;
function getHxContactPhoneKindFromString(value) {
    return HxContactPhoneKind[value];
}
exports.getHxContactPhoneKindFromString = getHxContactPhoneKindFromString;
/*-------------------------------------------------------------------------------
  HxContactSignificantOtherKind
-------------------------------------------------------------------------------*/
var HxContactSignificantOtherKind;
(function (HxContactSignificantOtherKind) {
    HxContactSignificantOtherKind[HxContactSignificantOtherKind["Spouse"] = 0] = "Spouse";
    HxContactSignificantOtherKind[HxContactSignificantOtherKind["Child"] = 1] = "Child";
    HxContactSignificantOtherKind[HxContactSignificantOtherKind["Partner"] = 2] = "Partner";
    HxContactSignificantOtherKind[HxContactSignificantOtherKind["Sibling"] = 3] = "Sibling";
    HxContactSignificantOtherKind[HxContactSignificantOtherKind["Parent"] = 4] = "Parent";
    HxContactSignificantOtherKind[HxContactSignificantOtherKind["Other"] = 5] = "Other";
})(HxContactSignificantOtherKind = exports.HxContactSignificantOtherKind || (exports.HxContactSignificantOtherKind = {}));
function getHxContactSignificantOtherKindAsString(value) {
    return HxContactSignificantOtherKind[value];
}
exports.getHxContactSignificantOtherKindAsString = getHxContactSignificantOtherKindAsString;
function getHxContactSignificantOtherKindFromString(value) {
    return HxContactSignificantOtherKind[value];
}
exports.getHxContactSignificantOtherKindFromString = getHxContactSignificantOtherKindFromString;
/*-------------------------------------------------------------------------------
  HxContactListSyncStatus
-------------------------------------------------------------------------------*/
var HxContactListSyncStatus;
(function (HxContactListSyncStatus) {
    HxContactListSyncStatus[HxContactListSyncStatus["Idle"] = 0] = "Idle";
    HxContactListSyncStatus[HxContactListSyncStatus["Syncing"] = 1] = "Syncing";
    HxContactListSyncStatus[HxContactListSyncStatus["UpToDate"] = 2] = "UpToDate";
    HxContactListSyncStatus[HxContactListSyncStatus["AuthenticationError"] = 3] = "AuthenticationError";
    HxContactListSyncStatus[HxContactListSyncStatus["PolicyError"] = 4] = "PolicyError";
    HxContactListSyncStatus[HxContactListSyncStatus["UnknownError"] = 5] = "UnknownError";
    HxContactListSyncStatus[HxContactListSyncStatus["ManualAccountRemovalRequired"] = 6] = "ManualAccountRemovalRequired";
})(HxContactListSyncStatus = exports.HxContactListSyncStatus || (exports.HxContactListSyncStatus = {}));
function getHxContactListSyncStatusAsString(value) {
    return HxContactListSyncStatus[value];
}
exports.getHxContactListSyncStatusAsString = getHxContactListSyncStatusAsString;
function getHxContactListSyncStatusFromString(value) {
    return HxContactListSyncStatus[value];
}
exports.getHxContactListSyncStatusFromString = getHxContactListSyncStatusFromString;
/*-------------------------------------------------------------------------------
  HxContactUrlType
-------------------------------------------------------------------------------*/
var HxContactUrlType;
(function (HxContactUrlType) {
    HxContactUrlType[HxContactUrlType["Personal"] = 0] = "Personal";
    HxContactUrlType[HxContactUrlType["Business"] = 1] = "Business";
    HxContactUrlType[HxContactUrlType["Other"] = 11] = "Other";
    HxContactUrlType[HxContactUrlType["Attachment"] = 2] = "Attachment";
    HxContactUrlType[HxContactUrlType["EbcDisplayDefinition"] = 3] = "EbcDisplayDefinition";
    HxContactUrlType[HxContactUrlType["EbcFinalImage"] = 4] = "EbcFinalImage";
    HxContactUrlType[HxContactUrlType["EbcLogo"] = 5] = "EbcLogo";
    HxContactUrlType[HxContactUrlType["Feed"] = 6] = "Feed";
    HxContactUrlType[HxContactUrlType["Image"] = 7] = "Image";
    HxContactUrlType[HxContactUrlType["Profile"] = 8] = "Profile";
    HxContactUrlType[HxContactUrlType["Blog"] = 9] = "Blog";
    HxContactUrlType[HxContactUrlType["InternalMarker"] = 10] = "InternalMarker";
})(HxContactUrlType = exports.HxContactUrlType || (exports.HxContactUrlType = {}));
function getHxContactUrlTypeAsString(value) {
    return HxContactUrlType[value];
}
exports.getHxContactUrlTypeAsString = getHxContactUrlTypeAsString;
function getHxContactUrlTypeFromString(value) {
    return HxContactUrlType[value];
}
exports.getHxContactUrlTypeFromString = getHxContactUrlTypeFromString;
/*-------------------------------------------------------------------------------
  HxContactUnistoreNotificationType
-------------------------------------------------------------------------------*/
var HxContactUnistoreNotificationType;
(function (HxContactUnistoreNotificationType) {
    HxContactUnistoreNotificationType[HxContactUnistoreNotificationType["Create"] = 0] = "Create";
    HxContactUnistoreNotificationType[HxContactUnistoreNotificationType["Update"] = 1] = "Update";
})(HxContactUnistoreNotificationType = exports.HxContactUnistoreNotificationType || (exports.HxContactUnistoreNotificationType = {}));
function getHxContactUnistoreNotificationTypeAsString(value) {
    return HxContactUnistoreNotificationType[value];
}
exports.getHxContactUnistoreNotificationTypeAsString = getHxContactUnistoreNotificationTypeAsString;
function getHxContactUnistoreNotificationTypeFromString(value) {
    return HxContactUnistoreNotificationType[value];
}
exports.getHxContactUnistoreNotificationTypeFromString = getHxContactUnistoreNotificationTypeFromString;
/*-------------------------------------------------------------------------------
  HxContactImAddressKind
-------------------------------------------------------------------------------*/
var HxContactImAddressKind;
(function (HxContactImAddressKind) {
    HxContactImAddressKind[HxContactImAddressKind["ImAddress1"] = 0] = "ImAddress1";
    HxContactImAddressKind[HxContactImAddressKind["ImAddress2"] = 1] = "ImAddress2";
    HxContactImAddressKind[HxContactImAddressKind["ImAddress3"] = 2] = "ImAddress3";
})(HxContactImAddressKind = exports.HxContactImAddressKind || (exports.HxContactImAddressKind = {}));
function getHxContactImAddressKindAsString(value) {
    return HxContactImAddressKind[value];
}
exports.getHxContactImAddressKindAsString = getHxContactImAddressKindAsString;
function getHxContactImAddressKindFromString(value) {
    return HxContactImAddressKind[value];
}
exports.getHxContactImAddressKindFromString = getHxContactImAddressKindFromString;
/*-------------------------------------------------------------------------------
  HxContactPhotoKind
-------------------------------------------------------------------------------*/
var HxContactPhotoKind;
(function (HxContactPhotoKind) {
    HxContactPhotoKind[HxContactPhotoKind["None"] = 0] = "None";
    HxContactPhotoKind[HxContactPhotoKind["Uri"] = 1] = "Uri";
    HxContactPhotoKind[HxContactPhotoKind["Stream"] = 2] = "Stream";
})(HxContactPhotoKind = exports.HxContactPhotoKind || (exports.HxContactPhotoKind = {}));
function getHxContactPhotoKindAsString(value) {
    return HxContactPhotoKind[value];
}
exports.getHxContactPhotoKindAsString = getHxContactPhotoKindAsString;
function getHxContactPhotoKindFromString(value) {
    return HxContactPhotoKind[value];
}
exports.getHxContactPhotoKindFromString = getHxContactPhotoKindFromString;
/*-------------------------------------------------------------------------------
  HxEmailAddressType
-------------------------------------------------------------------------------*/
var HxEmailAddressType;
(function (HxEmailAddressType) {
    HxEmailAddressType[HxEmailAddressType["Unknown"] = 0] = "Unknown";
    HxEmailAddressType[HxEmailAddressType["OneOff"] = 1] = "OneOff";
    HxEmailAddressType[HxEmailAddressType["Mailbox"] = 2] = "Mailbox";
    HxEmailAddressType[HxEmailAddressType["PublicDL"] = 3] = "PublicDL";
    HxEmailAddressType[HxEmailAddressType["PrivateDL"] = 4] = "PrivateDL";
    HxEmailAddressType[HxEmailAddressType["Contact"] = 5] = "Contact";
    HxEmailAddressType[HxEmailAddressType["PublicFolder"] = 6] = "PublicFolder";
    HxEmailAddressType[HxEmailAddressType["GroupMailbox"] = 7] = "GroupMailbox";
    HxEmailAddressType[HxEmailAddressType["Guest"] = 8] = "Guest";
    HxEmailAddressType[HxEmailAddressType["ImplicitContact"] = 9] = "ImplicitContact";
    HxEmailAddressType[HxEmailAddressType["User"] = 10] = "User";
})(HxEmailAddressType = exports.HxEmailAddressType || (exports.HxEmailAddressType = {}));
function getHxEmailAddressTypeAsString(value) {
    return HxEmailAddressType[value];
}
exports.getHxEmailAddressTypeAsString = getHxEmailAddressTypeAsString;
function getHxEmailAddressTypeFromString(value) {
    return HxEmailAddressType[value];
}
exports.getHxEmailAddressTypeFromString = getHxEmailAddressTypeFromString;
/*-------------------------------------------------------------------------------
  HxContactSortProperty
-------------------------------------------------------------------------------*/
var HxContactSortProperty;
(function (HxContactSortProperty) {
    HxContactSortProperty[HxContactSortProperty["LastName"] = 0] = "LastName";
    HxContactSortProperty[HxContactSortProperty["FirstName"] = 1] = "FirstName";
    HxContactSortProperty[HxContactSortProperty["DisplayNameFromSettings"] = 2] = "DisplayNameFromSettings";
    HxContactSortProperty[HxContactSortProperty["CompanyNameAndJobTitle"] = 3] = "CompanyNameAndJobTitle";
})(HxContactSortProperty = exports.HxContactSortProperty || (exports.HxContactSortProperty = {}));
function getHxContactSortPropertyAsString(value) {
    return HxContactSortProperty[value];
}
exports.getHxContactSortPropertyAsString = getHxContactSortPropertyAsString;
function getHxContactSortPropertyFromString(value) {
    return HxContactSortProperty[value];
}
exports.getHxContactSortPropertyFromString = getHxContactSortPropertyFromString;
/*-------------------------------------------------------------------------------
  HxRuleConditionType
-------------------------------------------------------------------------------*/
var HxRuleConditionType;
(function (HxRuleConditionType) {
    HxRuleConditionType[HxRuleConditionType["Unknown"] = 0] = "Unknown";
    HxRuleConditionType[HxRuleConditionType["FromRecipients"] = 1] = "FromRecipients";
    HxRuleConditionType[HxRuleConditionType["SentToRecipients"] = 2] = "SentToRecipients";
    HxRuleConditionType[HxRuleConditionType["ContainsSubjectString"] = 3] = "ContainsSubjectString";
    HxRuleConditionType[HxRuleConditionType["ContainsSubjectOrBodyString"] = 4] = "ContainsSubjectOrBodyString";
    HxRuleConditionType[HxRuleConditionType["ContainsSenderString"] = 5] = "ContainsSenderString";
    HxRuleConditionType[HxRuleConditionType["ContainsBodyString"] = 6] = "ContainsBodyString";
    HxRuleConditionType[HxRuleConditionType["ContainsRecipientString"] = 7] = "ContainsRecipientString";
    HxRuleConditionType[HxRuleConditionType["ContainsHeaderString"] = 8] = "ContainsHeaderString";
    HxRuleConditionType[HxRuleConditionType["SentToOrCcMe"] = 9] = "SentToOrCcMe";
    HxRuleConditionType[HxRuleConditionType["SentToMeOnly"] = 10] = "SentToMeOnly";
    HxRuleConditionType[HxRuleConditionType["SentToMe"] = 11] = "SentToMe";
    HxRuleConditionType[HxRuleConditionType["SentMeCc"] = 12] = "SentMeCc";
    HxRuleConditionType[HxRuleConditionType["NotSentToMe"] = 13] = "NotSentToMe";
    HxRuleConditionType[HxRuleConditionType["MarkedWithImportance"] = 14] = "MarkedWithImportance";
    HxRuleConditionType[HxRuleConditionType["MarkedWithSensitivity"] = 15] = "MarkedWithSensitivity";
    HxRuleConditionType[HxRuleConditionType["HasAttachment"] = 16] = "HasAttachment";
    HxRuleConditionType[HxRuleConditionType["MarkedAsOof"] = 17] = "MarkedAsOof";
    HxRuleConditionType[HxRuleConditionType["WithinSizeRange"] = 18] = "WithinSizeRange";
    HxRuleConditionType[HxRuleConditionType["WithinDateRange"] = 19] = "WithinDateRange";
    HxRuleConditionType[HxRuleConditionType["MeetingMessage"] = 20] = "MeetingMessage";
    HxRuleConditionType[HxRuleConditionType["AssignedCategories"] = 21] = "AssignedCategories";
    HxRuleConditionType[HxRuleConditionType["Forms"] = 22] = "Forms";
    HxRuleConditionType[HxRuleConditionType["MessageClassification"] = 23] = "MessageClassification";
    HxRuleConditionType[HxRuleConditionType["Ndr"] = 24] = "Ndr";
    HxRuleConditionType[HxRuleConditionType["AutomaticForward"] = 25] = "AutomaticForward";
    HxRuleConditionType[HxRuleConditionType["Encrypted"] = 26] = "Encrypted";
    HxRuleConditionType[HxRuleConditionType["Signed"] = 27] = "Signed";
    HxRuleConditionType[HxRuleConditionType["ReadReceipt"] = 28] = "ReadReceipt";
    HxRuleConditionType[HxRuleConditionType["MeetingResponse"] = 29] = "MeetingResponse";
    HxRuleConditionType[HxRuleConditionType["PermissionControlled"] = 30] = "PermissionControlled";
    HxRuleConditionType[HxRuleConditionType["ApprovalRequest"] = 31] = "ApprovalRequest";
    HxRuleConditionType[HxRuleConditionType["Voicemail"] = 32] = "Voicemail";
    HxRuleConditionType[HxRuleConditionType["FlaggedForAction"] = 33] = "FlaggedForAction";
    HxRuleConditionType[HxRuleConditionType["FromSubscription"] = 34] = "FromSubscription";
})(HxRuleConditionType = exports.HxRuleConditionType || (exports.HxRuleConditionType = {}));
function getHxRuleConditionTypeAsString(value) {
    return HxRuleConditionType[value];
}
exports.getHxRuleConditionTypeAsString = getHxRuleConditionTypeAsString;
function getHxRuleConditionTypeFromString(value) {
    return HxRuleConditionType[value];
}
exports.getHxRuleConditionTypeFromString = getHxRuleConditionTypeFromString;
/*-------------------------------------------------------------------------------
  HxRuleActionType
-------------------------------------------------------------------------------*/
var HxRuleActionType;
(function (HxRuleActionType) {
    HxRuleActionType[HxRuleActionType["Unknown"] = 0] = "Unknown";
    HxRuleActionType[HxRuleActionType["MoveToFolder"] = 1] = "MoveToFolder";
    HxRuleActionType[HxRuleActionType["CopyToFolder"] = 2] = "CopyToFolder";
    HxRuleActionType[HxRuleActionType["Delete"] = 3] = "Delete";
    HxRuleActionType[HxRuleActionType["PinMessage"] = 4] = "PinMessage";
    HxRuleActionType[HxRuleActionType["MarkAsRead"] = 5] = "MarkAsRead";
    HxRuleActionType[HxRuleActionType["MarkImportance"] = 6] = "MarkImportance";
    HxRuleActionType[HxRuleActionType["AssignCategory"] = 7] = "AssignCategory";
    HxRuleActionType[HxRuleActionType["FlagMessage"] = 8] = "FlagMessage";
    HxRuleActionType[HxRuleActionType["ForwardToRecipients"] = 9] = "ForwardToRecipients";
    HxRuleActionType[HxRuleActionType["ForwardAsAttachmentToRecipients"] = 10] = "ForwardAsAttachmentToRecipients";
    HxRuleActionType[HxRuleActionType["RedirectToRecipients"] = 11] = "RedirectToRecipients";
    HxRuleActionType[HxRuleActionType["StopProcessing"] = 12] = "StopProcessing";
    HxRuleActionType[HxRuleActionType["ServerReplyMessage"] = 13] = "ServerReplyMessage";
    HxRuleActionType[HxRuleActionType["MarkSensitivity"] = 14] = "MarkSensitivity";
    HxRuleActionType[HxRuleActionType["SendSmsAlertToRecipients"] = 15] = "SendSmsAlertToRecipients";
    HxRuleActionType[HxRuleActionType["PermanentDelete"] = 16] = "PermanentDelete";
    HxRuleActionType[HxRuleActionType["AssignSystemCategories"] = 17] = "AssignSystemCategories";
    HxRuleActionType[HxRuleActionType["RemoveSystemCategories"] = 18] = "RemoveSystemCategories";
})(HxRuleActionType = exports.HxRuleActionType || (exports.HxRuleActionType = {}));
function getHxRuleActionTypeAsString(value) {
    return HxRuleActionType[value];
}
exports.getHxRuleActionTypeAsString = getHxRuleActionTypeAsString;
function getHxRuleActionTypeFromString(value) {
    return HxRuleActionType[value];
}
exports.getHxRuleActionTypeFromString = getHxRuleActionTypeFromString;
/*-------------------------------------------------------------------------------
  HxActivatedByType
-------------------------------------------------------------------------------*/
var HxActivatedByType;
(function (HxActivatedByType) {
    HxActivatedByType[HxActivatedByType["Launch"] = 0] = "Launch";
    HxActivatedByType[HxActivatedByType["File"] = 1] = "File";
    HxActivatedByType[HxActivatedByType["Share"] = 2] = "Share";
    HxActivatedByType[HxActivatedByType["ContactPanel"] = 5] = "ContactPanel";
    HxActivatedByType[HxActivatedByType["Programmatic"] = 3] = "Programmatic";
    HxActivatedByType[HxActivatedByType["LivePersonaCard"] = 6] = "LivePersonaCard";
    HxActivatedByType[HxActivatedByType["Others"] = 4] = "Others";
})(HxActivatedByType = exports.HxActivatedByType || (exports.HxActivatedByType = {}));
function getHxActivatedByTypeAsString(value) {
    return HxActivatedByType[value];
}
exports.getHxActivatedByTypeAsString = getHxActivatedByTypeAsString;
function getHxActivatedByTypeFromString(value) {
    return HxActivatedByType[value];
}
exports.getHxActivatedByTypeFromString = getHxActivatedByTypeFromString;
/*-------------------------------------------------------------------------------
  HxNetworkStatus
-------------------------------------------------------------------------------*/
var HxNetworkStatus;
(function (HxNetworkStatus) {
    HxNetworkStatus[HxNetworkStatus["Unknown"] = 4] = "Unknown";
    HxNetworkStatus[HxNetworkStatus["Offline"] = 0] = "Offline";
    HxNetworkStatus[HxNetworkStatus["HighCost"] = 1] = "HighCost";
    HxNetworkStatus[HxNetworkStatus["Metered"] = 2] = "Metered";
    HxNetworkStatus[HxNetworkStatus["Unrestricted"] = 3] = "Unrestricted";
})(HxNetworkStatus = exports.HxNetworkStatus || (exports.HxNetworkStatus = {}));
function getHxNetworkStatusAsString(value) {
    return HxNetworkStatus[value];
}
exports.getHxNetworkStatusAsString = getHxNetworkStatusAsString;
function getHxNetworkStatusFromString(value) {
    return HxNetworkStatus[value];
}
exports.getHxNetworkStatusFromString = getHxNetworkStatusFromString;
/*-------------------------------------------------------------------------------
  HxBatteryStatus
-------------------------------------------------------------------------------*/
var HxBatteryStatus;
(function (HxBatteryStatus) {
    HxBatteryStatus[HxBatteryStatus["Unknown"] = 3] = "Unknown";
    HxBatteryStatus[HxBatteryStatus["Low"] = 0] = "Low";
    HxBatteryStatus[HxBatteryStatus["Normal"] = 1] = "Normal";
    HxBatteryStatus[HxBatteryStatus["PluggedIn"] = 2] = "PluggedIn";
})(HxBatteryStatus = exports.HxBatteryStatus || (exports.HxBatteryStatus = {}));
function getHxBatteryStatusAsString(value) {
    return HxBatteryStatus[value];
}
exports.getHxBatteryStatusAsString = getHxBatteryStatusAsString;
function getHxBatteryStatusFromString(value) {
    return HxBatteryStatus[value];
}
exports.getHxBatteryStatusFromString = getHxBatteryStatusFromString;
/*-------------------------------------------------------------------------------
  HxGroupAccessType
-------------------------------------------------------------------------------*/
var HxGroupAccessType;
(function (HxGroupAccessType) {
    HxGroupAccessType[HxGroupAccessType["None"] = 3] = "None";
    HxGroupAccessType[HxGroupAccessType["Private"] = 0] = "Private";
    HxGroupAccessType[HxGroupAccessType["Secret"] = 1] = "Secret";
    HxGroupAccessType[HxGroupAccessType["Public"] = 2] = "Public";
})(HxGroupAccessType = exports.HxGroupAccessType || (exports.HxGroupAccessType = {}));
function getHxGroupAccessTypeAsString(value) {
    return HxGroupAccessType[value];
}
exports.getHxGroupAccessTypeAsString = getHxGroupAccessTypeAsString;
function getHxGroupAccessTypeFromString(value) {
    return HxGroupAccessType[value];
}
exports.getHxGroupAccessTypeFromString = getHxGroupAccessTypeFromString;
/*-------------------------------------------------------------------------------
  HxGroupSubscriptionType
-------------------------------------------------------------------------------*/
var HxGroupSubscriptionType;
(function (HxGroupSubscriptionType) {
    HxGroupSubscriptionType[HxGroupSubscriptionType["All"] = 0] = "All";
    HxGroupSubscriptionType[HxGroupSubscriptionType["ReplyAndCalendar"] = 1] = "ReplyAndCalendar";
    HxGroupSubscriptionType[HxGroupSubscriptionType["ReplyOnly"] = 2] = "ReplyOnly";
    HxGroupSubscriptionType[HxGroupSubscriptionType["None"] = 3] = "None";
})(HxGroupSubscriptionType = exports.HxGroupSubscriptionType || (exports.HxGroupSubscriptionType = {}));
function getHxGroupSubscriptionTypeAsString(value) {
    return HxGroupSubscriptionType[value];
}
exports.getHxGroupSubscriptionTypeAsString = getHxGroupSubscriptionTypeAsString;
function getHxGroupSubscriptionTypeFromString(value) {
    return HxGroupSubscriptionType[value];
}
exports.getHxGroupSubscriptionTypeFromString = getHxGroupSubscriptionTypeFromString;
/*-------------------------------------------------------------------------------
  HxGroupProductType
-------------------------------------------------------------------------------*/
var HxGroupProductType;
(function (HxGroupProductType) {
    HxGroupProductType[HxGroupProductType["Default"] = 0] = "Default";
    HxGroupProductType[HxGroupProductType["HomeRoom"] = 1] = "HomeRoom";
    HxGroupProductType[HxGroupProductType["Yammer"] = 2] = "Yammer";
    HxGroupProductType[HxGroupProductType["SkypeConsumer"] = 3] = "SkypeConsumer";
})(HxGroupProductType = exports.HxGroupProductType || (exports.HxGroupProductType = {}));
function getHxGroupProductTypeAsString(value) {
    return HxGroupProductType[value];
}
exports.getHxGroupProductTypeAsString = getHxGroupProductTypeAsString;
function getHxGroupProductTypeFromString(value) {
    return HxGroupProductType[value];
}
exports.getHxGroupProductTypeFromString = getHxGroupProductTypeFromString;
/*-------------------------------------------------------------------------------
  HxGroupMemberType
-------------------------------------------------------------------------------*/
var HxGroupMemberType;
(function (HxGroupMemberType) {
    HxGroupMemberType[HxGroupMemberType["Member"] = 0] = "Member";
    HxGroupMemberType[HxGroupMemberType["Owner"] = 1] = "Owner";
    HxGroupMemberType[HxGroupMemberType["Guest"] = 2] = "Guest";
})(HxGroupMemberType = exports.HxGroupMemberType || (exports.HxGroupMemberType = {}));
function getHxGroupMemberTypeAsString(value) {
    return HxGroupMemberType[value];
}
exports.getHxGroupMemberTypeAsString = getHxGroupMemberTypeAsString;
function getHxGroupMemberTypeFromString(value) {
    return HxGroupMemberType[value];
}
exports.getHxGroupMemberTypeFromString = getHxGroupMemberTypeFromString;
/*-------------------------------------------------------------------------------
  HxPolicyComplianceState
-------------------------------------------------------------------------------*/
var HxPolicyComplianceState;
(function (HxPolicyComplianceState) {
    HxPolicyComplianceState[HxPolicyComplianceState["Unknown"] = 0] = "Unknown";
    HxPolicyComplianceState[HxPolicyComplianceState["Success"] = 1] = "Success";
    HxPolicyComplianceState[HxPolicyComplianceState["PartialSuccess"] = 2] = "PartialSuccess";
    HxPolicyComplianceState[HxPolicyComplianceState["Failure"] = 3] = "Failure";
    HxPolicyComplianceState[HxPolicyComplianceState["ExternallyManaged"] = 4] = "ExternallyManaged";
})(HxPolicyComplianceState = exports.HxPolicyComplianceState || (exports.HxPolicyComplianceState = {}));
function getHxPolicyComplianceStateAsString(value) {
    return HxPolicyComplianceState[value];
}
exports.getHxPolicyComplianceStateAsString = getHxPolicyComplianceStateAsString;
function getHxPolicyComplianceStateFromString(value) {
    return HxPolicyComplianceState[value];
}
exports.getHxPolicyComplianceStateFromString = getHxPolicyComplianceStateFromString;
/*-------------------------------------------------------------------------------
  HxStatusCodeType
-------------------------------------------------------------------------------*/
var HxStatusCodeType;
(function (HxStatusCodeType) {
    HxStatusCodeType[HxStatusCodeType["Unknown"] = 0] = "Unknown";
    HxStatusCodeType[HxStatusCodeType["Success"] = 1] = "Success";
    HxStatusCodeType[HxStatusCodeType["Failure"] = 2] = "Failure";
})(HxStatusCodeType = exports.HxStatusCodeType || (exports.HxStatusCodeType = {}));
function getHxStatusCodeTypeAsString(value) {
    return HxStatusCodeType[value];
}
exports.getHxStatusCodeTypeAsString = getHxStatusCodeTypeAsString;
function getHxStatusCodeTypeFromString(value) {
    return HxStatusCodeType[value];
}
exports.getHxStatusCodeTypeFromString = getHxStatusCodeTypeFromString;
/*-------------------------------------------------------------------------------
  HxMigrationStateType
-------------------------------------------------------------------------------*/
var HxMigrationStateType;
(function (HxMigrationStateType) {
    HxMigrationStateType[HxMigrationStateType["Initialized"] = 0] = "Initialized";
    HxMigrationStateType[HxMigrationStateType["SyncingListOfViews"] = 1] = "SyncingListOfViews";
    HxMigrationStateType[HxMigrationStateType["SyncingMailActions"] = 2] = "SyncingMailActions";
    HxMigrationStateType[HxMigrationStateType["SyncingCalendarActions"] = 3] = "SyncingCalendarActions";
    HxMigrationStateType[HxMigrationStateType["SyncingRecipientsCache"] = 13] = "SyncingRecipientsCache";
    HxMigrationStateType[HxMigrationStateType["SyncingPrunedManuallyClassifiedMessageHeaders"] = 14] = "SyncingPrunedManuallyClassifiedMessageHeaders";
    HxMigrationStateType[HxMigrationStateType["SyncingTop25InboxMessageHeaders"] = 12] = "SyncingTop25InboxMessageHeaders";
    HxMigrationStateType[HxMigrationStateType["SyncingTodayAppointments"] = 15] = "SyncingTodayAppointments";
    HxMigrationStateType[HxMigrationStateType["Phase1Completed"] = 4] = "Phase1Completed";
    HxMigrationStateType[HxMigrationStateType["SyncingMessageData"] = 5] = "SyncingMessageData";
    HxMigrationStateType[HxMigrationStateType["SyncingAttachments"] = 6] = "SyncingAttachments";
    HxMigrationStateType[HxMigrationStateType["SyncingMessageHeaderReplicationMetaData"] = 7] = "SyncingMessageHeaderReplicationMetaData";
    HxMigrationStateType[HxMigrationStateType["SyncingPhotos"] = 10] = "SyncingPhotos";
    HxMigrationStateType[HxMigrationStateType["Completed"] = 8] = "Completed";
    HxMigrationStateType[HxMigrationStateType["Phase2Completed"] = 9] = "Phase2Completed";
})(HxMigrationStateType = exports.HxMigrationStateType || (exports.HxMigrationStateType = {}));
function getHxMigrationStateTypeAsString(value) {
    return HxMigrationStateType[value];
}
exports.getHxMigrationStateTypeAsString = getHxMigrationStateTypeAsString;
function getHxMigrationStateTypeFromString(value) {
    return HxMigrationStateType[value];
}
exports.getHxMigrationStateTypeFromString = getHxMigrationStateTypeFromString;
/*-------------------------------------------------------------------------------
  HxMockActorFailureType
-------------------------------------------------------------------------------*/
var HxMockActorFailureType;
(function (HxMockActorFailureType) {
    HxMockActorFailureType[HxMockActorFailureType["None"] = 0] = "None";
    HxMockActorFailureType[HxMockActorFailureType["PreconditionsViolated"] = 1] = "PreconditionsViolated";
    HxMockActorFailureType[HxMockActorFailureType["UserErrorInStorage"] = 2] = "UserErrorInStorage";
    HxMockActorFailureType[HxMockActorFailureType["GeneralErrorInStorage"] = 3] = "GeneralErrorInStorage";
    HxMockActorFailureType[HxMockActorFailureType["UserErrorInSync"] = 4] = "UserErrorInSync";
    HxMockActorFailureType[HxMockActorFailureType["SuccessInSync"] = 5] = "SuccessInSync";
    HxMockActorFailureType[HxMockActorFailureType["SuccessResultsInSync"] = 6] = "SuccessResultsInSync";
    HxMockActorFailureType[HxMockActorFailureType["FailureResultsInSync"] = 7] = "FailureResultsInSync";
    HxMockActorFailureType[HxMockActorFailureType["NoExplicitFailureResults"] = 8] = "NoExplicitFailureResults";
})(HxMockActorFailureType = exports.HxMockActorFailureType || (exports.HxMockActorFailureType = {}));
function getHxMockActorFailureTypeAsString(value) {
    return HxMockActorFailureType[value];
}
exports.getHxMockActorFailureTypeAsString = getHxMockActorFailureTypeAsString;
function getHxMockActorFailureTypeFromString(value) {
    return HxMockActorFailureType[value];
}
exports.getHxMockActorFailureTypeFromString = getHxMockActorFailureTypeFromString;
/*-------------------------------------------------------------------------------
  HxEndTimeMode
-------------------------------------------------------------------------------*/
var HxEndTimeMode;
(function (HxEndTimeMode) {
    HxEndTimeMode[HxEndTimeMode["EndOfTime"] = 0] = "EndOfTime";
    HxEndTimeMode[HxEndTimeMode["SpecificTime"] = 1] = "SpecificTime";
    HxEndTimeMode[HxEndTimeMode["None"] = 2] = "None";
})(HxEndTimeMode = exports.HxEndTimeMode || (exports.HxEndTimeMode = {}));
function getHxEndTimeModeAsString(value) {
    return HxEndTimeMode[value];
}
exports.getHxEndTimeModeAsString = getHxEndTimeModeAsString;
function getHxEndTimeModeFromString(value) {
    return HxEndTimeMode[value];
}
exports.getHxEndTimeModeFromString = getHxEndTimeModeFromString;
/*-------------------------------------------------------------------------------
  HxCertificateUsage
-------------------------------------------------------------------------------*/
var HxCertificateUsage;
(function (HxCertificateUsage) {
    HxCertificateUsage[HxCertificateUsage["None"] = 0] = "None";
    HxCertificateUsage[HxCertificateUsage["Signing"] = 1] = "Signing";
    HxCertificateUsage[HxCertificateUsage["Encryption"] = 2] = "Encryption";
    HxCertificateUsage[HxCertificateUsage["SigningAndEncryption"] = 3] = "SigningAndEncryption";
})(HxCertificateUsage = exports.HxCertificateUsage || (exports.HxCertificateUsage = {}));
function getHxCertificateUsageAsString(value) {
    return HxCertificateUsage[value];
}
exports.getHxCertificateUsageAsString = getHxCertificateUsageAsString;
function getHxCertificateUsageFromString(value) {
    return HxCertificateUsage[value];
}
exports.getHxCertificateUsageFromString = getHxCertificateUsageFromString;
/*-------------------------------------------------------------------------------
  HxAllowGuestAction
-------------------------------------------------------------------------------*/
var HxAllowGuestAction;
(function (HxAllowGuestAction) {
    HxAllowGuestAction[HxAllowGuestAction["Allowed"] = 0] = "Allowed";
    HxAllowGuestAction[HxAllowGuestAction["NotAllowed"] = 1] = "NotAllowed";
    HxAllowGuestAction[HxAllowGuestAction["Unknown"] = 2] = "Unknown";
})(HxAllowGuestAction = exports.HxAllowGuestAction || (exports.HxAllowGuestAction = {}));
function getHxAllowGuestActionAsString(value) {
    return HxAllowGuestAction[value];
}
exports.getHxAllowGuestActionAsString = getHxAllowGuestActionAsString;
function getHxAllowGuestActionFromString(value) {
    return HxAllowGuestAction[value];
}
exports.getHxAllowGuestActionFromString = getHxAllowGuestActionFromString;
/*-------------------------------------------------------------------------------
  HxAddInAccessTokenType
-------------------------------------------------------------------------------*/
var HxAddInAccessTokenType;
(function (HxAddInAccessTokenType) {
    HxAddInAccessTokenType[HxAddInAccessTokenType["CallerIdentity"] = 0] = "CallerIdentity";
    HxAddInAccessTokenType[HxAddInAccessTokenType["ExtensionCallback"] = 1] = "ExtensionCallback";
    HxAddInAccessTokenType[HxAddInAccessTokenType["ScopedToken"] = 2] = "ScopedToken";
    HxAddInAccessTokenType[HxAddInAccessTokenType["ExtensionRestApiCallback"] = 3] = "ExtensionRestApiCallback";
    HxAddInAccessTokenType[HxAddInAccessTokenType["Connectors"] = 4] = "Connectors";
    HxAddInAccessTokenType[HxAddInAccessTokenType["Loki"] = 5] = "Loki";
    HxAddInAccessTokenType[HxAddInAccessTokenType["DesktopOutlook"] = 6] = "DesktopOutlook";
})(HxAddInAccessTokenType = exports.HxAddInAccessTokenType || (exports.HxAddInAccessTokenType = {}));
function getHxAddInAccessTokenTypeAsString(value) {
    return HxAddInAccessTokenType[value];
}
exports.getHxAddInAccessTokenTypeAsString = getHxAddInAccessTokenTypeAsString;
function getHxAddInAccessTokenTypeFromString(value) {
    return HxAddInAccessTokenType[value];
}
exports.getHxAddInAccessTokenTypeFromString = getHxAddInAccessTokenTypeFromString;
/*-------------------------------------------------------------------------------
  HxMipLabelAuditOperationType
-------------------------------------------------------------------------------*/
var HxMipLabelAuditOperationType;
(function (HxMipLabelAuditOperationType) {
    HxMipLabelAuditOperationType[HxMipLabelAuditOperationType["SensitivityLabelApplied"] = 0] = "SensitivityLabelApplied";
    HxMipLabelAuditOperationType[HxMipLabelAuditOperationType["SensitivityLabelChanged"] = 1] = "SensitivityLabelChanged";
    HxMipLabelAuditOperationType[HxMipLabelAuditOperationType["SensitivityLabelRemoved"] = 2] = "SensitivityLabelRemoved";
    HxMipLabelAuditOperationType[HxMipLabelAuditOperationType["SensitivityLabelRecommended"] = 3] = "SensitivityLabelRecommended";
    HxMipLabelAuditOperationType[HxMipLabelAuditOperationType["SensitivityLabelRecommendedAndDismissed"] = 4] = "SensitivityLabelRecommendedAndDismissed";
    HxMipLabelAuditOperationType[HxMipLabelAuditOperationType["SensitivityLabelFileRenamed"] = 5] = "SensitivityLabelFileRenamed";
})(HxMipLabelAuditOperationType = exports.HxMipLabelAuditOperationType || (exports.HxMipLabelAuditOperationType = {}));
function getHxMipLabelAuditOperationTypeAsString(value) {
    return HxMipLabelAuditOperationType[value];
}
exports.getHxMipLabelAuditOperationTypeAsString = getHxMipLabelAuditOperationTypeAsString;
function getHxMipLabelAuditOperationTypeFromString(value) {
    return HxMipLabelAuditOperationType[value];
}
exports.getHxMipLabelAuditOperationTypeFromString = getHxMipLabelAuditOperationTypeFromString;
/*-------------------------------------------------------------------------------
  HxMipLabelChangeActionSourceType
-------------------------------------------------------------------------------*/
var HxMipLabelChangeActionSourceType;
(function (HxMipLabelChangeActionSourceType) {
    HxMipLabelChangeActionSourceType[HxMipLabelChangeActionSourceType["None"] = 0] = "None";
    HxMipLabelChangeActionSourceType[HxMipLabelChangeActionSourceType["Default"] = 1] = "Default";
    HxMipLabelChangeActionSourceType[HxMipLabelChangeActionSourceType["Auto"] = 2] = "Auto";
    HxMipLabelChangeActionSourceType[HxMipLabelChangeActionSourceType["Manual"] = 3] = "Manual";
    HxMipLabelChangeActionSourceType[HxMipLabelChangeActionSourceType["Recommended"] = 4] = "Recommended";
})(HxMipLabelChangeActionSourceType = exports.HxMipLabelChangeActionSourceType || (exports.HxMipLabelChangeActionSourceType = {}));
function getHxMipLabelChangeActionSourceTypeAsString(value) {
    return HxMipLabelChangeActionSourceType[value];
}
exports.getHxMipLabelChangeActionSourceTypeAsString = getHxMipLabelChangeActionSourceTypeAsString;
function getHxMipLabelChangeActionSourceTypeFromString(value) {
    return HxMipLabelChangeActionSourceType[value];
}
exports.getHxMipLabelChangeActionSourceTypeFromString = getHxMipLabelChangeActionSourceTypeFromString;
/*-------------------------------------------------------------------------------
  HxMipLabelEventType
-------------------------------------------------------------------------------*/
var HxMipLabelEventType;
(function (HxMipLabelEventType) {
    HxMipLabelEventType[HxMipLabelEventType["None"] = 0] = "None";
    HxMipLabelEventType[HxMipLabelEventType["LabelUpgraded"] = 1] = "LabelUpgraded";
    HxMipLabelEventType[HxMipLabelEventType["LabelDowngraded"] = 2] = "LabelDowngraded";
    HxMipLabelEventType[HxMipLabelEventType["LabelChangedSameOrder"] = 3] = "LabelChangedSameOrder";
})(HxMipLabelEventType = exports.HxMipLabelEventType || (exports.HxMipLabelEventType = {}));
function getHxMipLabelEventTypeAsString(value) {
    return HxMipLabelEventType[value];
}
exports.getHxMipLabelEventTypeAsString = getHxMipLabelEventTypeAsString;
function getHxMipLabelEventTypeFromString(value) {
    return HxMipLabelEventType[value];
}
exports.getHxMipLabelEventTypeFromString = getHxMipLabelEventTypeFromString;
/*-------------------------------------------------------------------------------
  HxAllowBluetoothType
-------------------------------------------------------------------------------*/
var HxAllowBluetoothType;
(function (HxAllowBluetoothType) {
    HxAllowBluetoothType[HxAllowBluetoothType["Disable"] = 0] = "Disable";
    HxAllowBluetoothType[HxAllowBluetoothType["HandsfreeOnly"] = 1] = "HandsfreeOnly";
    HxAllowBluetoothType[HxAllowBluetoothType["Allow"] = 2] = "Allow";
})(HxAllowBluetoothType = exports.HxAllowBluetoothType || (exports.HxAllowBluetoothType = {}));
function getHxAllowBluetoothTypeAsString(value) {
    return HxAllowBluetoothType[value];
}
exports.getHxAllowBluetoothTypeAsString = getHxAllowBluetoothTypeAsString;
function getHxAllowBluetoothTypeFromString(value) {
    return HxAllowBluetoothType[value];
}
exports.getHxAllowBluetoothTypeFromString = getHxAllowBluetoothTypeFromString;
/*-------------------------------------------------------------------------------
  HxSmimeCertValidationType
-------------------------------------------------------------------------------*/
var HxSmimeCertValidationType;
(function (HxSmimeCertValidationType) {
    HxSmimeCertValidationType[HxSmimeCertValidationType["Service"] = 0] = "Service";
    HxSmimeCertValidationType[HxSmimeCertValidationType["Local"] = 1] = "Local";
    HxSmimeCertValidationType[HxSmimeCertValidationType["LocalAndService"] = 2] = "LocalAndService";
})(HxSmimeCertValidationType = exports.HxSmimeCertValidationType || (exports.HxSmimeCertValidationType = {}));
function getHxSmimeCertValidationTypeAsString(value) {
    return HxSmimeCertValidationType[value];
}
exports.getHxSmimeCertValidationTypeAsString = getHxSmimeCertValidationTypeAsString;
function getHxSmimeCertValidationTypeFromString(value) {
    return HxSmimeCertValidationType[value];
}
exports.getHxSmimeCertValidationTypeFromString = getHxSmimeCertValidationTypeFromString;
/*-------------------------------------------------------------------------------
  HxRestEndpointType
-------------------------------------------------------------------------------*/
var HxRestEndpointType;
(function (HxRestEndpointType) {
    HxRestEndpointType[HxRestEndpointType["Substrate"] = 0] = "Substrate";
    HxRestEndpointType[HxRestEndpointType["Outlook"] = 1] = "Outlook";
    HxRestEndpointType[HxRestEndpointType["Graph"] = 2] = "Graph";
    HxRestEndpointType[HxRestEndpointType["AddIns"] = 3] = "AddIns";
})(HxRestEndpointType = exports.HxRestEndpointType || (exports.HxRestEndpointType = {}));
function getHxRestEndpointTypeAsString(value) {
    return HxRestEndpointType[value];
}
exports.getHxRestEndpointTypeAsString = getHxRestEndpointTypeAsString;
function getHxRestEndpointTypeFromString(value) {
    return HxRestEndpointType[value];
}
exports.getHxRestEndpointTypeFromString = getHxRestEndpointTypeFromString;
/*-------------------------------------------------------------------------------
  HxCloudEnvironmentType
-------------------------------------------------------------------------------*/
var HxCloudEnvironmentType;
(function (HxCloudEnvironmentType) {
    HxCloudEnvironmentType[HxCloudEnvironmentType["Worldwide"] = 0] = "Worldwide";
    HxCloudEnvironmentType[HxCloudEnvironmentType["GccHigh"] = 1] = "GccHigh";
    HxCloudEnvironmentType[HxCloudEnvironmentType["Dod"] = 2] = "Dod";
    HxCloudEnvironmentType[HxCloudEnvironmentType["Gallatin"] = 3] = "Gallatin";
    HxCloudEnvironmentType[HxCloudEnvironmentType["Blackforest"] = 4] = "Blackforest";
})(HxCloudEnvironmentType = exports.HxCloudEnvironmentType || (exports.HxCloudEnvironmentType = {}));
function getHxCloudEnvironmentTypeAsString(value) {
    return HxCloudEnvironmentType[value];
}
exports.getHxCloudEnvironmentTypeAsString = getHxCloudEnvironmentTypeAsString;
function getHxCloudEnvironmentTypeFromString(value) {
    return HxCloudEnvironmentType[value];
}
exports.getHxCloudEnvironmentTypeFromString = getHxCloudEnvironmentTypeFromString;
/*-------------------------------------------------------------------------------
  HxCertificateDefaultFlagsType
-------------------------------------------------------------------------------*/
var HxCertificateDefaultFlagsType;
(function (HxCertificateDefaultFlagsType) {
    HxCertificateDefaultFlagsType[HxCertificateDefaultFlagsType["None"] = 0] = "None";
    HxCertificateDefaultFlagsType[HxCertificateDefaultFlagsType["DefaultForFormat"] = 1] = "DefaultForFormat";
    HxCertificateDefaultFlagsType[HxCertificateDefaultFlagsType["GlobalDefault"] = 2] = "GlobalDefault";
    HxCertificateDefaultFlagsType[HxCertificateDefaultFlagsType["DefaultSendCert"] = 4] = "DefaultSendCert";
})(HxCertificateDefaultFlagsType = exports.HxCertificateDefaultFlagsType || (exports.HxCertificateDefaultFlagsType = {}));
function getHxCertificateDefaultFlagsTypeAsString(value) {
    return HxCertificateDefaultFlagsType[value];
}
exports.getHxCertificateDefaultFlagsTypeAsString = getHxCertificateDefaultFlagsTypeAsString;
function getHxCertificateDefaultFlagsTypeFromString(value) {
    return HxCertificateDefaultFlagsType[value];
}
exports.getHxCertificateDefaultFlagsTypeFromString = getHxCertificateDefaultFlagsTypeFromString;
/*-------------------------------------------------------------------------------
  HxCertificateSourceType
-------------------------------------------------------------------------------*/
var HxCertificateSourceType;
(function (HxCertificateSourceType) {
    HxCertificateSourceType[HxCertificateSourceType["Contacts"] = 0] = "Contacts";
    HxCertificateSourceType[HxCertificateSourceType["GAL"] = 1] = "GAL";
    HxCertificateSourceType[HxCertificateSourceType["Device"] = 2] = "Device";
    HxCertificateSourceType[HxCertificateSourceType["LDAP"] = 3] = "LDAP";
})(HxCertificateSourceType = exports.HxCertificateSourceType || (exports.HxCertificateSourceType = {}));
function getHxCertificateSourceTypeAsString(value) {
    return HxCertificateSourceType[value];
}
exports.getHxCertificateSourceTypeAsString = getHxCertificateSourceTypeAsString;
function getHxCertificateSourceTypeFromString(value) {
    return HxCertificateSourceType[value];
}
exports.getHxCertificateSourceTypeFromString = getHxCertificateSourceTypeFromString;
/*-------------------------------------------------------------------------------
  HxCredentialsValidationStatus
-------------------------------------------------------------------------------*/
var HxCredentialsValidationStatus;
(function (HxCredentialsValidationStatus) {
    HxCredentialsValidationStatus[HxCredentialsValidationStatus["Unknown"] = 0] = "Unknown";
    HxCredentialsValidationStatus[HxCredentialsValidationStatus["Valid"] = 1] = "Valid";
    HxCredentialsValidationStatus[HxCredentialsValidationStatus["Invalid"] = 2] = "Invalid";
    HxCredentialsValidationStatus[HxCredentialsValidationStatus["SslCheckFailed"] = 3] = "SslCheckFailed";
    HxCredentialsValidationStatus[HxCredentialsValidationStatus["OutgoingCredentialsInvalid"] = 4] = "OutgoingCredentialsInvalid";
    HxCredentialsValidationStatus[HxCredentialsValidationStatus["OutgoingSslCheckFailed"] = 5] = "OutgoingSslCheckFailed";
    HxCredentialsValidationStatus[HxCredentialsValidationStatus["InvalidServerConfig"] = 6] = "InvalidServerConfig";
    HxCredentialsValidationStatus[HxCredentialsValidationStatus["InvalidOutgoingServerConfig"] = 7] = "InvalidOutgoingServerConfig";
})(HxCredentialsValidationStatus = exports.HxCredentialsValidationStatus || (exports.HxCredentialsValidationStatus = {}));
function getHxCredentialsValidationStatusAsString(value) {
    return HxCredentialsValidationStatus[value];
}
exports.getHxCredentialsValidationStatusAsString = getHxCredentialsValidationStatusAsString;
function getHxCredentialsValidationStatusFromString(value) {
    return HxCredentialsValidationStatus[value];
}
exports.getHxCredentialsValidationStatusFromString = getHxCredentialsValidationStatusFromString;
/*-------------------------------------------------------------------------------
  HxCalendarIconAssetFileType
-------------------------------------------------------------------------------*/
var HxCalendarIconAssetFileType;
(function (HxCalendarIconAssetFileType) {
    HxCalendarIconAssetFileType[HxCalendarIconAssetFileType["Svg"] = 0] = "Svg";
    HxCalendarIconAssetFileType[HxCalendarIconAssetFileType["FullColorSvg"] = 1] = "FullColorSvg";
    HxCalendarIconAssetFileType[HxCalendarIconAssetFileType["Pdf"] = 2] = "Pdf";
    HxCalendarIconAssetFileType[HxCalendarIconAssetFileType["MdpiPng"] = 3] = "MdpiPng";
    HxCalendarIconAssetFileType[HxCalendarIconAssetFileType["HdpiPng"] = 4] = "HdpiPng";
    HxCalendarIconAssetFileType[HxCalendarIconAssetFileType["XHdpiPng"] = 5] = "XHdpiPng";
    HxCalendarIconAssetFileType[HxCalendarIconAssetFileType["XxHdpiPng"] = 6] = "XxHdpiPng";
    HxCalendarIconAssetFileType[HxCalendarIconAssetFileType["XxxHdpiPng"] = 7] = "XxxHdpiPng";
    HxCalendarIconAssetFileType[HxCalendarIconAssetFileType["FluentSVG"] = 8] = "FluentSVG";
    HxCalendarIconAssetFileType[HxCalendarIconAssetFileType["FluentPdf"] = 9] = "FluentPdf";
    HxCalendarIconAssetFileType[HxCalendarIconAssetFileType["None"] = 10] = "None";
})(HxCalendarIconAssetFileType = exports.HxCalendarIconAssetFileType || (exports.HxCalendarIconAssetFileType = {}));
function getHxCalendarIconAssetFileTypeAsString(value) {
    return HxCalendarIconAssetFileType[value];
}
exports.getHxCalendarIconAssetFileTypeAsString = getHxCalendarIconAssetFileTypeAsString;
function getHxCalendarIconAssetFileTypeFromString(value) {
    return HxCalendarIconAssetFileType[value];
}
exports.getHxCalendarIconAssetFileTypeFromString = getHxCalendarIconAssetFileTypeFromString;
/*-------------------------------------------------------------------------------
  HxOutlookCloudSettingValueSourceType
-------------------------------------------------------------------------------*/
var HxOutlookCloudSettingValueSourceType;
(function (HxOutlookCloudSettingValueSourceType) {
    HxOutlookCloudSettingValueSourceType[HxOutlookCloudSettingValueSourceType["Unknown"] = 0] = "Unknown";
    HxOutlookCloudSettingValueSourceType[HxOutlookCloudSettingValueSourceType["SystemDefault"] = 1] = "SystemDefault";
    HxOutlookCloudSettingValueSourceType[HxOutlookCloudSettingValueSourceType["TenantDefault"] = 2] = "TenantDefault";
    HxOutlookCloudSettingValueSourceType[HxOutlookCloudSettingValueSourceType["TenantForced"] = 3] = "TenantForced";
    HxOutlookCloudSettingValueSourceType[HxOutlookCloudSettingValueSourceType["UserOverride"] = 4] = "UserOverride";
})(HxOutlookCloudSettingValueSourceType = exports.HxOutlookCloudSettingValueSourceType || (exports.HxOutlookCloudSettingValueSourceType = {}));
function getHxOutlookCloudSettingValueSourceTypeAsString(value) {
    return HxOutlookCloudSettingValueSourceType[value];
}
exports.getHxOutlookCloudSettingValueSourceTypeAsString = getHxOutlookCloudSettingValueSourceTypeAsString;
function getHxOutlookCloudSettingValueSourceTypeFromString(value) {
    return HxOutlookCloudSettingValueSourceType[value];
}
exports.getHxOutlookCloudSettingValueSourceTypeFromString = getHxOutlookCloudSettingValueSourceTypeFromString;
/*-------------------------------------------------------------------------------
  HxSslScheme
-------------------------------------------------------------------------------*/
var HxSslScheme;
(function (HxSslScheme) {
    HxSslScheme[HxSslScheme["SecureFromStart"] = 0] = "SecureFromStart";
    HxSslScheme[HxSslScheme["UpgradeToSecure"] = 1] = "UpgradeToSecure";
    HxSslScheme[HxSslScheme["NotSecure"] = 2] = "NotSecure";
})(HxSslScheme = exports.HxSslScheme || (exports.HxSslScheme = {}));
function getHxSslSchemeAsString(value) {
    return HxSslScheme[value];
}
exports.getHxSslSchemeAsString = getHxSslSchemeAsString;
function getHxSslSchemeFromString(value) {
    return HxSslScheme[value];
}
exports.getHxSslSchemeFromString = getHxSslSchemeFromString;
/*-------------------------------------------------------------------------------
  HxNewItemNotificationType
-------------------------------------------------------------------------------*/
var HxNewItemNotificationType;
(function (HxNewItemNotificationType) {
    HxNewItemNotificationType[HxNewItemNotificationType["None"] = 0] = "None";
    HxNewItemNotificationType[HxNewItemNotificationType["Sound"] = 1] = "Sound";
    HxNewItemNotificationType[HxNewItemNotificationType["EmailToast"] = 2] = "EmailToast";
    HxNewItemNotificationType[HxNewItemNotificationType["VoiceMailToast"] = 4] = "VoiceMailToast";
    HxNewItemNotificationType[HxNewItemNotificationType["FaxToast"] = 8] = "FaxToast";
})(HxNewItemNotificationType = exports.HxNewItemNotificationType || (exports.HxNewItemNotificationType = {}));
function getHxNewItemNotificationTypeAsString(value) {
    return HxNewItemNotificationType[value];
}
exports.getHxNewItemNotificationTypeAsString = getHxNewItemNotificationTypeAsString;
function getHxNewItemNotificationTypeFromString(value) {
    return HxNewItemNotificationType[value];
}
exports.getHxNewItemNotificationTypeFromString = getHxNewItemNotificationTypeFromString;
/*-------------------------------------------------------------------------------
  HxFontFlagsType
-------------------------------------------------------------------------------*/
var HxFontFlagsType;
(function (HxFontFlagsType) {
    HxFontFlagsType[HxFontFlagsType["None"] = 0] = "None";
    HxFontFlagsType[HxFontFlagsType["Bold"] = 1] = "Bold";
    HxFontFlagsType[HxFontFlagsType["Italic"] = 2] = "Italic";
    HxFontFlagsType[HxFontFlagsType["Underline"] = 4] = "Underline";
})(HxFontFlagsType = exports.HxFontFlagsType || (exports.HxFontFlagsType = {}));
function getHxFontFlagsTypeAsString(value) {
    return HxFontFlagsType[value];
}
exports.getHxFontFlagsTypeAsString = getHxFontFlagsTypeAsString;
function getHxFontFlagsTypeFromString(value) {
    return HxFontFlagsType[value];
}
exports.getHxFontFlagsTypeFromString = getHxFontFlagsTypeFromString;
/*-------------------------------------------------------------------------------
  HxConversationSortOrderType
-------------------------------------------------------------------------------*/
var HxConversationSortOrderType;
(function (HxConversationSortOrderType) {
    HxConversationSortOrderType[HxConversationSortOrderType["Chronological"] = 0] = "Chronological";
    HxConversationSortOrderType[HxConversationSortOrderType["Tree"] = 1] = "Tree";
    HxConversationSortOrderType[HxConversationSortOrderType["NewestOnTop"] = 2] = "NewestOnTop";
    HxConversationSortOrderType[HxConversationSortOrderType["ChronologicalNewestOnTop"] = 3] = "ChronologicalNewestOnTop";
    HxConversationSortOrderType[HxConversationSortOrderType["NewestOnBottom"] = 4] = "NewestOnBottom";
    HxConversationSortOrderType[HxConversationSortOrderType["ChronologicalNewestOnBottom"] = 5] = "ChronologicalNewestOnBottom";
    HxConversationSortOrderType[HxConversationSortOrderType["TreeNewestOnBottom"] = 6] = "TreeNewestOnBottom";
})(HxConversationSortOrderType = exports.HxConversationSortOrderType || (exports.HxConversationSortOrderType = {}));
function getHxConversationSortOrderTypeAsString(value) {
    return HxConversationSortOrderType[value];
}
exports.getHxConversationSortOrderTypeAsString = getHxConversationSortOrderTypeAsString;
function getHxConversationSortOrderTypeFromString(value) {
    return HxConversationSortOrderType[value];
}
exports.getHxConversationSortOrderTypeFromString = getHxConversationSortOrderTypeFromString;
/*-------------------------------------------------------------------------------
  HxAfterMoveOrDeleteBehaviorType
-------------------------------------------------------------------------------*/
var HxAfterMoveOrDeleteBehaviorType;
(function (HxAfterMoveOrDeleteBehaviorType) {
    HxAfterMoveOrDeleteBehaviorType[HxAfterMoveOrDeleteBehaviorType["OpenPreviousItem"] = 0] = "OpenPreviousItem";
    HxAfterMoveOrDeleteBehaviorType[HxAfterMoveOrDeleteBehaviorType["OpenNextItem"] = 1] = "OpenNextItem";
    HxAfterMoveOrDeleteBehaviorType[HxAfterMoveOrDeleteBehaviorType["ReturnToView"] = 2] = "ReturnToView";
})(HxAfterMoveOrDeleteBehaviorType = exports.HxAfterMoveOrDeleteBehaviorType || (exports.HxAfterMoveOrDeleteBehaviorType = {}));
function getHxAfterMoveOrDeleteBehaviorTypeAsString(value) {
    return HxAfterMoveOrDeleteBehaviorType[value];
}
exports.getHxAfterMoveOrDeleteBehaviorTypeAsString = getHxAfterMoveOrDeleteBehaviorTypeAsString;
function getHxAfterMoveOrDeleteBehaviorTypeFromString(value) {
    return HxAfterMoveOrDeleteBehaviorType[value];
}
exports.getHxAfterMoveOrDeleteBehaviorTypeFromString = getHxAfterMoveOrDeleteBehaviorTypeFromString;
/*-------------------------------------------------------------------------------
  HxDaysOfWeekType
-------------------------------------------------------------------------------*/
var HxDaysOfWeekType;
(function (HxDaysOfWeekType) {
    HxDaysOfWeekType[HxDaysOfWeekType["None"] = 0] = "None";
    HxDaysOfWeekType[HxDaysOfWeekType["Sunday"] = 1] = "Sunday";
    HxDaysOfWeekType[HxDaysOfWeekType["Monday"] = 2] = "Monday";
    HxDaysOfWeekType[HxDaysOfWeekType["Tuesday"] = 4] = "Tuesday";
    HxDaysOfWeekType[HxDaysOfWeekType["Wednesday"] = 8] = "Wednesday";
    HxDaysOfWeekType[HxDaysOfWeekType["Thursday"] = 16] = "Thursday";
    HxDaysOfWeekType[HxDaysOfWeekType["Friday"] = 32] = "Friday";
    HxDaysOfWeekType[HxDaysOfWeekType["Weekdays"] = 62] = "Weekdays";
    HxDaysOfWeekType[HxDaysOfWeekType["Saturday"] = 64] = "Saturday";
    HxDaysOfWeekType[HxDaysOfWeekType["WeekendDays"] = 65] = "WeekendDays";
    HxDaysOfWeekType[HxDaysOfWeekType["AllDays"] = 127] = "AllDays";
})(HxDaysOfWeekType = exports.HxDaysOfWeekType || (exports.HxDaysOfWeekType = {}));
function getHxDaysOfWeekTypeAsString(value) {
    return HxDaysOfWeekType[value];
}
exports.getHxDaysOfWeekTypeAsString = getHxDaysOfWeekTypeAsString;
function getHxDaysOfWeekTypeFromString(value) {
    return HxDaysOfWeekType[value];
}
exports.getHxDaysOfWeekTypeFromString = getHxDaysOfWeekTypeFromString;
/*-------------------------------------------------------------------------------
  HxLocalEventsEnabledType
-------------------------------------------------------------------------------*/
var HxLocalEventsEnabledType;
(function (HxLocalEventsEnabledType) {
    HxLocalEventsEnabledType[HxLocalEventsEnabledType["FirstRun"] = 0] = "FirstRun";
    HxLocalEventsEnabledType[HxLocalEventsEnabledType["Disabled"] = 1] = "Disabled";
    HxLocalEventsEnabledType[HxLocalEventsEnabledType["Enabled"] = 2] = "Enabled";
})(HxLocalEventsEnabledType = exports.HxLocalEventsEnabledType || (exports.HxLocalEventsEnabledType = {}));
function getHxLocalEventsEnabledTypeAsString(value) {
    return HxLocalEventsEnabledType[value];
}
exports.getHxLocalEventsEnabledTypeAsString = getHxLocalEventsEnabledTypeAsString;
function getHxLocalEventsEnabledTypeFromString(value) {
    return HxLocalEventsEnabledType[value];
}
exports.getHxLocalEventsEnabledTypeFromString = getHxLocalEventsEnabledTypeFromString;
/*-------------------------------------------------------------------------------
  HxTimeIncrementType
-------------------------------------------------------------------------------*/
var HxTimeIncrementType;
(function (HxTimeIncrementType) {
    HxTimeIncrementType[HxTimeIncrementType["FifteenMinutes"] = 15] = "FifteenMinutes";
    HxTimeIncrementType[HxTimeIncrementType["ThirtyMinutes"] = 30] = "ThirtyMinutes";
})(HxTimeIncrementType = exports.HxTimeIncrementType || (exports.HxTimeIncrementType = {}));
function getHxTimeIncrementTypeAsString(value) {
    return HxTimeIncrementType[value];
}
exports.getHxTimeIncrementTypeAsString = getHxTimeIncrementTypeAsString;
function getHxTimeIncrementTypeFromString(value) {
    return HxTimeIncrementType[value];
}
exports.getHxTimeIncrementTypeFromString = getHxTimeIncrementTypeFromString;
/*-------------------------------------------------------------------------------
  HxPreviewMarkAsReadBehaviorType
-------------------------------------------------------------------------------*/
var HxPreviewMarkAsReadBehaviorType;
(function (HxPreviewMarkAsReadBehaviorType) {
    HxPreviewMarkAsReadBehaviorType[HxPreviewMarkAsReadBehaviorType["Delayed"] = 0] = "Delayed";
    HxPreviewMarkAsReadBehaviorType[HxPreviewMarkAsReadBehaviorType["OnSelectionChange"] = 1] = "OnSelectionChange";
    HxPreviewMarkAsReadBehaviorType[HxPreviewMarkAsReadBehaviorType["Never"] = 2] = "Never";
})(HxPreviewMarkAsReadBehaviorType = exports.HxPreviewMarkAsReadBehaviorType || (exports.HxPreviewMarkAsReadBehaviorType = {}));
function getHxPreviewMarkAsReadBehaviorTypeAsString(value) {
    return HxPreviewMarkAsReadBehaviorType[value];
}
exports.getHxPreviewMarkAsReadBehaviorTypeAsString = getHxPreviewMarkAsReadBehaviorTypeAsString;
function getHxPreviewMarkAsReadBehaviorTypeFromString(value) {
    return HxPreviewMarkAsReadBehaviorType[value];
}
exports.getHxPreviewMarkAsReadBehaviorTypeFromString = getHxPreviewMarkAsReadBehaviorTypeFromString;
/*-------------------------------------------------------------------------------
  HxReadReceiptResponseType
-------------------------------------------------------------------------------*/
var HxReadReceiptResponseType;
(function (HxReadReceiptResponseType) {
    HxReadReceiptResponseType[HxReadReceiptResponseType["DoNotAutomaticallySend"] = 0] = "DoNotAutomaticallySend";
    HxReadReceiptResponseType[HxReadReceiptResponseType["AlwaysSend"] = 1] = "AlwaysSend";
    HxReadReceiptResponseType[HxReadReceiptResponseType["NeverSend"] = 2] = "NeverSend";
})(HxReadReceiptResponseType = exports.HxReadReceiptResponseType || (exports.HxReadReceiptResponseType = {}));
function getHxReadReceiptResponseTypeAsString(value) {
    return HxReadReceiptResponseType[value];
}
exports.getHxReadReceiptResponseTypeAsString = getHxReadReceiptResponseTypeAsString;
function getHxReadReceiptResponseTypeFromString(value) {
    return HxReadReceiptResponseType[value];
}
exports.getHxReadReceiptResponseTypeFromString = getHxReadReceiptResponseTypeFromString;
/*-------------------------------------------------------------------------------
  HxMailFormatType
-------------------------------------------------------------------------------*/
var HxMailFormatType;
(function (HxMailFormatType) {
    HxMailFormatType[HxMailFormatType["Html"] = 0] = "Html";
    HxMailFormatType[HxMailFormatType["PlainText"] = 1] = "PlainText";
})(HxMailFormatType = exports.HxMailFormatType || (exports.HxMailFormatType = {}));
function getHxMailFormatTypeAsString(value) {
    return HxMailFormatType[value];
}
exports.getHxMailFormatTypeAsString = getHxMailFormatTypeAsString;
function getHxMailFormatTypeFromString(value) {
    return HxMailFormatType[value];
}
exports.getHxMailFormatTypeFromString = getHxMailFormatTypeFromString;
/*-------------------------------------------------------------------------------
  HxEmailComposeModeType
-------------------------------------------------------------------------------*/
var HxEmailComposeModeType;
(function (HxEmailComposeModeType) {
    HxEmailComposeModeType[HxEmailComposeModeType["Inline"] = 0] = "Inline";
    HxEmailComposeModeType[HxEmailComposeModeType["SeparateForm"] = 1] = "SeparateForm";
})(HxEmailComposeModeType = exports.HxEmailComposeModeType || (exports.HxEmailComposeModeType = {}));
function getHxEmailComposeModeTypeAsString(value) {
    return HxEmailComposeModeType[value];
}
exports.getHxEmailComposeModeTypeAsString = getHxEmailComposeModeTypeAsString;
function getHxEmailComposeModeTypeFromString(value) {
    return HxEmailComposeModeType[value];
}
exports.getHxEmailComposeModeTypeFromString = getHxEmailComposeModeTypeFromString;
/*-------------------------------------------------------------------------------
  HxAutoReplyStateType
-------------------------------------------------------------------------------*/
var HxAutoReplyStateType;
(function (HxAutoReplyStateType) {
    HxAutoReplyStateType[HxAutoReplyStateType["Disabled"] = 0] = "Disabled";
    HxAutoReplyStateType[HxAutoReplyStateType["Enabled"] = 1] = "Enabled";
    HxAutoReplyStateType[HxAutoReplyStateType["Scheduled"] = 2] = "Scheduled";
})(HxAutoReplyStateType = exports.HxAutoReplyStateType || (exports.HxAutoReplyStateType = {}));
function getHxAutoReplyStateTypeAsString(value) {
    return HxAutoReplyStateType[value];
}
exports.getHxAutoReplyStateTypeAsString = getHxAutoReplyStateTypeAsString;
function getHxAutoReplyStateTypeFromString(value) {
    return HxAutoReplyStateType[value];
}
exports.getHxAutoReplyStateTypeFromString = getHxAutoReplyStateTypeFromString;
/*-------------------------------------------------------------------------------
  HxExternalAudienceType
-------------------------------------------------------------------------------*/
var HxExternalAudienceType;
(function (HxExternalAudienceType) {
    HxExternalAudienceType[HxExternalAudienceType["None"] = 0] = "None";
    HxExternalAudienceType[HxExternalAudienceType["Known"] = 1] = "Known";
    HxExternalAudienceType[HxExternalAudienceType["All"] = 2] = "All";
})(HxExternalAudienceType = exports.HxExternalAudienceType || (exports.HxExternalAudienceType = {}));
function getHxExternalAudienceTypeAsString(value) {
    return HxExternalAudienceType[value];
}
exports.getHxExternalAudienceTypeAsString = getHxExternalAudienceTypeAsString;
function getHxExternalAudienceTypeFromString(value) {
    return HxExternalAudienceType[value];
}
exports.getHxExternalAudienceTypeFromString = getHxExternalAudienceTypeFromString;
